import reproc1 from "@/assets/reprocessing/r1.jpg.asset.json";
import reproc2 from "@/assets/reprocessing/r2.jpg.asset.json";
import reproc3 from "@/assets/reprocessing/r3.jpg.asset.json";
import reproc4 from "@/assets/reprocessing/r4.jpg.asset.json";
import reproc5 from "@/assets/reprocessing/r5.jpg.asset.json";
import reproc6 from "@/assets/reprocessing/r6.jpg.asset.json";
import reproc7 from "@/assets/reprocessing/r7.jpg.asset.json";
import reproc8 from "@/assets/reprocessing/r8.jpg.asset.json";
import reproc9 from "@/assets/reprocessing/reprocessamento-9.jpg.asset.json";
import reproc10 from "@/assets/reprocessing/reprocessamento-10.jpg.asset.json";
import reproc11 from "@/assets/reprocessing/reprocessamento-11.jpg.asset.json";
import reproc12 from "@/assets/reprocessing/reprocessamento-12.jpg.asset.json";
import reproc13 from "@/assets/reprocessing/reprocessamento-13.jpg.asset.json";
import reproc14 from "@/assets/reprocessing/reprocessamento-14.jpg.asset.json";
import reproc15 from "@/assets/reprocessing/reprocessamento-15.jpg.asset.json";
import reproc16 from "@/assets/reprocessing/reprocessamento-16.jpg.asset.json";
import reproc17 from "@/assets/reprocessing/reprocessamento-17.jpg.asset.json";
import reproc18 from "@/assets/reprocessing/reprocessamento-18.jpg.asset.json";
import reincarnateFilm from "@/assets/reincarnate-project-4.mp4.asset.json";
import reincarnatePoster from "@/assets/reincarnate-project-4-poster.jpg.asset.json";
import reincarnate1 from "@/assets/reincarnate-project-1.mp4.asset.json";
import reincarnate1Poster from "@/assets/reincarnate-project-1-poster.webp.asset.json";
import reincarnate2 from "@/assets/reincarnate-project-2.mp4.asset.json";
import reincarnate2Poster from "@/assets/reincarnate-project-2-poster.webp.asset.json";
import madnessCover from "@/assets/madness-capa-sirene.jpg.asset.json";
import bodySound from "@/assets/body-sound-module.webp.asset.json";
import esuRitual from "@/assets/esu-ritual-performance.webp.asset.json";
import weightOfFeeling from "@/assets/the-weight-of-feeling.webp.asset.json";
import apopheniaPareidolia from "@/assets/apophenia-pareidolia.png.asset.json";
import weightOfFeelingPlate from "@/assets/the-weight-of-feeling-plate.webp.asset.json";
import wofRopeHands from "@/assets/weight-of-feeling-42-2.jpg.asset.json";
import wofWaistRopes from "@/assets/weight-of-feeling-38-2.jpg.asset.json";
import wofSeatedChain from "@/assets/weight-of-feeling-71-2.jpg.asset.json";
import wofChainOverhead from "@/assets/weight-of-feeling-77-2.jpg.asset.json";
import wofReclinedChains from "@/assets/weight-of-feeling-107_1-2.jpg.asset.json";
import wofEyesClosedChain from "@/assets/weight-of-feeling-108-2.jpg.asset.json";
import wofNeckChains from "@/assets/weight-of-feeling-112_1-2.jpg.asset.json";
import wofRopesFace from "@/assets/weight-of-feeling-124_1-2.jpg.asset.json";
import memoriaFeto from "@/assets/memoria-feto-performance.webp.asset.json";
import lacunaTattooChest from "@/assets/lacuna-tattoo-chest.webp.asset.json";
import lacunaTattooHeadlamp from "@/assets/lacuna-tattoo-headlamp.webp.asset.json";
import lacunaStudioBw from "@/assets/lacuna-studio-bw.webp.asset.json";
import lacunaDaggerPendant from "@/assets/lacuna-dagger-pendant.webp.asset.json";
import lacunaMirrorForearm from "@/assets/lacuna-mirror-forearm.webp.asset.json";
import lacunaHammockFace from "@/assets/lacuna-hammock-face.webp.asset.json";

export type ProjectImage = { src: string; alt: string };

/** `file` plays a clip stored with the site, whose address is held in `id`. */
export type ProjectVideo = { provider: "vimeo" | "youtube" | "file"; id: string; poster?: string };

export type Project = {
  slug: string;
  title: string;
  year: string;
  lead: string;
  body: string[];
  cover: string;
  images: ProjectImage[];
  videos: ProjectVideo[];
};

export const projects: Project[] = [
  {
    "slug": "reprocessing",
    "title": "Reprocessing — Bodies, Ruins and Permanences",
    "year": "2011–2014",
    "lead": "Photographs and videos from early works, revisited.",
    "body": [],
    "cover": reproc2.url,
    "images": [
      { "src": reproc1.url, "alt": "Woman with tears of black makeup, in warm red light, looking to the side." },
      { "src": reproc2.url, "alt": "Woman in a light slip dress seen from behind, leaning on a window facing a building." },
      { "src": reproc3.url, "alt": "Woman in a lace dress lying face-down on the floor in front of a round mirror." },
      { "src": reproc4.url, "alt": "Person in black kneeling under a tree, covering the face with red fabric." },
      { "src": reproc5.url, "alt": "Woman with long hair in a green coat in front of a closed metal shutter at night." },
      { "src": reproc6.url, "alt": "The Gas Mask Girl — child in a gas mask holding flowers in a workshop." },
      { "src": reproc7.url, "alt": "Bare legs lying on the floor at the threshold of an old wooden door." },
      { "src": reproc8.url, "alt": "Woman in black reaching up to a gilded mirror on a pale blue wall." },
      { "src": reproc9.url, "alt": "Woman's face veiled in dark mesh, head bowed with closed eyes, dried flowers against dim warm light." },
      { "src": reproc10.url, "alt": "Woman in a white lace dress bent forward on a wooden chair on a tree-lined street, balancing a tray and a glass of milk on her back while her hair falls to the ground." },
      { "src": reproc11.url, "alt": "Woman in a long red gown walking away through an open doorway in a weathered hallway with peeling paint." },
      { "src": reproc12.url, "alt": "Woman in a purple dress standing with her face covered among several figures of herself lying motionless on the floor of an abandoned industrial building." },
      { "src": reproc13.url, "alt": "Woman in a dark red shirt gripping the handlebar of a weathered carnival ride cart in a dim storage building, beside a motion-blurred shot of the ride's clown-faced front car." },
      { "src": reproc14.url, "alt": "Red-haired woman crouching with her hands at her feet inside a dark industrial factory beside massive vintage machinery, lit by dim window light." },
      { "src": reproc15.url, "alt": "Bare legs of a standing person with scraped, bleeding knees and a dangling rosary cross, against a peeling white wall." },
      { "src": reproc16.url, "alt": "Woman in a black lace bra reclining with her head tilted back and a hand resting on her chest, against a pitch-black background." },
      { "src": reproc17.url, "alt": "Silhouetted figure running down the aisle of an abandoned, decaying train car, framed by a rusty doorway." },
      { "src": reproc18.url, "alt": "Close-up of a person's hands loosely resting at the waist over a voluminous pleated black garment, in a dim interior." }
    ],
    "videos": [
      { provider: "file", id: reincarnate1.url, poster: reincarnate1Poster.url },
      { provider: "file", id: reincarnate2.url, poster: reincarnate2Poster.url },
      { provider: "file", id: reincarnateFilm.url, poster: reincarnatePoster.url }
    ]
  },
  {
    "slug": "what-is-madness",
    "title": "What Is Madness?",
    "year": "2025",
    "lead": "Four works that read what weighs on mental health in each place in the world and translate it into image, light and sound.",
    "body": [
      "Four works that read what weighs on mental health in each place in the world and translate it into image, light and sound."
    ],
    "cover": madnessCover.url,
    "images": [],
    "videos": []
  },
  {
    "slug": "body-sound",
    "title": "Body Sound",
    "year": "2026",
    "lead": "A wearable sound module shaped to the back of the body: an articulated metal frame with tensioned strings that turns posture, breath and movement into vibration.",
    "body": [
      "Body Sound investigates the body as a resonant instrument. The structure follows the curvature of the spine and ribs, so every gesture of the performer stretches or releases the strings and becomes sound."
    ],
    "cover": bodySound.url,
    "images": [
      { "src": bodySound.url, "alt": "Body Sound — 3D model of the wearable back module, articulated metal frame with strings" }
    ],
    "videos": []
  },
  {
    "slug": "selfie",
    "title": "Self",
    "year": "2026",
    "lead": "The self does not appear as a stable unit, but as an effect emerging from relations, repetitions, and subtle ruptures. Something that continuously reorganizes itself through gestures, gazes, and almost imperceptible displacements.",
    "body": [
      "Certain interventions simply make visible what usually remains diffuse: the instability between inside and outside, between presence and projection. In this field, the self appears less as an identity and more as a process in circulation, always on the verge of transformation."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0496c396-9de0-4958-b0bc-2102e20783c5/Self-Luiza-jesus-Prado.png",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/25797c8b-6858-4e58-8512-42357807d06c/Self-2-Luiza-jesus-Prado.jpg",
        "alt": "Close-up of a fish head on a fishing lure, against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/29a06e6f-8213-4542-a790-941db0f3ab11/WhatsApp+Image+2026-02-11+at+14.04.48+%285%29.jpeg",
        "alt": "A large, irregularly shaped geological specimen with chains hanging from it, mounted on a round, reflective black surface. The reflection shows windows and parts of a building outside."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a3a60eab-c74f-492a-9211-5c880bf13e84/WhatsApp+Image+2026-02-11+at+14.04.48+%281%29.jpeg",
        "alt": "A black oval mirror on a white wall reflecting a room with large windows, chains hanging from a piece of burnt or melted material, and some objects on a surface."
      }
    ],
    "videos": []
  },
  {
    "slug": "camara-obscura",
    "title": "Camara Obscura",
    "year": "2023—",
    "lead": "The experimental project research The Camara Obscura - Decoding and Reprocessing of Memories is part of transdisciplinary research, involving photography, noise, physics, semiotics, neuroscience and psychology, on the rescue of memories through photography and its decoding.",
    "body": [
      "Photographic image methods – and the image itself – play an important role in therapeutic applications in trauma, such as those used in the EMDR technique (Desensitization and reprocessing through eye movements), or those used in Psychodrama techniques or in cognitive and neurological disorders of patients, such as psychotics, whose outbreaks suggest the cause and association of brain damage and chronicity involving memory loss, regardless of the patient’s neuroplasticity, thus considering more serious cases such as Alzheimer’s disease.",
      "Analyzing the temporality of memory through photography as a method of documenting memories and consequently a desensitizing act because memory, despite being documented, can be subjective and questionable, it is possible to consider the decoding of photography a projection of the mathematical logical linearity of primitive communication, being an evolution of the noise uttered in a primate communication that proceeds the gesture (the performance - characterizing in art) and consequently the image, a technical evolution or the coding of the image.",
      "This project proposes experiments on desensitizing processes using photographs and installations that suggest the recovery of memories. These installations are based on the assumption that communication is intuitive and if we go back to the primitivism of communication, starting from gestures (performance) and noise/symbols (decoding of the documentary photographic image) we can arrive at basic principles of human memory, thus including a dialogue more simplified within pathologies and disorders associated with memory loss, therefore, the development of this research is mainly a parallel alternative, using photography in psychiatric, psychological and neurological treatments.",
      "This proposal aims to investigate and artistically translate the experience of memory loss by interviewing individuals with partially lost memories, as well as friends or family members of people who have experienced total memory loss. The goal is to narrate and visualize the stories related to these losses through photography, sound, and immersive installation. Participants will be divided into two specific groups:",
      "1. **Volunteers willing to share personal stories of trauma**, which will serve as a basis for a photographic desensitization process using self-portraiture;"
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2ae2002e-6f69-4e60-b40f-323e0783409e/Exposi%C3%A7%C3%A3o_interativa_luiza_prado.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/eb99ea24-5537-4e12-9c0e-8fb5b93c385b/fotografia_luiza_prado.jpg",
        "alt": "Framed black and white abstract art with a blurred photo of a person's face with glasses, hung on a plain white wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1df9b420-5fce-46ff-a60a-6d72e2eb730b/imagem_decompilada_luiza_prado.jpg",
        "alt": "Framed digital document or code displayed on a wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/281ff171-7f03-4b5a-8790-05bd19db6b40/decodificado_luiza_prado.jpg",
        "alt": "A person wearing white headphones looking at a framed computer code on a white wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b2225f05-24d4-42c4-86b3-65e4732e32bc/camara_obscura_luiza_prado.png",
        "alt": "Technical drawing of an electrical box with detailed measurements and assembly instructions, including views of the box's top, front, and side perspectives."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c8033167-7205-453d-a943-7ea5ac662862/camara_obscura_luiza_prado.png",
        "alt": "Technical drawing showing wooden box parts with different views, including an exploded view, front, and side perspectives, labeled in Portuguese."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/85cb9f52-b706-4310-b3cd-e6865a442f56/Camara-Obscur-hifa-cybe-luiza-prado-projeto-1.png",
        "alt": "Technical diagram of an electrical box with parts labeled in Portuguese, showing different views and components including a removable cover, brackets, and structure specifications."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/50596271-8c46-4488-b949-4b90ac85764c/black_box_luiza_prado.jpg",
        "alt": "A black wooden box with a silver handle, sitting on a concrete floor near a window with a cityscape view."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/723011ff-0f95-4e8d-bca8-15b1725d7798/camara_obscura_luiza_prado.jpg",
        "alt": "A dark, empty room with a reflective floor and a ceiling filled with evenly spaced bright white lights."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b2aed8ff-1306-483d-9fad-7f1f2457f11d/caixa-preta.jpg",
        "alt": "A transparent glass display case on a textured gray pedestal against a black background."
      }
    ],
    "videos": []
  },
  {
    "slug": "ecologies-of-perception",
    "title": "Ecologies of Perception",
    "year": "2024",
    "lead": "Visual Psilocybin Therapy is a project about the visual effects of psilocybin and its therapeutic power.Psilocybin is an alkaloid found in fungi of the genus Psilocybe sp. and it works by mimicking the effects of serotonin and occurs in the attainment of altered states of consciousness in the search for the divine and self-knowledge.",
    "body": [
      "Currently, spiritualists and scientists have been studying in psilocybin an experience on the deepest areas of the psyche, never reached in ordinary states of consciousness. Promising studies report the therapeutic potential of psilocybin in the treatment of refractory depression and other disorders of the mind and show a great relationship with conventional neuropharmacology – psilocybin is capable of performing changes in nerve conductions, opening a spectrum of possibilities in psychedelic-assisted psychotherapy. What was once just spirituality, today, is allied to science.",
      "The visual effects of psilocybin include profound perceptual-cognitive changes such as visual and sensory hallucinations, auditory distortions, synesthesia, well-being, ego death (complete loss of subjective sense of identity) and suggest learnings as the entheogen acts as a psychic guide. This project suggests that we can expand the cognitive studies of psilocybin, reproducing the visual effects and creating visual, sensory and auditory neurostimuli, based on applied studies, which suggest an alteration of consciousness as a therapeutic end.With the increasing and popularization of treatment against depression and anxiety, technology becomes a tool in the creation of alternative therapies in order to minimize the effects caused by such diseases, and can create a safe place for a creative journey in your self-knowledge.",
      "Psilocybin Visual and Sensory Therapy emerged from a self-experiment, as a patient (autistic and highly qualified) using different types of magic mushrooms in different quantities. During these experiments I recorded my reactions and also created a diary as the process progressed.",
      "In the photo below, the painting made during this process, below some making off videos recorded during the paintings and finally the diaries in 3 languages ​​(Portuguese, Spanish and English)",
      "This experiment is developed using some sensory topics. The idea is a complete immersion in all senses, inducing an alternation of consciousness."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3c1dd2c1-f774-471e-8b5c-b849b5694659/marina_sabina.jpeg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6ad8db99-dcc0-450f-8599-cb3be19cf2f2/psilocibina_painting_luiza_prado.png",
        "alt": "Abstract colorful painting featuring a snake, a large eye, and vibrant shapes and patterns."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ebe08f86-d87a-4775-a548-83131060bbd0/painting-luiza-prado.jpg",
        "alt": "A colorful abstract painting with swirling shapes, a large dark circle, and fantastical creatures, hanging on a wall. Below the painting, various colorful fabric art pieces and a fabric sculpture rese"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9094cd62-7978-49f0-b1ef-b0658ab31da0/mutualism_luiza_prado_guilherme_todorov.png",
        "alt": "Psilocybin Visual and Sensory Therapy"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6b5450f2-d1c8-487b-9a31-484ee984e944/luiza_prado_psilocibina_collage.png",
        "alt": "Surreal digital artwork of a cosmic landscape with mountains, moons, and planets. Large mushrooms tower over a decorated tablecloth-covered surface with various smaller mushrooms and abstract shapes, "
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/80602c4c-b52f-439b-8336-360446fc2829/banquete_alquimico_luiza_prado.png",
        "alt": "A glowing, misty blue table with an underwater scene featuring fish and a plant centerpiece, illuminated by blue light."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e828862e-9537-4b8f-94a8-a3b49e5bbb49/banquete_alquimico_luiza_prado.png",
        "alt": "A cake decorated with chocolate mushrooms and topped with glass-like candles, surrounded by blue glowing leaves."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ba3efd1c-6298-4331-b92e-5fd3649310f6/banquete_alquimico_luiza_prado.png",
        "alt": "A scene of archaeological excavation with scattered shells and artifacts on sandy ground illuminated by blue and orange lighting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4ae49111-e763-4259-969e-3faadf0f71d3/banquete_alquimico_luiza_prado.png",
        "alt": "Deconstructed gourmet dessert with ice cream, caramelized toppings, and chocolate garnishes on a rock with smoky blue mist in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/21eed6ed-8795-43d0-a1b2-2d59b867011d/banquete_alquimico_luiza_prado.png",
        "alt": "A science experiment setup with colorful glowing liquids in beakers and glasses, emitting smoke and illuminated by blue, purple, and orange LED lights on a table."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ce7a72c6-fab0-47fc-87b5-81689b8b0ca4/banquete_alquimico_luiza_prado.png",
        "alt": "Luminous artificial mushrooms and decorative glass orbs on a science-themed display with glowing and fog effects."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c26a93fc-2a72-4a8d-b1a0-e8b0ec449c95/banquete-alquimico-hifa-cybe-1.png",
        "alt": "Elegant dining table set with a central decorative display of flowers, branches, and candles. The table surface is covered with crushed ice and scattered flower petals, illuminated by blue lighting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f95735e5-401c-41c3-bf83-096ed7e04726/banquete_alquimico_luiza_prado.png",
        "alt": "A night scene with a table illuminated by blue lighting, featuring glasses, bowls, and a tray of glowing orange cubes, suggesting a stylish or modern setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/19099460-ee1e-445c-a114-252913cb233a/mutualism_luiza_prado_guilherme_todorov.png",
        "alt": "Psilocybin Visual and Sensory Therapy"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a9a00812-d82d-4bce-be15-3dd5de19cef2/mutualism_luiza_prado_guilherme_todorov.png",
        "alt": "Psilocybin Visual and Sensory Therapy"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a78cd07e-cf02-4ec3-9705-dafc73e3c688/psilocibina_luiza_prado.jpg",
        "alt": "Room with a window covered by a dark curtain, colorful projected light patterns on the ceiling, and reflective metallic fabric on the floor creating an abstract, futuristic ambiance."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/335e69e9-5b36-49eb-81cc-ab1db30c4bfb/psilocibina_luiza_prado.jpg",
        "alt": "Dark room with a ceiling projection creating swirling light patterns on the walls and ceiling, with some objects, possibly structures or art installations, on the floor reflecting light."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4d53d1a2-a389-4269-8a9f-850245ec4926/psilocibina_luiza_prado.jpg",
        "alt": "Dark room with reflective metallic crumpled foil surfaces on the floor and walls, illuminated by purple and yellow lights, creating a futuristic, abstract space."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a94e719f-03e8-4959-a76b-8e92c9994dbc/psilocibina_luiza_prado.jpg",
        "alt": "Black and white photo of two people in a room with decorative lighting on the wall and a large window showing a cityscape at night."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/662f20c4-1f21-44ac-a90d-fb23903692cb/psilocibina_luiza_prado.jpg",
        "alt": "Two people sitting on the floor in an art gallery with a projection of abstract light patterns on the wall behind them."
      }
    ],
    "videos": [
      {
        "provider": "youtube",
        "id": "0tX9FMDvkac"
      },
      {
        "provider": "youtube",
        "id": "T5ZTLmBPwp4"
      },
      {
        "provider": "youtube",
        "id": "CrPBSSo6T9k"
      }
    ]
  },
  {
    "slug": "appropriation",
    "title": "Appropriation",
    "year": "2023—",
    "lead": "The project investigates the symbols of sexuality in art and entertainment, revealing dynamics of power, marginalization, and resistance. It explores the symbolic language of prostitution, eroticism, fetish, BDSM, and other subversive themes that permeate sexuality and its social and economic impact.",
    "body": [
      "This project examines the use of these symbols both in the realms of art and entertainment, while also highlighting the concurrent marginalization of sex workers. Through the analysis of cultural representations, it seeks to understand how sexuality is portrayed and symbolized across various forms of media and art, and how these representations influence public perception and the social treatment of sex workers.",
      "Sex work, in its various manifestations — prostitution, camming, striptease, pole dance, burlesque, BDSM, fetish, and the cinematic pornographic industry — inhabits a space marked by structures of power, appropriation, and subversion. These bodies that perform desire are simultaneously object and subject within a pleasure economy that reveals both the oppressive dynamics of capitalism and the potentials for autonomy and resistance.",
      "Menu: Ceviche, Sancocho, Pamonha, Café, Bolo de Fubá (pastel de harina de maíz) y Feijoada",
      "The performance proposes a reflection on the politics of marginalized bodies within sexual contexts. The body, covered by a latex bodysuit and mask, becomes an anonymous and fetishized surface where identity disappears, giving way to a territory of projection and consumption.",
      "By ingesting dishes such as feijoada, pamonha, ceviche, or sancocho, the action goes beyond the act of eating. These foods operate as symbols that condense colonial histories, subsistence economies, and cultural resistances. Their flavors, associated with contexts often labeled as “underdeveloped,” are brought into the performative space as materials of tension. The act of eating reveals the paradox between the celebration of these cultures and their simultaneous exoticization and exploitation."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a1babc15-edae-4f30-a700-0790c6af457c/pole_dancer_box_luiza_prado.png",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4c0b44c8-9a11-48fe-aec4-1cf3752873fd/FOOD_10939.jpg",
        "alt": "Appropriation"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/60715cf0-2497-4729-a8a8-8caa08ab5072/FOOD_10662.jpg",
        "alt": "Person peeling a cooked corn on the cob."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/01b4cabb-8e1a-4efb-a6d0-acbfd606f267/FOOD_10071.jpg",
        "alt": "A black bowl with corn on the cob, pieces of cooked meat, and an apple in broth."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b2fa1d0a-6233-4828-baa6-168080236470/FOOD_12488.jpg",
        "alt": "Close-up of lips with a rolled cigarette resting on the lower lip."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/477aa31d-89cc-4f01-9467-ba8e7792b7bd/FOOD_14527.jpg",
        "alt": "Person with tattooed hand eating food."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/944209c3-2709-45c3-a1a9-fe7a6759eac1/FOOD_10584.jpg",
        "alt": "Close-up of a person wearing a black helmet, with visible lips and part of face showing, against a pink background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3053fae1-cb4f-4fab-b619-6064e33cd549/FOOD_11403.jpg",
        "alt": "A person wearing a black ski mask, black leather jacket, and holding a metal fork with a gold handle, with pink background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2e9fa5db-644e-40b4-97bc-bcac9a39b3a8/FOOD_11664.jpg",
        "alt": "Person wearing a black latex mask and long-sleeved black outfit, eating food against a pink wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/40f77dee-f098-436a-8826-e0c25c89b888/FOOD_12221.jpg",
        "alt": "Person wearing a black latex mask and black latex outfit, touching their face with one hand, against a red background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/dde21af8-af94-4c98-88ee-0f651c5270d7/FOOD_10387.jpg",
        "alt": "Person wearing a black ski mask and black leather outfit, holding a fork and eating from a bowl against a pink background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/38515c31-a600-4bdc-83f8-34bd7422836e/FOOD_12649.jpg",
        "alt": "Close-up of lips with saliva and a small green pepper sticking out."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8853f3d2-9c42-477c-a7bc-47f5f4c96740/FOOD_12894.jpg",
        "alt": "Close-up of a black and white cat, partially obscured, with visible eye, nose, and whiskers."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/78a595e3-2bb3-4983-a1a2-9ade2bb427e2/FOOD_13425.jpg",
        "alt": "Close-up of a dish with cubed pink meat, sliced red onions, and green herbs in a creamy sauce."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a9ddeefa-d5b6-475a-8284-4ca4710c7c48/FOOD_14125.jpg",
        "alt": "Person wearing a black mask with reflective eye lenses and a black leather jacket, covering their face, with tattoos visible on their arm, against a red background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6de56e27-5743-4883-9987-a0477dbbdb85/FOOD_14168.jpg",
        "alt": "Person wearing black shirt holding a white mug and stirring a dark-colored liquid with a spoon."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f0140586-0cb1-4a56-89f4-1835915be797/FOOD_14272.jpg",
        "alt": "Person wearing a black mask and black clothing, holding and drinking from a gray mug, against a red background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/28a3de26-0856-4af2-aa06-6068a1868411/FOOD_14686.jpg",
        "alt": "Person holding two slices of toasted bread"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6823ac00-725c-4735-8b30-ce63728a7090/FOOD_15023.jpg",
        "alt": "Person in a black jacket and gray shirt with black face mask holding a piece of food, with their face partially visible and an eye visible, against a reddish background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9d73ff0d-077a-4cd2-b5cb-efbc112ab473/FOOD_15015.jpg",
        "alt": "Person wearing a black mask and black leather outfit, holding and eating a yellow ice cream cone against a pink background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/791b41a9-8277-4b1a-8eed-4e7237be8729/FOOD_15160.jpg",
        "alt": "A close-up of a person's hand with a tattoo, touching a black and white animal, possibly a dog or a cow."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/26ea4c80-3f82-42d2-99bf-44b71aca1a06/FOOD_15274.jpg",
        "alt": "Close-up of a person with black and gray shirt, showing their chest, chin, lips, and part of their face with a reddish background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3ede2603-3b10-4585-8ff7-2f71d22f543d/FOOD_13945.jpg",
        "alt": "Close-up of a person wearing a black hoodie and ski mask, holding a chicken with a yellow handle tool."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a2a49360-d0de-4b9c-8e66-b65d2cd7b19f/FOOD_14852.jpg",
        "alt": "Person wearing a black ski mask, holding and eating food with a red background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f6ff1683-405b-4502-b327-9d740e095607/vibrador_luiza_prado.png",
        "alt": "Pink toy gun with three pink toy grenades on a white background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9a3b4236-e3f3-4952-b552-c12474ad5be8/SnapInsta.to_466724485_18472203526010496_6250240815230024493_n.jpg.jpeg",
        "alt": "A woman with long hair, sitting on a high heel shoe, revealing tattoos on her back and thigh, with the words 'PUTA ARTISTA' in large red font."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fa5f9b45-d420-4c79-8f87-52705e2b2295/SnapInsta.to_466656409_18472203535010496_7934196260883174456_n.jpg.jpeg",
        "alt": "Bold red text repeating the words 'ARTISTE PUTA' and 'ARTISTA' on a white background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/698bcd63-82af-4136-a22c-6d1340084f0c/texture_luiza_prado.png",
        "alt": "A red and green speckled pattern with no distinct objects or scenes."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/40d90340-937b-40a9-8cd4-962bc484872d/tinder_luiza_prado_social_experiment.png",
        "alt": "Screenshots of a Tinder app profile showing images of food items: a traditional Brazilian dish with rice, beans, and orange slices; two skewers of grilled meat; and a burger with fries and a soda."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/7804d0ff-4ae5-4746-baf7-0f7586a0fab3/tinder_luiza_prado_social_experiment.jpg",
        "alt": "A screenshot of a messaging app conversation where one person messages another with a greeting and questions about their day, stopping at a message saying 'Other than being delicious'."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3ff8b968-d71b-49a8-8c70-5156e81133bd/tinder_luiza_prado_social_experiment.jpg",
        "alt": "A screenshot of a messaging app conversation with a question about the identity of the sender, asking if they are a person or a company."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3d5e7d22-8dd5-4b41-8e32-cc2167a53016/tinder_luiza_prado_social_experiment.jpg",
        "alt": "Chat conversation with a person asking about a food item. The message suggests the food looks like a corrupted bowl of food or a corrupted hamburger."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0f83e132-0e19-4260-8213-5e0a7bfc7b5f/tinder_luiza_prado_social_experiment.jpg",
        "alt": "A screenshot of a messaging app conversation with a comment saying, 'If these are your real photos, you look like Delicious :]' and a GIF icon at the bottom."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f1197cff-9414-4850-b5ae-995544ec1d1a/tinder_luiza_prado_social_experiment.jpg",
        "alt": "A screenshot of a messaging app with a conversation. The last message from a user reads, \"I couldn't decide. I'd pick both haha\". The interface shows tabs for Messages and About, with the Messages tab highlighted in red."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1ed0e39a-4277-4504-ad83-de29ba59aaab/tinder_luiza_prado_social_experiment.jpg",
        "alt": "Screenshot of a messaging app conversation with a blurred profile picture at the top, displaying messages that say: 'Nice photos. I like food 😋' and 'What is your favorite though? Vegi or burgers?'"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fa9fa67a-3c8a-4783-9b0b-73864065b969/tinder_luiza_prado_social_experiment.jpg",
        "alt": "A screenshot of a messaging app with a conversation in blue text bubbles. The person is joking about a cheeseburger, food, and the Big Bowl, possibly a restaurant or food reference."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/21be6fc6-5fb1-4aa2-93f7-a167ca2d6a6f/tinder_luiza_prado_social_experiment.jpg",
        "alt": "A messaging app screen showing a message asking, 'Are you a corrupted cook?' with a pixelated profile picture at the top left."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3a3f3f2f-38cb-4dae-a024-859225fe6d14/tinder_luiza_prado_social_experiment.jpg",
        "alt": "A screenshot of a messaging app chat window with a message asking, 'Macdonalds hired you ?' accompanied by a thinking face emoji, and a blurred profile picture of a person."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/21497641-2600-420b-a14a-88f94abfa22a/tinder_luiza_prado_social_experiment.jpg",
        "alt": "Screenshot of a messaging app chat with a message that says 'Mmm que deliciosa rs' in a blue speech bubble."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fe083633-a721-481b-95d2-9a467c2f0b3f/tinder_luiza_prado_social_experiment.jpg",
        "alt": "Screenshot of a messaging app conversation with a person sending a message in a blue chat bubble. The message says, 'Hi Luiza, I love food. And you have only pictures of food. So somehow I'm confused if this is what they call, Love at first sight. Co"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/64afd2e5-9b66-4aaf-8585-7cd00ae18d4a/tinder_luiza_prado_social_experiment.jpg",
        "alt": "A text message conversation on a mobile phone screen, with a message from a person expressing confusion and asking for guidance, mentioning love of food and sunshine."
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "1126527725"
      },
      {
        "provider": "vimeo",
        "id": "225930382"
      },
      {
        "provider": "vimeo",
        "id": "424353923"
      },
      {
        "provider": "vimeo",
        "id": "424353839"
      },
      {
        "provider": "vimeo",
        "id": "424354108"
      },
      {
        "provider": "vimeo",
        "id": "424354190"
      },
      {
        "provider": "vimeo",
        "id": "442740145"
      },
      {
        "provider": "youtube",
        "id": "sox8_Q9crog"
      }
    ]
  },
  {
    "slug": "garden-of-dreams-and-nightmares-situated-between-the-loom",
    "title": "Garden of Dreams and Nightmares",
    "year": "2024",
    "lead": "Garden of Dreams and Nightmares, Situated Between the Loom and the Harvest unfolds within the artist’s ongoing research on memory as a symbolic territory positioned between weaving and gathering. The project establishes a field of intersection between imagination, the body, and ancestry, in dialogue with Yanomami and Andean cosmologies, in which dreaming is conceived as a collective space of existence and knowledge.",
    "body": [
      "The loom operates as a metaphor for the interconnection between worlds, gestures, and experiences, while the harvest evokes the return of actions to the body and to the community. The garden becomes a hybrid environment where memory germinates and transforms, merging sensory, affective, and material dimensions.",
      "The paintings are tactile surfaces, created through layers of latex and encaustic, materials that evoke the skin and physicality of the performing body. Through this process, the artist transposes the gestures and presence of performance into the pictorial field, allowing the body to persist in the work as trace, texture, and temperature. The tactile quality also recalls collective and healing dimensions, where touch operates as both a means of connection and a site of transformation.",
      "In resonance with neuroscientific perspectives, dreaming is understood here as a process of memory consolidation and synaptic reorganization. The brain functions as a symbolic loom, weaving emotions and past experiences into narratives that combine truth, delirium, and ancestry. Within this entanglement, the garden becomes a space where memory, matter, and healing intertwine."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6e658744-6e32-4372-a2a6-84cbccf69a8b/Luiza_Prado_Expanded_Painting_with_Latex_and_Encaustic_8.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5e887b55-1796-4d89-bba0-c957b17f7758/Luiza_Prado_Expanded_Painting_with_Latex_and_Encaustic.jpg",
        "alt": "An artist's studio with a large abstract painting in reds, blacks, and oranges leaning against the wall. Various art supplies, including a red rolling cart filled with paints and brushes, a small blac"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/caac6203-71e3-424b-adec-27fdeabf9048/Luiza_Prado_Expanded_Painting_with_Latex_and_Encaustic_9.jpg",
        "alt": "Mixed media artwork featuring a rectangular canvas with abstract dark and warm-colored patterns, with melted or crumpled material hanging from the bottom."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/890180a2-550c-4858-a03c-113d2d0a7fc1/Luiza_Prado_Expanded_Painting_with_Latex_and_Encaustic_10.jpg",
        "alt": "Abstract painting with warm earthy tones of brown, gold, red, and black, with textured and swirling patterns."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6bb60e65-4787-4a0a-8154-78e5427547fe/Luiza_Prado_Expanded_Painting_with_Latex_and_Encaustic.jpg",
        "alt": "Abstract mixed media art piece with textured, dark, and metallic elements mounted on a white wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/630ceb75-fc1b-40aa-9b43-73f39b876b9d/Luiza_Prado_Expanded_Painting_with_Latex_and_Encaustic.jpg",
        "alt": "Abstract art piece with red, black, and glossy textures resembling melted plastic or organic material."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/320a0c0e-6b27-452a-8dd0-62421b8598d1/WhatsApp+Image+2026-03-15+at+11.10.25+%281%29.png",
        "alt": "Burnt and charred remains of what appears to be crumpled, burnt paper or fabric on a blackened, rusty surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/661f0224-d34c-45db-b8d5-054d1d862e6d/WhatsApp+Image+2026-03-15+at+11.10.25+%282%29.jpeg",
        "alt": "Close-up of a baked dish showing burnt cheese or sauce with darker charred spots and some lighter, creamy parts at the bottom."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2bc20f8f-5815-44b3-9a7e-fc10c129f6c7/Luiza_Prado_Expanded_Painting_with_Latex_and_Encaustic_6.jpg",
        "alt": "Close-up of burnished, melted, and partially charred plastic or metal object with irregular shapes and textures, predominantly brown and black with some yellowish areas, placed against a white surface"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1f0b7e10-f4a1-437e-809b-8db4f7ddef6a/Luiza_Prado_Expanded_Painting_with_Latex_and_Encaustic_2.jpg",
        "alt": "Close-up of an abstract, textured painting with warm earth tones, orange, brown, and yellow, featuring drips and layered paint."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/35bf98e1-2500-42ee-a93b-d54cc0bb41b3/Luiza_Prado_Expanded_Painting_with_Latex_and_Encaustic.JPG",
        "alt": "A close-up of a burnt, charred surface with melted, hardened black and orange/brown materials, possibly melted plastic or burned food."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4f24553d-9376-44a5-a4c1-c747fcb19dd5/Luiza_Prado_Expanded_Painting_with_Latex_and_Encaustic_3.jpg",
        "alt": "A crumpled and shiny piece of dark brown or black foil or plastic material on a plain white surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/48270fca-788a-4e0c-9739-842aaef244c9/Luiza_Prado_Expanded_Painting_with_Latex_and_Encaustic_7.jpg",
        "alt": "Close-up of a burned, charred object with blackened, melted, and crispy textures."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/74f57dee-7785-49aa-800d-2ae7464557a1/WhatsApp+Image+2026-03-15+at+11.10.25+%283%29.jpeg",
        "alt": "A burnt and greasy blackened baking sheet with crumpled parchment paper and remnants of a cooked or burnt food item."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e6b4d1a9-22fb-4a2c-8326-c1deee37942c/Luiza_Prado_Expanded_Painting_with_Latex_and_Encausti2.jpg",
        "alt": "Close-up of a wet, textured, and glossy animal hide with shades of brown, black, and amber."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4a1ce236-1fb9-4f61-bcf0-d443d27c9c9d/Luiza_Prado_Expanded_Painting_with_Latex_and_Encaustic_1.jpg",
        "alt": "Close-up of blackberries submerged in a red liquid, possibly juice or syrup."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9979d3cf-aff2-4dc3-8fb6-9dd415a5dffa/painting_with_chemical_laboratory_reagents_luiza_prado.jpg",
        "alt": "Abstract mixed media artwork with black background, swirling colors of purple, yellow, white, and hints of green and orange, with textured and layered paint."
      }
    ],
    "videos": []
  },
  {
    "slug": "neurotransition",
    "title": "Neurotransition",
    "year": "2022—",
    "lead": "Neurotransition — Essays about Autism and Transsexuality. A long-form visual essay on neurodivergence, gender transition and the weight of feeling: bodies that translate the world through different protocols of perception.",
    "body": [
      "The Weight of Feeling gathers photography, video and writing produced across years of self-observation, mapping autism and giftedness (AH/SD) as material for image-making rather than as deficit."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a80e5833-531f-457e-86ef-b81336e15aa8/%2840%29.JPG",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/53718df7-cdc4-4ea1-8589-5b96ae42addb/%2870%29.JPG",
        "alt": "(70).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5f35e1a6-ff02-4fbf-a95a-11286a4fe9e4/%2836%29.JPG",
        "alt": "(36).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a4484f1b-dfae-43dc-99c2-c294e448f2f2/%2878%29.JPG",
        "alt": "(78).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/de4017ea-7b94-444f-ada2-a44a1f435148/%28106%29.JPG",
        "alt": "(106).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ab2f6835-d6f8-491c-8b05-338fbe4beecb/%28108%29.JPG",
        "alt": "(108).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8bb817bc-33f6-4260-b23f-3e8160e50a58/%2842%29.JPG",
        "alt": "(42).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c4a68386-4cf8-4c71-b56c-3f5baf4f500d/%28103%29.JPG",
        "alt": "(103).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/282a1f02-4dff-4896-8fa6-0e161187912a/%2857%29.JPG",
        "alt": "(57).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/77b69a5a-d620-4c54-abb4-8b897530fe69/%2895%29.JPG",
        "alt": "(95).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/14da376a-ded1-49e7-8850-408a651584d3/%28100%29+%281%29.JPG",
        "alt": "(100) (1).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/06b80631-3c0d-4be2-abdc-39cab4ef3ade/%2899%29.JPG",
        "alt": "(99).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ccceea79-a31d-4049-ae2e-c13938404768/%28102%29.JPG",
        "alt": "(102).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5eb358ab-65fd-4a3e-983c-0fbee329d5b7/%2858%29.JPG",
        "alt": "(58).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/37986b84-9c26-42e0-97a2-d92316edfcd4/%28104%29.JPG",
        "alt": "(104).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e5eba101-4d23-4286-828a-463d4a127758/%2883%29+%281%29.JPG",
        "alt": "(83) (1).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fdf9fe9e-1fa8-4e79-9f2c-63093e2862a6/%2873%29.JPG",
        "alt": "(73).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/7be684bd-6bcb-4ce3-a109-e763712f8efe/%28107%29+%281%29.JPG",
        "alt": "(107) (1).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/7a696404-32ff-4202-8784-809dceec8199/%28112%29.JPG",
        "alt": "(112).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5fb1b782-3613-4ce9-be37-b7f1647d1dee/%2876%29.JPG",
        "alt": "(76).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/99f2db2b-20d4-4205-ab15-60ec476eaafe/%2869%29.JPG",
        "alt": "(69).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e05aa893-2201-4701-9445-277df6a1e503/%28114%29.JPG",
        "alt": "(114).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9409844d-dac8-4b1b-ad36-72fa7add030a/%28118%29.JPG",
        "alt": "(118).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/62818c3f-9ca3-4976-9539-16eb7b8a9057/%2874%29.JPG",
        "alt": "(74).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/89ce402a-edc5-4102-bf08-c04adf1b4b60/%2884%29+%281%29.JPG",
        "alt": "(84) (1).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9f7b7f97-5d0b-40ff-af6a-10703308b33d/%2883%29.JPG",
        "alt": "(83).JPG"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/faddc327-1bb2-4bde-a2bb-60fed8473f9e/%2859%29.JPG",
        "alt": "(59).JPG"
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "1178952666"
      }
    ]
  },
  {
    "slug": "butoh-caipira",
    "title": "Butoh Caipira",
    "year": "2023—",
    "lead": "In the shadows of this body, the litanies of the saints' festivals resound, the echo of the drums, the murmur of the prayers interrupted by the creaking of the canoes. His skin retains the touch of healers, his bare feet follow the rhythm of the promises paid with candles and ribbons. He carries the weight of invisible ex-votos, of memories dissolved in time.",
    "body": [
      "This research proposes a reterritorialization of butoh based on the symbolic and affective landscapes of the Brazilian countryside, especially the regions bathed by the Paraíba do Sul and Paraitinga rivers. By conceiving a \"country butoh\", we explore the possibility of a body that is inscribed not only in space, but in collective memory, in religious syncretism and in the cosmogony of land and water.",
      "Butoh, as a body language originating in post-war Japan, is marked by a deep listening to time, death, decomposition and presence. When transplanted to the depths of Brazil — where the country folk, the riverside dwellers and the backlands coexist with hybrid and ancestral religious practices —, butoh acquires its own contours. This dancing country body approaches the land not only as an aesthetic or metaphorical element, but as an ontological substrate of existence. Here, the ground is territory, food, sacred and also a threat, especially in the face of the recurrent flooding of the rivers.",
      "The research therefore proposes an unfolding of butoh as a tool for excavating memory and territory, stretching the boundaries between tradition and experimentation, between the sacred and the performative, between the individual body and the collective body of culture."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/02a13b2f-8fae-46a5-ab3d-faaf07ec6e90/pachamama-hifa+cybe.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a95a1ac0-b6bd-4582-a35d-63ae91ec9122/pachamama-2.jpg",
        "alt": "Close-up of a plant with various stems, leaves, and small flowers or buds, some with pink and purple hues."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6d1be33d-73f1-4ce8-b761-315c42d04bec/pachamama-1.jpg",
        "alt": "Close-up of a plant with a red stem and green leaves, and a close-up of tangled roots and moss."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/af660cef-9be1-43be-927e-cfed0dff96f0/pachamama-3.jpg",
        "alt": "Close-up of moss and small green plants growing on bark or wood, with a yellow flower near the bottom center of the image."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e0a11162-5395-4505-ad13-3e989240afc4/bio_art_biology_nature_luiza_prado.jpg",
        "alt": "Five different leaves with a heart-shaped cutout in each, arranged from left to right, showcasing varying colors and shapes."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5eb851eb-5272-43eb-a47e-b7933ca6aa9f/pachamama_luiza_prado.jpg",
        "alt": "A floral arrangement with various flowers, moss, and twigs arranged vertically against a white background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/879355b2-7b5b-409e-9a6d-2346540ffc22/ro%C3%A7a_luiza_prado.jpg",
        "alt": "An outdoor backyard space with a circle of stones around a small fire pit, surrounded by stacked tires and makeshift benches, with trees and bushes in the background under a partly cloudy sky."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/413afd9e-260a-4e40-b4a8-28cb9904c1f9/roa-hifa-cybe-luiza-prado-1.jpg",
        "alt": "A large fallen tree blocking a rural dirt path, surrounded by green trees and misty fog in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0f42f3fd-6f3b-4918-a49c-b041d58a80c9/roa-hifa-cybe-luiza-prado-2.jpg",
        "alt": "A person pushing a wheelbarrow filled with soil through a lush, tropical garden with banana trees at sunset."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/7f75200e-31c4-4e59-8657-c02933dd847c/roa-hifa-cybe-luiza-prado-4.jpg",
        "alt": "A silhouette of two people, one bending down and the other standing, while a shovel is used to move soil against a sunset sky with clouds."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b459425b-96e6-4f7b-b419-38636195d43a/ro%C3%A7a_luiza_prado.jpg",
        "alt": "A dirty hand with blackened fingernails, holding up three fingers against a blurred outdoor background of green grass and plants."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6ff3b258-3b61-40cc-bc29-a5f28718cb48/cartografias_butoh_luiza_prado.jpg",
        "alt": "An art installation depicting a kitchen fire scene with burnt fabric, soot, and a bowl with a wooden spoon and egg, alongside scattered cloths and wall decorations."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/99c346fb-5fd4-4659-98b8-f73726f49d96/cartografias_butoh_luiza_prado.jpg",
        "alt": "Corner of a room with plain white walls, cluttered with a mop, in a metal basin, a pile of blankets or clothes on the floor, and unorganized items. Wall decorations include three small frames and one "
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/50e3304f-a7e5-49e2-8690-807574f6f552/cartografias_butoh_luiza_prado.jpg",
        "alt": "A metal container with a smaller clay bowl inside, some ashes and burnt residue, a shovel with a wooden handle leaning against the container, and some indistinct bedding or cloth in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5bf7d0fb-8017-41ef-8b6c-ef7308073195/cartografias_butoh_luiza_prado.jpg",
        "alt": "Burned and sooty crumpled papers and fabric on a floor in a corner next to a white wall and bed."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/935e5dbd-acf1-4aa5-8b56-2f7d99a43e75/cartografias_butoh_luiza_prado.jpg",
        "alt": "A traditional oil lamp with a clay wick holder and white pebbles inside a metal basin, with a blurred background of bedding and a wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e607f6e4-57ad-4fbb-90c1-242e900b914e/assentamento_hifa_cybe_luiza_prado_2.png",
        "alt": "An art installation with various types of grains and seeds arranged in circular patterns on the floor of a gallery."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b76d2bd2-a93a-4e54-ae49-2950b6323fdc/assentamento_hifa_cybe_luiza_prado_.png",
        "alt": "Indoor art installation with black powder arranged in a curved shape on a wooden floor, against a plain white wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e1d28973-8f72-4437-978a-abf63e1b87ac/assentamento_hifa_cybe_luiza_prado_.png",
        "alt": "An art installation featuring a large pile of various natural and dark-colored materials on the floor, with hanging roots or strands on a white wall and a diagonal beam of light illuminating part of the scene."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3e62b3b9-5845-4e91-9191-8f848e2df26e/Captura+de+tela+2026-01-02+095333.png",
        "alt": "Close-up of a person's tattooed hands forming a heart shape, lying on a black surface with white lines and surrounded by a looped piece of beige rope."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d921f356-f6eb-4ab3-9bcf-5c0fa264ed46/Captura+de+tela+2026-01-02+095348.png",
        "alt": "A woman in black clothing wearing a head covering leans forward with a shovel, on a concrete floor near a pile of fabric, against a plain white wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/67b2ca41-f82f-41fe-bcee-c7c8b0b46f01/Captura+de+tela+2026-01-02+095059.png",
        "alt": "A person with long wet hair and glasses is looking down and closely inspecting or working on a surface, possibly concrete or stone, with their hand. Another hand is pointing towards the surface. There is a large round object, possibly a wooden bowl,"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5cd605d6-b945-48ad-a6a3-696ab000f30f/Captura+de+tela+2026-01-02+095325.png",
        "alt": "A woman with long dark hair is holding her head with one hand and wearing a transparent mask that covers her face, revealing her nose and mouth."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/59db62f0-e72d-4b5d-933a-1a047403845f/Captura+de+tela+2026-01-02+095216.png",
        "alt": "Person is cleaning or inspecting a large metal container with a towel, surrounded by scattered white candles on a concrete floor."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e3b6ec9a-50f3-45aa-914e-b6db845edee5/Captura+de+tela+2026-01-02+095050.png",
        "alt": "A person with long dark hair and tattoos on their fingers is kneeling on the floor with their hands on the ground. They are around a large metallic basin filled with water with a smaller, rusted bowl floating inside it. Several lit candles are scatte"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/512f8071-20d8-4ec4-b31d-35e0c0bf04e4/Captura+de+tela+2026-01-02+095230.png",
        "alt": "A woman in a black long sleeve shirt bends over on a concrete floor, with messy dark hair hanging down. There is a pile of white cloth or paper on the left and dark dirt or ash on the ground behind her."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5b956897-6d50-4803-bbf4-45749722d848/Captura+de+tela+2026-01-02+095312.png",
        "alt": "A person with long dark hair, tattoos, and septum piercing lying on the ground, with their face partially visible and hair covering part of their face."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/938a1c5d-0a12-4441-955f-98396829b74f/Captura+de+tela+2026-01-02+095246.png",
        "alt": "A woman with wet, dark, curly hair dressed in a black long-sleeve dress with a large tattoo on her chest and hand, holding a rope while sitting on a bed with white bedding in a room with white walls."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/05e4ba0f-a66a-4376-ae89-1787d5761dec/Captura+de+tela+2026-01-02+095404.png",
        "alt": "Person with long dark hair covered in black leather-like material, sitting against a plain wall, with their face partially obscured, wearing a black long-sleeve shirt."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b621315a-2237-4e27-924e-b1bcf597b1ed/Captura+de+tela+2026-01-02+095413.png",
        "alt": "Person wearing a hooded jacket with animal print pattern, holding their head with one hand, and leaning forward on a wooden stick, in a dimly lit setting with dirt on the ground."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ca51d24c-f522-4478-ad2d-b703b23c062b/Captura+de+tela+2026-01-02+095429.png",
        "alt": "Close-up of a dirty, weathered hand gripping a dark, textured surface, with a yellowish wooden stick nearby, and background elements including a black object and a textured surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/60e08bc8-5501-481b-b9af-d9a755f720f3/Captura+de+tela+2026-01-02+095441.png",
        "alt": "Close-up of a hand gripping a dark, textured object that appears to be a sculpture or piece of art, with visible cracks and patches of red and black."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/03b37923-d39b-4dd8-8b7a-cb096a0f410c/Captura+de+tela+2026-01-02+095448.png",
        "alt": "A person holding a dark, speckled bird with a long tail, sitting on a wooden bench, with visible dirt on their hands and arms."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9062a85e-799d-430b-af39-ef8d4f74520c/Captura+de+tela+2026-01-02+095510.png",
        "alt": "A person with worn, dusty hands is lighting a small white candle on a concrete surface, with a blurred background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/78265218-ad3e-462c-a409-bca36fd00634/Captura+de+tela+2026-01-02+095529.png",
        "alt": "A person touching burning candles on a concrete floor, with the focus on their dirt-covered hand and fingers."
      }
    ],
    "videos": [
      {
        "provider": "youtube",
        "id": "nVCfoBHdhok"
      }
    ]
  },
  {
    "slug": "topographies-of-violence",
    "title": "Topographies of Violence",
    "year": "2022",
    "lead": "We inhabit a cartography etched by the repetition of structural violence, violence that shapes flesh, subjectivity, and geography. The queer and dissident body, racialized, deviated, pathologized, becomes a palimpsest where power inscribes its norms and, simultaneously, where insurgencies are rewritten. It is a body that defies architectures of control: performing outside cisheteronormativity, beyond capitalist productivity, and outside the binary epistemologies of Western science.",
    "body": [
      "A stage where the protocols of pain and the noise of oppression are aestheticized as denunciation and political gesture. Within this terrain of collapse, BDSM operates as a symbolic machine: a performative language, a dramatization of consent and power, capable of distorting the lines between domination and desire, violence and care, system and failure.",
      "By engaging BDSM as a critical aesthetic, this project seeks to map the topographies of violence, where the body is marked, exposed, displaced, but also where it resists, reacts, and rebuilds itself. The restraints become diagrams of biopolitical control, yet also choreographies of possible freedom. Consensual pain stands in contrast to imposed pain. Performance becomes a sensitive cartography of a fractured world.",
      "This is an expanded reflection on mechanisms of normalization, surveillance, and exclusion imposed upon nonconforming bodies, and how those bodies, when turned into art, language, ritual, and fiction, sabotage the very systems that seek to discipline them. It is about occupying space with bodies that refuse obedience, that overflow gender, language, and function.",
      "When I was around five years old, I began to have recurring visions of a family wearing gas masks. This image would appear specifically whenever I looked toward my family’s house down the hallway. The vision of the gas mask family always seemed to coincide with moments when bad things were happening in my life. Because of this, I came to associate that image with deeply negative feelings. Experiencing these visions was painful, and I often had nightmares about this gas mask family — they robbed me of peace of mind.",
      "When I was 23, I decided to transform this haunting image into a staged photograph. After finding the models for the shoot, there was no doubt in my mind that I would give them a happy ending. I had lived for too long with the suffocating presence of this heavy-masked family and all the sorrow attached to them. The turning point came when I created and photographed The Gas Mask Girl (2012) — the image shown above. In photographing the girl wearing the gas mask, I borrowed her presence to help me process and purge the emotional weight carried by those visions."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0ddda6db-bac1-4a4d-bf4b-4898b683d717/gula_luiza_prado.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3ffed5dd-7b01-4691-b66f-44207ba2987a/sinto_muito_art_installation_luiza_prado.jpg",
        "alt": "An old typewriter with a red cloth or piece of fabric draped behind it, and the typewriter is damaged and missing parts, placed next to a box of empty typewriter ribbon spools and a small mechanical d"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/03aeef8d-c1be-450b-8206-70cfef2944ab/sinto_muito_art_installation_luiza_prado.jpg",
        "alt": "Three photographs of marble surfaces with red stains, with the middle photo having small black text that reads 'suite of 10' and a red stain dripping from the bottom."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/27b70ef7-0511-49dc-ad18-4cc1276da700/menina_da_mascara_de_gas_luiza_prado.jpg",
        "alt": "A child dressed in a dress wears a gas mask and holds a bouquet of flowers in a cluttered and gritty workshop or industrial space."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/83cb88fd-4cab-4c97-a418-d76651b1a548/frame-mockup-interior-3d-rendering.png",
        "alt": "A young child wearing a gas mask, holding a bouquet of flowers, standing in an industrial or workshop space with a cluttered background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a71a2b5b-ab08-45d8-8218-4b568de4a4e8/12140108_1233630746662937_4260025733726553663_o.jpg",
        "alt": "A woman with long dark hair and tattoos on her arm is placing a gas mask on a young girl who is holding a bouquet of flowers. The scene appears to be in a rustic or industrial setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b941d28c-5ddc-43fb-a025-2b50a9c651a7/luiza-prado-menina-da-mascara-de-gas-2+%281%29.jpg",
        "alt": "Two women, one with long curly hair and the other with long straight hair, are in a workshop or factory setting. The woman with curly hair is holding a bouquet of flowers and is wearing a dress. The w"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/21e935dd-dc45-4a67-8c40-0fa6c080160b/Imagem4.jpg",
        "alt": "Two black harnesses with adjustable straps and metal buckles hanging against a white background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1a79ad34-ef16-4bb0-9c61-09cd37a087e0/Imagem3.jpg",
        "alt": "Two black leather harnesses with straps and metal rings, shown against a plain white background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6a775db7-8f5e-4704-bc2f-8414f80ff546/the-painter-thumb-1+%281%29.jpg",
        "alt": "Topographies of Violence"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b067aa69-fde4-442d-b11e-619612b73e2e/the_painter_%282017%29_performance_art_-_hifa_cybe2853.jpg",
        "alt": "Close-up of a person wearing black shorts and a black top, sitting on a surface, with one hand resting on their thigh, shot in a minimalistic setting with shadows."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1b74db75-39bd-4481-b559-9937418515e5/the_painter_%282017%29_performance_art_-_hifa_cybe2444.jpg",
        "alt": "A person wearing black shorts and a long-sleeved black shirt is leaning on a white table or surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/03faf635-a8ee-4619-b37c-6fdec2de9e94/the_painter_%282017%29_performance_art_-_hifa_cybe1570.jpg",
        "alt": "Person wearing black gloves holding a paintbrush, leaning over a wooden easel or palette on a black background, with visible tattoos on their arm."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/72fcab85-8981-4fad-9d47-813daf9fee72/the_painter_%282017%29_performance_art_-_hifa_cybe3113.jpg",
        "alt": "A woman with tattoos, wearing black gloves and a black top, holding a wooden chair in a dark setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/97dcd47c-e6b5-45c1-bdaa-9eb38b77c7ca/the_painter_%282017%29_performance_art_-_hifa_cybe0032.jpg",
        "alt": "A person with long curly hair, wearing a black long-sleeve top, is sitting and touching a white block, with their lower body exposed, showing a tattoo on their right thigh."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6b7b99c8-7ce7-43aa-986c-3923a272bd16/the_painter_%282017%29_performance_art_-_hifa_cybe0003.jpg",
        "alt": "Close-up of a person’s side with tattoos, holding an easel with a canvas, working on a painting, against a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/34b89a71-365b-4c2a-8585-c4ae8a6739f1/interveno_corpo_estranho.jpg",
        "alt": "A sculpture of a woman with long hair, covering her face with hands, and a red cloth hanging from the sculpture's waist to the floor."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d3a49e0c-91d6-4a83-9d66-8d60a0dda471/corpo-estranho-hifa-cybe+%281%29.jpg",
        "alt": "Topographies of Violence"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/24d22b35-7b51-40fc-8e26-45218a614fb5/luiza%2Bjesus%2Bdo%2Bprado%2C%2Bhifa%2Bcybe%2C%2Bqueer%2C%2Bcorpo%2Bestranho.webp",
        "alt": "A collage of four images of a person lying on a white bed, with their head covered in red paint or blood."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/daa48c1b-eb3d-4fe1-9a34-31208be53936/gula-emilia-luiza-prado+%283%29.png",
        "alt": "A woman with short dark hair, sitting on the floor in a gritty industrial environment, with her legs spread apart and holding a knife in her right hand. She is topless, with tattoos on her chest, and has a serious expression. There is a large, partially sliced fruit on her lap, with a glowing, fiery appearance, and broccoli and other vegetables scattered around her on the floor. The background includes industrial machinery and wires, creating a dark, ominous atmosphere."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/003c23db-571f-4ac5-b305-a0179ecb76e2/Luiza-Prado-Gula-2.jpg",
        "alt": "Upside-down close-up of a person with jewelry, holding two large reddish objects near their face, with dark glossy eyes and a contemplative expression."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ad15c5e5-f8ef-421e-ad83-7cf449bd27c0/luiza%2Bprado%2Bexhibition.jpg",
        "alt": "A person with a purple jacket and dark hair in a bun looks at a painting in a gallery."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c9845795-8712-4187-ba86-00d346a22436/luiza_prado_hifa_cybe_rose_compass%2C_performance_art_shibari.jpg",
        "alt": "Close-up of a person's thigh with tattoos, tied with rope."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d5a9f7a9-f1c1-4ed3-887f-69279e404db4/luiza_prado_hifa_cybe_rose_compass_performance_art_shibari.jpg",
        "alt": "A person in athletic wear practicing aerial silks inside a gym with large windows exposing a cityscape of high-rise buildings."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0b3f7cdc-b748-4adc-baee-75d8b8f324be/luiza_prado_hifa_cybe_rose_compass_performance_art_shibari.jpg",
        "alt": "Person performing a headstand in a yoga pose on the floor, with their hair hanging downward and their hands supporting their head."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/24df6009-2d1f-4309-a09d-852b1755b99e/luiza_prado_hifa_cybe_rose_compass%2C_performance_art_shibari.jpg",
        "alt": "A person is tied with rope around their body and arms, with a tattoo visible on their shoulder, sitting near a window with blinds."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3636a1a2-e7da-451d-87a6-db94b550e878/luiza_prado_hifa_cybe_rose_compass%2C_performance_art_shibari.jpg",
        "alt": "Black and white photo of a woman with long hair looking down, with a tattoo on her arm and shoulder, standing in front of a window."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/41144580-4d22-4926-bfe3-0c13b7f4ab90/luiza_prado_hifa_cybe_rose_compass_performance_art_shibari.jpg",
        "alt": "A woman hanging upside down from a swinging rope, with her eyes closed, in a room with a plain wall and some fabric on the floor."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/542714b7-4f04-4e2a-8025-3a9d89f048d6/luiza_prado_hifa_cybe_rose_compass%2C_performance_art_shibari.jpg",
        "alt": "A woman in fishnet lingerie hanging upside down from a trapeze in a room with a wooden floor, with clothes and fabric on the floor."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3522b8e0-6a6e-43fb-bdbc-da80ad7c0beb/luiza_prado_hifa_cybe_rose_compass%2C_performance_art_shibari.jpg",
        "alt": "Black and white photo of a woman with tattoos, wearing a sheer top, tied with a knot around her waist, with long hair, looking downward."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d32be6b0-063e-4837-8efa-0166e15b8f6a/luiza_prado_hifa_cybe_rose_compass%2C_performance_art_shibari.jpg",
        "alt": "A woman in a fishnet outfit hanging upside down on aerial silks in a gym or studio."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ce71a2f6-f178-4c10-803a-20217924386c/luiza_prado_hifa_cybe_rose_compass%2C_performance_art_shibari.jpg",
        "alt": "A man and a woman practicing acrobatics in a room with large windows, with the man holding the woman upside down in a pose."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b733aa72-17c9-44f5-8e46-d802b3190e2a/luiza_prado_hifa_cybe_rose_compass%2C_performance_art_shibari.jpg",
        "alt": "A woman practicing aerial yoga or hammocking, hanging upside down with her body extended horizontally, inside a room with large windows showing a cityscape in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d018e353-6b69-4f5a-ac07-4784eb87780e/luiza_prado_hifa_cybe_rose_compass_performance_art_shibari.jpg",
        "alt": "Topographies of Violence"
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "233700623"
      },
      {
        "provider": "vimeo",
        "id": "161196586"
      },
      {
        "provider": "vimeo",
        "id": "1074762149"
      }
    ]
  },
  {
    "slug": "discourses-of-necropolitics",
    "title": "Discourses of Necropolitics",
    "year": "2021",
    "lead": "Discourses of Necropolitics investigates the mechanisms through which death, disposability, and systemic violence are normalized, aestheticized, and operationalized in contemporary society.",
    "body": [
      "Drawing from Achille Mbembe’s concept of necropolitics, the project examines how states, institutions, and media construct narratives that determine which lives are grievous, visible, or valuable.",
      "Reproductions in larger formats of biometric photographs, rehearsing the notion of identification even in the face of democratic erosion.",
      "The search for identity originates in a space of biopolitical crisis and is a direct consequence of colonization.",
      "The 13 portrayed individuals — Indigenous, African-American, and Latinx — represent the 13 stripes of the American flag, or the original 13 colonies.",
      "The “afterimage” effect in the work suggests not only a revelation of the images themselves but also a space for reflection. When the experiment is carried out and the viewer stares at the negative image for 30 seconds, the eyes attempt to continue the image on a blank surface. Physiologically, the brain and the eyes seek equilibrium, and thus the image is revealed in its positive state."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/dc762bb2-d964-4580-9a5e-831edcbdcb31/carimbe-aqui-seu-passaporte-luiza-prado-1-1200x600.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4ecd96c9-badb-4a62-a60f-903f256f1f10/brasil%2Bconteudo%2Bsensivel+luiza+prado.jpg",
        "alt": "Close-up of a white fabric with a printed laundry care symbol indicating tumble dry on low heat."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/781703c7-fa35-4a83-ab7d-ef3fc5cf9727/we_the_people_luiza_prado.jpg",
        "alt": "A series of framed photographs of a person wearing a medical mask and glasses, displayed on a white gallery wall. A music stand is positioned in front of the photos."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3eb43e5e-b768-43d8-96c1-2206e9255c5b/we_the_people_luiza_prado.jpg",
        "alt": "A series of individuals with red blindfolds covering their eyes, shown in a row. The image focuses on their upper bodies and faces, with varied skin tones and hair types."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/14c8f277-6fd2-4f65-9ca3-d18d383fa20c/we_the_people_luiza_prado.jpg",
        "alt": "A row of individuals wearing full personal protective equipment including face masks, goggles, and protective suits."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c9086c40-71b4-4b59-9eb5-88eaae24a487/Imagem10.jpg",
        "alt": "A collage of fifteen people wearing virtual reality goggles with different hairstyles and facial expressions, against a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/abc00383-b327-4de7-bcb4-577d152d7a87/latina-luiza-prado.jpg",
        "alt": "Discourses of Necropolitics"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f68051c8-9b14-4f48-903b-2537f9638db5/resistencia-luiza-prado-6.jpg",
        "alt": "Back view of a person with large tattoo of a tree spanning from the shoulders to the lower back and red lightning bolt designs on the back."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d8e3f0fe-b6fc-43de-ad54-c90d99183875/hifa+cybe+resistencia.jpg",
        "alt": "Watercolor painting of a woman's face in profile, with soft facial features and flowing hair."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/65af8c97-b1ed-4fdd-85af-106c3c36e237/resistencia-luiza-prado-4.jpg",
        "alt": "Person with long dark hair and septum piercing, looking through a small round hole in a piece of wood."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4e99af85-68c5-4cd0-8e96-67140ae15be1/resistencia-luiza-prado-1+%281%29.jpg",
        "alt": "Tattoo artist creating a large red ink design on a person's upper back with tattoos, lying face down."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f8431aab-e491-4e0f-8ec5-25d179625f62/resistencia-luiza-prado-7.jpg",
        "alt": "Close-up of a textured beige surface with reddish veins and faint splotches."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0bbafbc3-3365-47f7-a1a6-29c47aadf200/resistencia-luiza-prado-2.jpg",
        "alt": "Tattoo artist creating a tattoo on a person's back while lying face down on a tattoo table."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a705b261-5b77-4418-ba17-9f7e6f754a89/resistencia-luiza-prado-1.jpg",
        "alt": "A person lying face down while a tattoo artist creates a tattoo on their back, with the skin prepped with red ink lines, and the artist wearing white gloves."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/89224f37-8eff-4ba0-8014-613ecd32d7a2/castra%C3%A7%C3%A3o_political_art_luiza_prado.jpg",
        "alt": "Brazilian flag along with three metal rods and a metal ring on a white background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fff9a609-4589-4d03-bc43-021be9303ea6/Imagem13.jpg",
        "alt": "Comparison of two metal T-shaped objects, possibly industrial or mechanical parts, side by side on a plain background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d4105173-7f98-496e-8f4d-80b9cedf86f4/Imagem11.jpg",
        "alt": "Discourses of Necropolitics"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8218867b-3ad9-4b05-b5f7-a467f104f879/luiza_prado_video_art_political_art.jpg",
        "alt": "A chair in front of a small table with a TV on top, in a worn, industrial-style room with two large windows and sunlight on the floor."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/86b8e539-a14c-4ab4-8c87-3be17d361005/e_da%C3%AD__%282020%29_-_video_performance___hifa_cybe+%28720p%29_14110.jpg",
        "alt": "Discourses of Necropolitics"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3c128408-d533-44f2-8baa-fa9836f40983/coco.jpg",
        "alt": "A piece of brown, textured material resembling a mouse or bear-shaped object on a plain white background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/cea9555e-ca25-43be-91cc-e26f84e964a4/impunidade.png",
        "alt": "A Brazilian-themed Monopoly game board featuring the word \"IMPUNIDADE\" (impunity) in the center, with a Brazilian flag on a yellow sign. The board has various properties, police, and crime-related spaces, including \"CAMINHADA CHEST,\" \"COMUNALINITY,\" \"CHANCE,\" and monetary amounts. The corners include spaces with two white stripes and a red arrow at the bottom right corner."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1396cb5b-2182-44b3-92fe-5dca23ae6128/bozo.jpg",
        "alt": "A small doll holding a round mirror reflecting a blurred face of a person."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/851d18a2-fa68-491d-be6c-606ecd57cee2/Imagem6.jpg",
        "alt": "Open notebook with a list on the left page and a yellow line chart on the right page, on a light background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b050739c-570c-4888-9e0c-ec9ba4f757f0/Imagem7.jpg",
        "alt": "Open books with text and images on white background"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6f68e94d-6458-4991-a0b4-eb0128c21cf4/Imagem8.jpg",
        "alt": "Photo of a Monopoly game board, game pieces, money, and various game components."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/cf39c1ac-ba9e-4e44-824b-eda41af62ff0/Posthumous_Performance_Luiza_Prado.webp",
        "alt": "Framed Brazilian death body donation certificate for Luiza Jesus do Prado, issued November 28, 1988, in Guaratinguetá, SP."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/56d2a3fc-9662-4d08-bf15-b990226f22ee/indigestao-luiza-prado-1-1200x600.jpg",
        "alt": "A person in a grey shirt eats money and drinks alcohol at a dining table, with multiple close-up shots of the hands, face, and actions involving money and a cigarette."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/03abe7dc-382c-4cae-98ea-cdd3aef83c87/indi-gest%C3%A3o_performance___hifa_cybe+%281080p%29_12988.jpg",
        "alt": "Discourses of Necropolitics"
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "233473348"
      },
      {
        "provider": "vimeo",
        "id": "272140565"
      },
      {
        "provider": "vimeo",
        "id": "424329715"
      },
      {
        "provider": "vimeo",
        "id": "181019759"
      }
    ]
  },
  {
    "slug": "diary-of-memories-that-i-dont-have",
    "title": "Diary of Memories I do Not Have",
    "year": "2020",
    "lead": "Photography is taken in a dramatic representation, used as a central approach and exploration of the self-psyche, emotional linkages, mental disorders, traumas and depression, in the case of memories that occurred in a substantial past, for the construction of the present. This same past is over, allowing changing lived situations, going to a new path to that experience through the photographic reprocessing.",
    "body": [
      "A derived and large in possibilities scene, which the protagonist becomes an auxiliary-ego, transforming its past in a perspective from another, distancing from the screenplay, desensitizing the situation through self-pictures frames that tells each step of the story, although allowing the manipulation in physical, digital and contextual of the denouement. The daily heart, ready to receive changes under remembrances not owned any longer. If there are ancestral beliefs, of situations and characteristics passed on, I believe that this lace was cut when the photography allowed me to materialize different ends of all the stories.",
      "“A Diary With Memories That I do Not Have” initiated in 2010. I started in photography with self-portraits and these symbolizes for me a catharsis sphere. In photography, began a unconsciously need to expose situations, trauma disorders, depression and phobias that I possessed and at the time did not know how to express them. It was also when I had contact and identification with the known “suicide photographers”, specifically Francesca Woodman and Diane Arbus. Much has been revealed through this process and then the self-portraits were used as the basis of psychological treatments, specifically with psychodrama techniques ( Jacob Levy Moreno – 1925) and EMDR (Francine Shapiro – 1987).",
      "This project involves desensitizing traumatic memories related to sexual violations using photography, noise and performance. In this project, EMDR and psychodrama techniques were used specifically and my body and my story were used as an experiment",
      "Chimera to affirm the impossibility of transforming past experiences, because if I crave the sky, not having wings, I am only a reverie for those who look at me. But, even unable to fly with my fixed feet in which I am predestined arrested, this floor that roots me is no longer absolute looking to what I crave so hard. My eyes fixes itself to the worldly desire, changing all the perspective, creating hardness, so I become the most beautiful of all birds. This is the moment in which I discover that, the accusation is the comfort of the prisoner, because he points to what he doesn’t know and believes to fly is an illness.",
      "The photo was used as the basis for my difficulty to verbally explore my experiences. There was an identification of my photography with the roles of Development Theory, Inversion Protagonism and the Mirror Technique, which are techniques developed in Psychodrama and correspond to the phases of the self-portrait as a catalyst experience. In the self-portrait, my auxiliary egos were in charge of the stage and through this mirror, I applied the EMDR techniques (Desensitization and Reprocessing through Eye Movement). Since a trauma sequence was suffered, I possessed PTSD, therefore so much of what had happened was considered by myself as fictional. However, EMDR working both hemispheres of the brain, reactivated processing experiments that had been forgotten or aggravated."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e2e35d73-3ffc-48d1-ba5a-157001daeff1/luiza-prado-piracaia-2-1.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0e01ee3d-05e7-4d0c-b44c-00070125c007/WhatsApp+Image+2024-04-20+at+16.11.53.jpeg",
        "alt": "A person lying face down on a large rock formation outdoors, with a bare tree and other trees in the background under a cloudy sky, black and white photograph."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/35112dc4-1d60-4a12-bd48-ce438927a426/self_portrait_luiza_prado.jpg",
        "alt": "A collage of five black and white photos depicting a woman with different emotional expressions and poses."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/36238e85-8b47-4acf-a3d6-8e5cd9bc949c/diario_de_memorias_que_nao_tenho_luiza_prado.jpg",
        "alt": "A black and white distorted image of a person covering their face with their hands, creating an abstract, surreal effect."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0de5cba2-4b1a-4724-b8de-88b50e6c431b/cega_luiza_prado.jpg",
        "alt": "Person lying on the floor with long hair covering their face, blurry motion around them in black and white."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e7a1a00d-3ac8-4c39-8534-a9df5474d09c/self_portrait_luiza_prado.jpg",
        "alt": "A digital artwork showing a central humanoid figure with multiple headless, floating humanoid figures arranged horizontally on either side, creating a symmetrical, dark, and surreal scene."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5738fa37-8232-45c8-a79d-b879c957160e/diario_de_memorias_que_nao_tenho_luiza_prado.gif",
        "alt": "Black and white image of a tree with expansive branches in a park-like setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e2e35d73-3ffc-48d1-ba5a-157001daeff1/luiza-prado-piracaia-2-1.jpg",
        "alt": "Person kneeling in a lake or river with mountains and cloudy sky in the background"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c377ee0f-5bd8-42ae-bfc4-d58b014ac005/self_portrait_luiza_prado.jpg",
        "alt": "Two women in vintage-style clothing engaging in a playful or dramatic scene in a cluttered room, with a cello leaning against the wall, and various papers, a birdcage, and a basket around them."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/214f877c-d76d-4372-94c6-8daf2ebfcd0c/self_portrait_luiza_prado.jpg",
        "alt": "A woman in a light-colored lace dress standing under a wooden bridge, looking down at the ground."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/44124fbb-ae6d-487a-86c0-13088044aa7c/self_portrait_luiza_prado.jpg",
        "alt": "A blurred sculpture of a nude human figure holding a dark ball, with multiple hands arranged on the body, against a plain background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0234972c-7539-4dcd-90af-adbb76a010ec/self_portrait_luiza_prado.jpg",
        "alt": "A person standing against a wall with a black drape, covering part of their body and creating dramatic shadows."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/424c2c51-52fe-4582-8b20-be102d7b6c53/self_portrait_luiza_prado.jpg",
        "alt": "A person with tattoos holding a mirror in front of their face, with a hand reaching into the mirror from behind. The mirror has an ornate gold frame, and the scene is in a dimly lit room with a wooden"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/486c495b-a300-4285-8d12-5732bccbcecc/self_portrait_luiza_prado.jpg",
        "alt": "Person lying on the floor with their arm stretched out, in a dimly lit room."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/11382045-7e1e-43cd-a168-c256daf95710/self_portrait_luiza_prado.jpg",
        "alt": "A nude woman with tattoos on her side and arm, with curly brown hair, poses against a plain light gray background, with her eyes closed and one hand touching her face and the other behind her head."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0bf9a21a-9cde-4e01-9cad-7c4037a8a12e/self_portrait_luiza_prado.jpg",
        "alt": "A woman with tattoos sitting on a bed, with her head turned down and her hand resting on her chin, in a kneeling pose against a plain wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/12470be0-049d-471a-98ee-65d5faae9bd5/self_portrait_luiza_prado.jpg",
        "alt": "A person with tattoos sitting on the floor, hunched over with their head in their hands, next to an old, ornate fireplace in a dimly lit room."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/015c187b-247c-46ff-be17-7d5f9536a8dd/self_portrait_luiza_prado.jpg",
        "alt": "A woman with disheveled hair and makeup smeared on her face, appearing distressed, standing topless in a shower or tiled room with bloodstains on her skin and the wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/68a33a91-cfa9-449f-af63-90ab584e5396/self_portrait_luiza_prado.jpg",
        "alt": "A black and white photo of a woman lying on a bed, with her body angled sideways and her right arm extended over her head. She has a tattoo of a tiger on her hip and is covering her chest with her left hand."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/40c058b0-cb23-4443-8343-cd35adfc0c8d/self_portrait_luiza_prado.jpg",
        "alt": "A person with a tattoo on their back sitting on the floor in a dark room facing the corner."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/788a87f5-b83d-4d8d-ab22-576c2402f499/self_portrait_luiza_prado.png",
        "alt": "A person resting on a windowsill during daytime, with a decorative metal window grille and tiled floor visible."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c7a6d8b7-d179-465a-90c1-f60bb382271a/self_portrait_luiza_prado.jpg",
        "alt": "Portrait of a woman with a septum piercing and bare shoulders, wearing a black blindfold against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b774dcf7-c622-468c-bcb4-aa8232a5f682/espelho_luiza_prado.jpg",
        "alt": "A person lying on the floor, partially hidden behind a mirror with a wooden frame, reaching out towards the mirror with blood on their hand."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/700cb29d-89f4-4eb0-ad70-34bb705dfea4/self_portrait_luiza_prado.jpg",
        "alt": "Black and white photo of a woman with tattoos, showing her back and side, with her head bowed and arm over her shoulder."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/56e6d1df-8ac3-4aa1-9b2f-f21f654050ab/self_portrait_luiza_prado.jpg",
        "alt": "A person lying on a blanket in a narrow hallway, appearing to be undressed and reclining, with a tattoo visible on their back."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/77679657-1846-4657-af43-7429b6591c34/vazio-luiza-prado.jpg",
        "alt": "A person with curly hair leaning over and reaching toward the camera, with clothing and bags visible in the foreground."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/430a8e9c-2f66-413a-a39b-a967209f014d/self_portrait_luiza_prado.jpg",
        "alt": "A person with tattoos sitting on the floor in a dark room, leaning against a damaged fireplace, with their head bowed and arms crossed over their knees."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4bd66a35-fef6-4d9a-b277-f883e4edf04c/8_self_luiza_prado.jpg",
        "alt": "A woman with dark hair and tattoos wearing a black top and choker, sitting on a bed against a plain wall, with a contemplative expression."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/297acd5d-10f8-4e4c-adc2-01cdc6fd984f/no-chao-luiza-prado.jpg",
        "alt": "A person with tattoos kneeling on the floor, resting their head and arms on a stool, with a disheveled bed and blanket in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/56c3efee-1152-448c-a9fe-db1b3496762f/luiza-prado-3-1.jpg",
        "alt": "A black and white photo of a person with dark hair leaning forward, exposing their back and shoulders, against a plain white background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/acf85756-86f6-4578-add7-92ae6127b01e/self_portrait_luiza_prado.jpg",
        "alt": "A sequence of five black-and-white photos of a woman displaying various emotional expressions, including crying and covering her face."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/07a4b2b4-4c0b-4873-b3ec-bd2768985e13/veneno_luiza_prado.jpg",
        "alt": "A person holding a red apple close to the camera, with their arm and shoulder visible in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ae273417-3668-4c2b-96f2-f2034b9fccf9/veneno_luiza_prado.jpg",
        "alt": "A person sitting on the floor in a small, dimly lit bathroom or closet, hugging their knees."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1c4993a3-db2f-4ba8-b89f-3ea9fddfe79e/colombiana_luiza_prado.jpg",
        "alt": "A woman sitting nude on a vintage sofa with her hands covering her face, in a dimly lit room with sculptures in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/cb4ac3cb-bd6f-46f4-9840-2ec094be0c11/consumo_luiza_prado.jpg",
        "alt": "A nude woman with tattoos sitting on the ground in an abandoned, graffiti-covered building with large windows and overgrown greenery outside."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1d690d0c-66a4-455b-8708-1c618a32bcfa/pelicula.png",
        "alt": "Close-up of a person sitting on a desk, with legs crossed, in a sewing or tailoring environment. The person is using a measuring tape around their knee, surrounded by sewing tools and fabric."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/63f886a4-50e6-4853-9f2e-8bd751b93136/diario_de_memorias_que_nao_tenho_luiza_prado.jpg",
        "alt": "A collage of children's drawings, including a girl with a headband, a rainbow-colored trumpet, a blue bird, a queen with a crown, and a girl in a pink dress with a crown."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ccf02326-9446-400f-97d3-ad8b2a4e45c4/rape_luiza_prado.png",
        "alt": "Diary With Memories I do Not Have"
      }
    ],
    "videos": [
      {
        "provider": "youtube",
        "id": "AR-sxi2uOG8"
      }
    ]
  },
  {
    "slug": "colonized-sexuality",
    "title": "Colonized Sexuality",
    "year": "2021—",
    "lead": "**Colonized sexuality** is the body crossed by norms that   do not belong to it. Imposed by Christian, patriarchal, and Eurocentric epistemologies, it turns desire into discipline,   skin into a border, gender into a prison. To colonize   sexuality is to sever pleasure from spirit, affection from territory, the body from history. It is to erase entire cosmologies where sex was ritual, connection, passage,   and vital force. To decolonize sexuality, then, is not only   an act of resistance",
    "body": [
      "Colonized sexuality is not merely the repression of individual desire — it is the systemic rearrangement of entire erotic, affective, and relational cosmologies through the violent imposition of Western, patriarchal, and Christian norms. As Aníbal Quijano defines in his theory of coloniality of power, colonization was not only a territorial project, but also an epistemic and ontological one. Sexuality was a key target of this transformation — a space where bodies were classified, desires were regulated, and forms of life were subjugated to fit within a Eurocentric model of intelligibility.",
      "Maria Lugones expands this idea by introducing the concept of the coloniality of gender, revealing how colonialism did not just impose hierarchies of race and class, but also forcibly introduced a binary gender system and heteronormative matrix where diverse pre-colonial gender expressions and sexualities were erased or demonized. In many Indigenous, Afro-diasporic, and ancestral worldviews, sexuality was not reduced to reproductive function or moral control, but existed as a force of connection, ritual, community, and spirituality. The colonial project severed this sacred link between body and territory, between sex and meaning.",
      "Gloria Anzaldúa, in her writings on the borderlands, reminds us that colonized sexuality also emerges as a site of internal fracture — a space where hybrid identities (queer, mestiza, racialized) are forced to navigate shame, fragmentation, and invisibility within both dominant culture and their own communities. Her work affirms that to reclaim sexuality is also to reconfigure language, myth, and flesh — a border practice that is both spiritual and political.",
      "Achille Mbembe points out that the colonial order functions through necropolitics — the regulation of who may live and who must die. Within this framework, the sexuality of Black, queer, Indigenous and trans bodies becomes a field of state control, medicalization, and hypervisibility paired with disposability. The erotic life of the colonized subject is policed, exoticized, or erased — never autonomous.",
      "Ochy Curiel, building from Afro-Caribbean feminism, reminds us that decolonizing sexuality cannot be a mere liberal inclusion of \"diverse\" sexualities into the colonial order. Rather, it requires a rupture with the racial-capitalist and patriarchal logic that continues to shape intimacy, desire, kinship, and relationality. It requires unlearning the colonial gaze and recovering ways of being together that do not rely on domination or commodification."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9a176d2e-b1fe-44af-9e78-8f386c186836/cultus_luiza_prado.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f81bde02-db7d-4977-bec1-98fc265adf14/pudor-luiza-prado.jpg",
        "alt": "A projection on a wall shows a pile of shredded paper or similar material on a surface, with a tattooed arm visible near the pile. A device connected by a cable is placed below the projection."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f2730f43-8248-4fe9-a763-f96aab75880b/pudor-hifa-cybe.jpg",
        "alt": "Colonized Sexuality"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f36e4894-d5bd-4b32-ad03-82eceee9cd5d/pudor-hifa-cybe.jpg",
        "alt": "Person pouring small white pills or tablets onto their tattooed arm, with a cross tattoo visible."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/25006c61-44d7-44d4-a173-de937d3367d1/pudor-hifa-cybe-1.jpg",
        "alt": "A nude woman with tattoos lying on her back against a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d9479c92-46f9-42af-89e9-23c4adbab999/pudor+luiza+prado_7029.jpg",
        "alt": "A person with tattoos on their side lying down, holding a white rosary with crosses on it, against a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d0306877-9111-40cd-acbe-dc5cfcb06c05/Luiza+Prado_2566851.jpeg",
        "alt": "Series of images showing a tattoo artist inking a tattoo design on a person's hand and wrist."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fa321c46-7760-4ce4-9bd4-e7bc353b101b/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%290989.jpg",
        "alt": "Colonized Sexuality"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2330f5f4-14cc-4c6c-9f52-db5ee43cb234/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%290429.jpg",
        "alt": "A close-up of a glass of water on a dark surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b3c1b584-1701-4fcd-b0f4-5401fdfb37d5/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%292735.jpg",
        "alt": "A naked person wearing a black ski mask with eye and mouth holes, standing against a plain wall with arms outstretched."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/87a17f8e-7d32-4abe-bca3-93d569731d61/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%298181.jpg",
        "alt": "A person with dark hair is looking down, holding a backbrush in their right hand, in front of a plain, cream-colored wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/422af5ee-de21-45cf-9ddd-25ddf665ef76/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%296240.jpg",
        "alt": "Close-up of a person's hand holding a smartphone with a blurred Oreo cookie in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a1ea95f3-dcdd-483e-af93-f03ebed2968d/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%298248.jpg",
        "alt": "Close-up of a person's face, possibly a child, against a neutral background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/541eee2f-9163-4897-ba87-feaaa63685e6/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%294860.jpg",
        "alt": "Reflection of a person with tattoos standing in a room with wooden flooring, partially distorted by a mirror or reflective surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/da631d6a-5a94-4fb5-9b57-0a92529d241b/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%298158.jpg",
        "alt": "A person with dark hair in a bun standing nude against a plain wall, covering their chest with their hands."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/007f75c5-e9fc-4e50-8dbb-866ffd0391df/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%296134.jpg",
        "alt": "A close-up of a glass with a dark background, showing some reflections and lighting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/734f28f7-c60a-4c8b-b534-f629fb43a5d7/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%292061.jpg",
        "alt": "A person holding a glass with a layered drink, seen from above, with a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/40d94186-60ca-49a6-9799-9fe771012402/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%291305.jpg",
        "alt": "A shirtless person wearing a black ski mask with holes for the eyes and mouth, standing against a plain off-white wall, with arms outstretched."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/335a3010-6c8c-486d-b8af-552bea5735fe/Performance+-+I+Miss+You+_+Luiza+Prado+%281%294612.jpg",
        "alt": "Colonized Sexuality"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2fbf783c-8e57-401d-8cb0-a39eeddd810e/Performance+-+I+Miss+You+_+Luiza+Prado+%281%292309.jpg",
        "alt": "Close-up of orange and yellow flames burning."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/408f026e-74af-4710-91c9-995335698884/Performance+-+I+Miss+You+_+Luiza+Prado+%281%295117.jpg",
        "alt": "Close-up of a person's hand and part of their face, with the hand slightly raised, in a dark outdoor setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/85302e2a-457e-4356-8072-56f3ccc4f583/Performance+-+I+Miss+You+_+Luiza+Prado+%281%294893.jpg",
        "alt": "Person standing on rocky terrain near trees and bushes"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/81a09d68-6f43-4fc4-9405-91aeff9b5def/Performance+-+I+Miss+You+_+Luiza+Prado+%281%296220.jpg",
        "alt": "A small campfire burning on the ground with visible flames and charred wood, surrounded by dirt and sand."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ca038904-a091-437e-932c-85b1c9ed2301/Performance+-+I+Miss+You+_+Luiza+Prado+%281%295292.jpg",
        "alt": "A person holding a zebra-striped fabric or object outdoors at night."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f2f0216d-9df1-4772-ab83-dd2d3a6bc302/Performance+-+I+Miss+You+_+Luiza+Prado+%281%296597.jpg",
        "alt": "Charcoal and flames from burning wood or debris on a ground surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9985ff58-96e8-473d-9512-ef13a84a9c0b/Performance+-+I+Miss+You+_+Luiza+Prado+%281%296326.jpg",
        "alt": "Lava flowing with visible flames on the surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f3f61447-245b-44c2-bc38-5a4ad29cd30e/Performance+-+I+Miss+You+_+Luiza+Prado+%281%295373.jpg",
        "alt": "A person holding a snowboard outdoors, with a snowy landscape in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f696ad77-9b9a-490e-8bc4-988ad795eb1f/Performance+-+I+Miss+You+_+Luiza+Prado+%281%295653.jpg",
        "alt": "Close-up of a charred paper or fabric on a fire with ashes and burnt debris around."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1327a005-f119-4822-9445-8ff9650d40dd/Performance+-+I+Miss+You+_+Luiza+Prado+%281%295477.jpg",
        "alt": "Close-up of a white ribbon with the word 'MAXIMUM' written on it, surrounded by a decorative ruffled design."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/90ce09da-1d5d-4a42-b71b-82652bc59dd7/Performance+-+I+Miss+You+_+Luiza+Prado+%281%295518.jpg",
        "alt": "Fire burning on paper or leaves on rocky ground."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/91301aac-5461-4444-896a-8cb550bf8758/Performance+-+I+Miss+You+_+Luiza+Prado+%281%293476.jpg",
        "alt": "Explosion in a forested area with flames and smoke."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5269497d-bc7e-4f2c-aef4-9e7563c20362/Performance+-+I+Miss+You+_+Luiza+Prado+%281%293998.jpg",
        "alt": "Close-up of a fire burning with bright orange and yellow flames."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8b4c4515-e13b-4225-847a-77aea9859854/Performance+-+I+Miss+You+_+Luiza+Prado+%281%294518.jpg",
        "alt": "A handwritten letter burning on the ground with flames and ashes."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/954d4984-18a2-44d4-af19-021b9ef6ce73/Performance+-+I+Miss+You+_+Luiza+Prado+%281%294148.jpg",
        "alt": "A person standing amid flames and smoke in a forested area."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3e74af13-e0ff-4ca2-a114-a283914f6989/Performance+-+I+Miss+You+_+Luiza+Prado+%281%293724.jpg",
        "alt": "Fire burning outdoors on a dark night."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/adde5e76-7ff4-474e-bfbf-a851fad32d99/i-miss-you-3-1200x600+%281%29.jpg",
        "alt": "Paper and leaves burning on the ground with flames."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/daabc61b-f1f6-42d9-9317-96e78b7f6ebd/i-miss-you-3-1200x600.jpg",
        "alt": "Paper documents burning on the ground with bright flames and ashes."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f464162c-7c8c-4afa-8a1d-c1c3fd02ee9e/Performance+-+I+Miss+You+_+Luiza+Prado+%281%292292.jpg",
        "alt": "Close-up of a hand with a peace sign gesture, partially visible person wearing a sash, outdoor setting with greenery in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c63d7070-8da4-4321-b2df-8f486e2c8ea5/Performance+-+I+Miss+You+_+Luiza+Prado+%281%292884.jpg",
        "alt": "Fire burning on dark surface, with flames and charred debris."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9764accd-58af-4381-a17c-2ed6983780fd/Performance+-+I+Miss+You+_+Luiza+Prado+%281%293276.jpg",
        "alt": "Person standing on a rocky surface with small fires burning in a circle around them, in a forest setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6452b510-2e56-4965-82ae-55485487744d/hifa+cybe+i+miss+you.jpg",
        "alt": "A handwritten letter being set on fire outdoors, with flames visible on the paper."
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "233659229"
      },
      {
        "provider": "vimeo",
        "id": "143548773"
      },
      {
        "provider": "vimeo",
        "id": "235166337"
      },
      {
        "provider": "vimeo",
        "id": "144276523"
      },
      {
        "provider": "youtube",
        "id": "tUMvGIZ-wvY"
      }
    ]
  },
  {
    "slug": "entities",
    "title": "Entities",
    "year": "2023",
    "lead": "The project Entities explores the relationship between body, memory, and spirituality through an engagement with entities rooted in Brazilian cosmologies, particularly those shaped by African and Indigenous origins. The performance unfolds as a contemporary ritual in which the body operates as a site of inscription and reactivation of memory, both individual and collective, inherited, transmitted, and transformed over time.",
    "body": [
      "In dialogue with ancestral knowledge present in practices such as umbanda, candomble and other Afro-Indigenous traditions, the work does not aim to literally represent entities, but to activate their presence as forces, archetypes, and modes of existence that move through the body. Within this context, ritual functions as a sensitive technology of accessing memory, allowing the invisible to manifest through gestures, repetition, and states of incorporation.",
      "Through trance, listening, and suspension, Entities proposes a liminal space where identity and alterity begin to dissolve, enabling the body to become a site of passage. The performance thus creates a field of encounter between different temporalities and epistemologies, where spirituality and memory emerge as living presences, deeply rooted in African and Indigenous heritages that continue to resonate in the present."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0510845e-58c8-409b-9a06-aa4d5f94ed77/luiza_prado_ritual_performance_hifa_cybe_aerial_chains.jpg",
    "images": [
      {
        "src": esuRitual.url,
        "alt": "Esú — ritual performance with fire, torches and harness in a red field."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6d8520d6-e4ed-4099-963e-864508eab6b0/luiza_prado_ritual_performance_hifa_cybe_aerial_chains.jpg",
        "alt": "Person with tattoos wearing a black outfit hanging upside down by chains in a dark setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/49de5193-6087-485b-9195-906257b65c9d/luiza_prado_ritual_performance_hifa_cybe_aerial_chains.jpg",
        "alt": "A person submerged in water, with visible tattoos on their arm, holding a fishing net with a jellyfish inside"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4e36c8b2-5346-488c-9857-4331013738f9/luiza_prado_ritual_performance_hifa_cybe_aerial_chains_oxum.jpg",
        "alt": "A person with tattoos wearing a black outfit, holding chains, with a netted mask over their face, against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d3c0cfd2-f545-4ac0-9c94-9a315dbb8663/luiza_prado_ritual_performance_hifa_cybe_aerial_chains.jpg",
        "alt": "A person with tattoos on their arm leaning forward, wearing wet clothing, with water droplets on their skin and hair."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/be16d131-4f6e-4c46-8698-d116bb87dd6e/luiza_prado_ritual_performance_hifa_cybe_aerial_chains_oxum.jpg",
        "alt": "A woman with tattoos wearing a mesh hat and revealing clothing, holding onto chains in a dimly lit, smoky environment."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/7f645b2b-32c5-4ca1-8f39-8f8ced268d40/luiza_prado_ritual_performance_hifa_cybe_aerial_chains.jpg",
        "alt": "A woman with tattoos on her arms and chest is wearing a metallic headpiece and outfit, with chains hanging from her arms, in a dark setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/607b36fb-3e48-4f3d-b81c-df549bca0f58/luiza_prado_ritual_performance_hifa_cybe_aerial_chains_oxum.jpg",
        "alt": "A tattooed woman with wet hair, holding a metal chain, in a dark setting with minimal light highlighting her profile and tattoos."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ed101245-0d3f-46eb-8f34-3e8f90d4b83e/luiza_prado_ritual_performance_hifa_cybe_aerial_chains.jpg",
        "alt": "A woman with tattoos on her arms and chest, wearing a black head covering and earrings, holding onto a metal chain in a dark setting with water on her skin."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/234ce352-24ca-45f8-8604-8432bbb7d901/luiza_prado_ritual_performance_hifa_cybe_aerial_chains.jpg",
        "alt": "A woman with tattoos on her shoulder and arm holding onto a large chain, her face partially covered with reflective material and hair partially visible, against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/361b3620-2091-4d86-86ae-a852b43672db/FINAL+LUIZA+11520.jpg",
        "alt": "Entities"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/93ce502a-c10c-499a-9c1b-f57dff5d8df7/FUNDO+PRETO+DUPLA0098.jpg",
        "alt": "Close-up of chains hanging in darkness with soft light reflecting off the metal links."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1b077fed-f718-4955-b3ac-1e54f2273d24/FINAL+LUIZA+15081.jpg",
        "alt": "A man and woman in a close, intimate embrace under water, with water droplets on their skin, dark background, somber mood."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0caf7e07-097c-4113-b7ec-ea83c1210721/FINAL+LUIZA+14676.jpg",
        "alt": "A person standing in the rain against a dark background, with water droplets visible on their skin and clothing."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/59c5227e-4a2e-4b18-8574-be0fbee8154f/FINAL+LUIZA+14672.jpg",
        "alt": "A man and woman embracing in the rain at night, with a dark background and minimal lighting highlighting their outlines."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b2d06fae-8da4-488d-aaa1-e7150213f223/FINAL+LUIZA+14590.jpg",
        "alt": "A man and woman in dark clothing are dancing closely together under rain against a dark background, with water droplets visible on their bodies."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d731b300-d819-471c-a3e5-be91be4a230f/FINAL+LUIZA+13615.jpg",
        "alt": "A close-up of a person with wet skin lying down, with closed eyes and lips slightly parted, water droplets on their face and body, and dark hair slicked back. Their hand is resting near their face."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/630d2bee-3a19-4307-9894-fe6e035d4cf6/FINAL+LUIZA+12802.jpg",
        "alt": "Two individuals are in the rain, one with long hair and earrings is looking at the other, who is partially visible. The scene is dark with water pouring down."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3f7df747-8431-44a9-9b94-277c4617c496/FINAL+LUIZA+12481.jpg",
        "alt": "A person with wet skin holding a large chain, with rain falling around them in a dark setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/04ea29c6-b1be-4de0-8ecf-1be3fa3ed516/FINAL+LUIZA+12470.jpg",
        "alt": "Person in rain with chains around their neck, holding a sword in a dark, wet environment."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8eafb718-0802-4fa4-90ea-292b881d7e22/FINAL+LUIZA+12428.jpg",
        "alt": "A woman with chains around her wrists and neck, standing in the rain with her eyes closed, appearing to be in distress or deep thought."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/210c5dc1-53a9-432e-b1df-dcfc15c15b70/FINAL+LUIZA+12318.jpg",
        "alt": "Close-up scene of a person in the rain with chains around their neck and shoulders, head down, dark and moody lighting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1de3143a-60c2-49c3-8041-f4a9e014f8e5/FINAL+LUIZA+12139.jpg",
        "alt": "A dark scene showing chains hanging from a structure, with a hand gripping a chain and raindrops falling in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6d56a050-9511-43ff-adc1-9f2c62a2a7f8/FINAL+LUIZA+12129.jpg",
        "alt": "A dark scene with rain falling, showing chains and a fallen tree or branch over a person on the ground."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/19e824ee-0b13-47a1-8e37-612a33bd9714/FINAL+LUIZA+11909.jpg",
        "alt": "Two people wrapped in metal chains standing in the rain under a dark wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8fc32645-98eb-4894-bebe-dffb00e3bfb2/FINAL+LUIZA+11623.jpg",
        "alt": "A shirtless man with tattoos on his torso is standing under heavy rain, holding a chain with both hands, with his face partially obscured."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/66d3b990-b818-4f3a-b574-f05437312319/FINAL+LUIZA+11529.jpg",
        "alt": "A dark scene showing a woman in the rain holding a chain, with a man behind her also holding chains, both appearing intense."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/415407fe-9178-4e64-b831-f05219a6902b/FINAL+LUIZA+11458.jpg",
        "alt": "Two shirtless men with tattoos, chained together, standing in the rain at night, one with his eyes closed, the other looking at him in the dark."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c086519c-c40e-4526-87ae-bc4bae7cd6cd/FINAL+LUIZA+11172.jpg",
        "alt": "Man with chains around his neck and head, leaning forward in the rain at night."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c1c685b5-602d-44b9-8498-3d39ddcc2700/FINAL+LUIZA+11082.jpg",
        "alt": "A man and woman sitting on the ground in the rain, with water droplets visible, in a dark setting with rain pouring down."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ec3b1805-827c-42ac-916b-cb2e96fffb0c/FINAL+LUIZA+11039.jpg",
        "alt": "A man and woman in a dark room, wet from rain, with the man shirtless and the woman holding a black umbrella."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c007d332-6f27-4127-8946-e7f58d2e27ae/FINAL+LUIZA+10635.jpg",
        "alt": "A shirtless man standing in the rain with his head bowed and eyes closed, illuminated against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0d601131-2ddc-4185-a4d0-db85f78876fc/FINAL+LUIZA+10414.jpg",
        "alt": "A woman in rain, partially illuminated, with a snake wrapped around her arm."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d775decd-b225-4993-a7a5-d8e517ef2ae0/FINAL+LUIZA+10375.jpg",
        "alt": "Woman with short curly hair and tattoos on her shoulder, looking at a shirtless man with wet skin, in a dark setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ba4c3f50-9a81-4fee-8062-77e0e02ac59b/FINAL+LUIZA+10308.jpg",
        "alt": "A woman with wet hair and tattoos on her shoulder and arm, looking down and to the side, in a dark setting with rain or water droplets on her skin."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a0366231-a8ee-45fd-bfe5-e4b7771aab2b/FINAL+LUIZA+10214.jpg",
        "alt": "A person with wet hair and smeared makeup looks distressed, partially illuminated in a dark environment, with shadows and dim lighting on their face and background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1ced4ded-f52f-4079-a825-f11353fe20d5/FINAL+LUIZA+10005.jpg",
        "alt": "A woman with short wet hair and tattoos on her chest, lying against a dark brick wall at night, illuminated by a dim light."
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "1176132299"
      },
      {
        "provider": "vimeo",
        "id": "1176137524"
      }
    ]
  },
  {
    "slug": "symbiogenesis",
    "title": "Symbiogenesis",
    "year": "2022—",
    "lead": "This project is a dystopia based on Symbiogenesis, based on the principle of its endosymbiotic theory, at the origin of the eukaryotic cell, of progressive evolution, leading to the complexification of coding systems, initially as a result of the fusion of prokaryotic cell genomes.",
    "body": [
      "It is a concept created by Boris Kozo-Polyansky (1890-1957) and Lynn Margulis (1938-2011). In the dystopian metasystem of this project, there is a progressive evolution among all metazoans, whose evolutionary scale considers the relationship with horizontal gene transfer and other coding events resulting from the interaction of different genomes leading to the complexification of biosystems.",
      "However, the great creation of all the kingdoms is the human being, which in this case is not part of the Animale, it is a separate being, which arose mainly from the aggregation of less complex symbionts. The human being also becomes the medium of these beings who seek to understand the domains of the human mind, asking whether intelligence, reason and conscience are in fact the figuration of a vast blindness, each being elected from each kingdom, by questioning the human being, becomes a figuration of the human psyche that emerges from the unconscious trying to save this creation (the human being) that does not understand the maintenance of the network of life nor its own intelligence, which in this case distances it from the truth and the will reach apoptosis, as it is the environment that houses the entire kingdom, it will result in the death on a large scale of all of them.",
      "The project is made up of the kingdoms; Kingdom Archaea (Archaebacteria), Kingdom Bacteria (Eubacteria), Kingdom Protista, Kingdom Fungi, Kingdom Plantae and Kingdom Animalia."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4874d7f5-6f47-4778-9ab3-05e30453a9d2/3d+wing+luiza+jesus+do+prado.png",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/08f5da71-6646-478e-8bee-dfcbede5dd00/fungi_shibari_performance_luiza_prado.jpg",
        "alt": "Symbiogenesis"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a7f433a5-baf6-4d43-ba69-777a30bd1a0e/organic_motion_luiza_prado_guilherme_todorov.png",
        "alt": "Symbiogenesis"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/922d4305-72bb-4ca8-bfe1-6be48190c7e7/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10479.jpg",
        "alt": "A tattooed person with dark hair and braids, wearing a red cord necklace, is performing a ritual with their arms outstretched in a dark room. There is a faint circular symbol on the wall behind them."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/495fd803-6ebb-41ab-875f-ef7c6a66cee2/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10363.jpg",
        "alt": "A woman with tattoos and dark hair is tied with red ropes, with her arms outstretched, in a dark setting with a faint circular background light."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/90e2e4df-e23a-45a6-898a-44f57d3e3d3f/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10367.jpg",
        "alt": "A person with closed eyes, covered in a black substance, wearing a red cord around their neck, with a large circular object in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/841f5a65-d8ab-4d25-b30e-d4b8522669b1/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10011.jpg",
        "alt": "Close-up of a pizza with chopped vegetables and sliced lemon on top, against a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d969f678-1eb6-4ae4-9e49-d6242ccfd82e/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10544.jpg",
        "alt": "A woman with tattoos, wearing black and red lingerie, holding red ropes in both hands, with a dark background and a large moon or sun behind her head."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/158c435d-16b5-4829-a27c-2858858ba86b/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10591.jpg",
        "alt": "Close-up of a human torso with a visible chest and abdomen, tied with red ropes in a decorative pattern, with black straps and dark shadows, creating a dramatic and intense scene."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d2196c90-794b-4fa7-a64c-f00507610885/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10633.jpg",
        "alt": "A woman with black wet hair and tattoos, tied with red cords, standing against a dark background with a moon and a red drape behind her."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c32d9790-42b8-481c-8183-5f741ee15a2c/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10765.jpg",
        "alt": "A woman with tattoos is suspended in mid-air, tied with red ropes, with her arms outstretched and her eyes closed in a dimly lit setting with dark red curtains in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fd3d2f69-85f2-4216-987e-784e19a7fc7c/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10825.jpg",
        "alt": "A close-up of a person's wet, muddy face, wearing a red braided necklace, with dark hair and water droplets on the skin."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/871a75f7-3bd2-47c7-a6a8-120356dd9997/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10852.jpg",
        "alt": "Close-up of a woman with wet hair, dark lipstick, and shiny makeup, wearing a jacket with red and black details."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6313a7e1-453c-41aa-aaff-b8260525a770/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10955.jpg",
        "alt": "Close-up of a woman's face with wet hair and makeup, wearing earrings, in a dark setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b897799f-be9c-4e55-9cc8-0fb2a9e65478/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11091.jpg",
        "alt": "Close-up of red shoelaces tied in knots against a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fe0c4978-8469-442f-bf60-0b8ef1d3589d/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11255.jpg",
        "alt": "A woman covered in black liquid, bound with red ropes on her arms and body, with black paint on her face and tattoos on her arms, standing against a dark background with a red and orange circular patt"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2c718871-aa5d-4622-8ce4-7c5841937804/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11305.jpg",
        "alt": "A person with black hair lying on their back with their face covered in black beans, against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/773b9b8b-6630-46f4-9f7f-abd256a40f9e/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11417.jpg",
        "alt": "Close-up of a person's neck and shoulder, showing skin scars, tattoos, and wet hair strands in a dark setting"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0efdb52f-c156-4add-a6aa-8a3a476f89ff/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11391.jpg",
        "alt": "A woman with her face partially covered in black bugs or insects, looking upward with a red eye, against a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/58b784c0-726d-4f56-9113-f1eff279009e/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11467.jpg",
        "alt": "Close-up of a person's arm and shoulder with dark hair, dark clothing, and jewelry, against a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/63e7b37b-98f1-4a03-a3f0-f591bbc5c809/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11568.jpg",
        "alt": "Close-up of a wooden bowstring with red strings, set against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/51fab22e-1798-4b4f-abb3-a525bde2aca4/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11705.jpg",
        "alt": "A woman with tattoos chained and bound in black and red restraints, with a dark background and a glowing moon."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e5d97fe7-00b0-4297-a8cb-9976354dd47c/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11900.jpg",
        "alt": "Close-up of a person's upper chest and neck with tattoos and wet skin, wearing a red cord necklace against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3cbe3805-d624-4028-9f4c-038f88fe9245/Reino-Fungi_Hifa_Cybe_Luiza_Prado_12026.jpg",
        "alt": "Close-up of red shoelaces tied in knots against a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a21b96b6-1c60-454a-95f1-5beecb0686e6/Reino-Fungi_Hifa_Cybe_Luiza_Prado_12101.jpg",
        "alt": "Close-up of a person's hand wearing a black, shiny glove, tying red shoelaces on a dark shoe, with tattoos visible on their arm."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d89da888-fe82-452a-95f8-84efaaee210e/Reino-Fungi_Hifa_Cybe_Luiza_Prado_12173.jpg",
        "alt": "A person is hanging upside down from a wooden bar, tied with red ropes around their ankle, set against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3eac9b1a-7f40-44f4-81f1-d0dfa29429b2/Reino-Fungi_Hifa_Cybe_Luiza_Prado_12336.jpg",
        "alt": "Close-up of a person holding a wooden staff decorated with pinkish circles and black rope, wearing black clothing with red cords and beads, against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c5793d0a-fa06-456d-932f-4378981a9b2f/Reino-Fungi_Hifa_Cybe_Luiza_Prado_12395.jpg",
        "alt": "A person wearing black gloves, red shoelaces, and red clothing, with tattoos on their face, is bending down. The focus is on the person's face and shoes, with dark lighting creating a dramatic effect."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4ca089a4-c762-4f70-bc58-37c26f48ee75/Reino-Fungi_Hifa_Cybe_Luiza_Prado_12411.jpg",
        "alt": "Close-up of red nylon cord knots on a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/40cbffcd-98f9-4dbe-9068-1928960d66d2/Reino-Fungi_Hifa_Cybe_Luiza_Prado_13090.jpg",
        "alt": "Close-up of a dark, burnt object with blackened areas and a textured surface, surrounded by red rope and some black material, with part of a hand visible in the top left corner."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4db7feac-4720-457b-aeec-e067be1867f3/Reino-Fungi_Hifa_Cybe_Luiza_Prado_13307.jpg",
        "alt": "A person with tattoos on their body, wearing a red string around their neck and a black beaded necklace, extending their arm towards the camera. The person has dark hair partially covering their face and is set against a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1d8302ee-5baf-4b90-b86b-a7433e52e740/Reino-Fungi_Hifa_Cybe_Luiza_Prado_13583.jpg",
        "alt": "A person with black hair, tattoos on the chest and arms, and a beard is holding a chain of shiny black insects near his face, with a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5d003bcc-032d-4479-8793-09a425e66a15/Reino-Fungi_Hifa_Cybe_Luiza_Prado_13962.jpg",
        "alt": "A dark image showing a hand gripping a red fabric with long, sharp metallic claws extending from the fingers."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a6b26931-204a-44db-b82a-a36ecc7bbde5/Reino-Fungi_Hifa_Cybe_Luiza_Prado_14657.jpg",
        "alt": "A person wearing black and red attire and face beadings, with arm stretched holding red strings, in a dark setting with a moonlit backdrop."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/934e4bdc-6b28-4768-9425-f058f660934b/Reino-Fungi_Hifa_Cybe_Luiza_Prado_14996.jpg",
        "alt": "A person with long hair and tattoos, wearing a mask, kneeling and extending their arms, with red ropes attached to their wrists, in a dark setting with a backdrop and a moon or large orb above."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a99996b3-5a3b-4a0d-828d-02b6b4070e0e/Reino-Fungi_Hifa_Cybe_Luiza_Prado_15362.jpg",
        "alt": "A person wearing a dark, patterned shirt leaning forward in a dark setting, with details not clearly visible."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fa001cbc-aa3b-4f9b-9a5c-2d39df0a4b77/organic_motion_luiza_prado_guilherme_todorov.png",
        "alt": "Close-up of a textured surface with tangled, light brown fibers illuminated by a warm light source in darkness."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d4da743b-d686-44cc-b8ab-e506d62ddaa5/performance_shibari_luiza_prado.png",
        "alt": "Symbiogenesis"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a34a16b1-7002-4767-b383-7505a97d11a4/Reino-Fungi_6_14451.jpg",
        "alt": "A performer dressed as a fairy with purple wings, performing handstands against a rocky background with dramatic lighting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/bce8d1d8-576a-4d80-a6c0-00f5dc31a621/Reino-Fungi_6_10520.jpg",
        "alt": "Close-up of a person's face with dark hair, eyes closed, and jewelry with large green and red gemstones, set against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5789842b-f2bf-4901-bd1f-b9007fc777f3/Reino-Fungi_6_10542.jpg",
        "alt": "A person with tattoos lying on a hammock in a dimly lit cave with warm lighting."
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "932934707",
        "poster": "/__l5e/assets-v1/c4148b34-f372-4b4b-a4ae-97970698e5f0/fungi-video-thumb.jpg"
      },
      {
        "provider": "vimeo",
        "id": "934280735"
      },
      {
        "provider": "vimeo",
        "id": "932935155",
        "poster": "/__l5e/assets-v1/7b57442f-9de1-4198-95f2-28f2508f505f/animalia-video-thumb.png"
      },
      {
        "provider": "vimeo",
        "id": "1173568225"
      },
      {
        "provider": "vimeo",
        "id": "1173567960"
      },
      {
        "provider": "vimeo",
        "id": "1173568702"
      },
      {
        "provider": "vimeo",
        "id": "1173568922"
      }
    ]
  },
  {
    "slug": "animalia",
    "title": "Animalia",
    "year": "",
    "lead": "",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d4da743b-d686-44cc-b8ab-e506d62ddaa5/performance_shibari_luiza_prado.png",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a34a16b1-7002-4767-b383-7505a97d11a4/Reino-Fungi_6_14451.jpg",
        "alt": "A performer dressed as a fairy or mythical creature with purple wings, hanging upside down from a harness, with a dark background and a textured, rocky surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/bce8d1d8-576a-4d80-a6c0-00f5dc31a621/Reino-Fungi_6_10520.jpg",
        "alt": "A woman with her eyes closed, surrounded by dark hair, with shiny, reflective beads or jewels on her face and neck."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5789842b-f2bf-4901-bd1f-b9007fc777f3/Reino-Fungi_6_10542.jpg",
        "alt": "A tattooed woman is hanging upside down in a dark, cave-like setting, suspended by ropes."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9201f329-49e7-45f9-bd00-198faaeb3668/Reino-Fungi_6_10693.jpg",
        "alt": "A person with long dark hair and tattoos is hanging in a bondage setup with ropes. The scene is dark with dramatic lighting, creating shadows and emphasizing the person's body and facial expression."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/878d7413-f70b-4cd2-adc4-d1bcd8b96510/Reino-Fungi_6_11413.jpg",
        "alt": "A dark image showing a portion of a person's face with wet hair and some blurred, colorful reflection lights in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0021dedb-338e-4408-b286-e627c87e80c7/Reino-Fungi_6_11538.jpg",
        "alt": "Close-up photo of a fish, likely a salmon, inside a wooden container or box."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/795286ee-5678-46c7-a751-253cd0a38e9c/Reino-Fungi_6_11932.jpg",
        "alt": "A person's hand with tattoos on the wrist, reaching towards a collection of ropes and carabiners hanging in darkness."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f8fd2df9-4a4a-4e1a-b79f-c2a91eab576e/Reino-Fungi_6_16376.jpg",
        "alt": "A person's tattooed arm with a pink flower tattoo. The person is wearing yellow, glittery, polka-dot gloves and holding or touching their tattooed skin."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/adf67eae-7972-459f-a259-a42e27e43898/Reino-Fungi_6_16143.jpg",
        "alt": "An individual with tattoos performing a handstand, wearing a jewel-encrusted headpiece, with butterfly wings and a decorated fabric backdrop."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/7856c85e-d16d-4f29-99ee-f666c407e340/Reino-Fungi_6_15960.jpg",
        "alt": "A person with multiple tattoos being restrained by ropes and having their chest touched with a stick or tool."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9bbcb6e8-4158-4a8f-aa8e-577a6e31d925/Reino-Fungi_6_15847.jpg",
        "alt": "Close-up of a person holding a cupcake or muffin with a hand, with their face partially visible and blurred in the background, surrounded by ropes and wearing a shirt with a tattoo on the shoulder."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b89c4c1e-f334-48a5-90b0-db60bed85643/Reino-Fungi_6_15595.jpg",
        "alt": "A person with tattoos and beaded jewelry, lying on a surface, is bound with thick ropes tying their torso and arms, with a web tattoo visible on their chest."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8611b6dc-a518-4ec2-ae57-b66f0abb9be5/Reino-Fungi_6_15666.jpg",
        "alt": "A close-up of a person’s hand and forearm with tattoos, positioned in a dark environment."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/842d7ec2-1be3-4b98-b1a3-f2ead03dda22/Reino-Fungi_6_15530.jpg",
        "alt": "A close-up of a person with tattoos and jewelry, tied with ropes, with dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a9301963-b07d-4fd3-8ed7-ddb59702ec11/Reino-Fungi_6_15509.jpg",
        "alt": "A person with tattoos, wearing a beaded necklace, is bound with ropes and appears to be upside down or lying on his side."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6da24616-b902-4e47-b46b-d84fb6707dbc/Reino-Fungi_6_15402.jpg",
        "alt": "Person hanging upside down with wings, in a dark setting with textured background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/693877d2-077a-4e57-89cd-8eb16ac58ec7/Reino-Fungi_6_15206.jpg",
        "alt": "A person hanging upside down by a harness from the ceiling, with their head towards the ground, along a rugged fabric backdrop."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2d424e0a-9adb-47c5-a38b-fcb1c0a2c6b6/Reino-Fungi_6_14870.jpg",
        "alt": "Close-up of a person's face adorned with colorful gemstones, chain necklaces, and jewelry, with black hair and makeup, in a dark setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/86aed208-919c-486f-b9ed-353ebc889c57/Reino-Fungi_6_14730.jpg",
        "alt": "A person with a large face covered in multicolored rhinestones, tattoos, and a rope tied around the body, lying on a surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9ca1af0e-c75a-4c60-a624-6c65f07d9b9b/Reino-Fungi_6_14655.jpg",
        "alt": "A close-up of a person's tattoos and skin, with a tan dog being restrained with thick ropes."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b719e14a-561e-45d1-8a63-a0b9df104245/Reino-Fungi_6_14532.jpg",
        "alt": "A sculpture of a reclining woman with tattoos, adorned with colorful beads on her head, hung upside down with ropes in a dark setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/75db095a-931a-4b68-b3b0-3a65ff021e2f/Reino-Fungi_6_14460.jpg",
        "alt": "Performer with purple butterfly wings doing a handstand on stage, illuminated against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/bcb058e4-3575-4f88-9d26-52c075defa61/Reino-Fungi_6_14266.jpg",
        "alt": "A person hanging upside down in a dark setting, tied with ropes to a structure, with painted wings on their back, in a theatrical or artistic scene."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a49eac3b-a846-4a18-888a-cea3341af323/Reino-Fungi_6_14121.jpg",
        "alt": "Tattooed person wearing fishnet gloves lying on their side with their arm extended, surrounded by ropes, in a dark, artistic setting with purple and black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e596d807-720c-4459-80ad-82b54b65fe79/Reino-Fungi_6_14063.jpg",
        "alt": "A person with tattoos and a bejeweled headpiece, lying on a wooden surface, wrapped in ropes, with dark background and purple light effects."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/577994ca-9afe-41fc-a6cc-cb209ac7e3b9/Reino-Fungi_6_13968.jpg",
        "alt": "A person with tattoos hanging by ropes with a snake wrapped around their hand, in a dark setting with colorful lights in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fc4543ba-d2b8-4961-99f5-56077290b2b5/Reino-Fungi_6_13900.jpg",
        "alt": "A person with tattoos and jewelry, dressed in torn clothing, lying on the ground, surrounded by darkness and ropes hanging vertically."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/64f22f4f-3363-43d3-8bf3-2dce589291f6/Reino-Fungi_6_13603.jpg",
        "alt": "A person with body tattoos hanging upside down, with arms extended and head touching the ground, in a dimly lit environment with dark background and some colored lighting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/60e30cda-4c99-45a5-8afe-193645f7879f/Reino-Fungi_6_13464.jpg",
        "alt": "A person with tattoos and a decorative necklace is lying on a wooden swing hanging from ropes, suspended in a dark cave-like setting with rocky walls and a firelight glow."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/74c97953-0005-4ecf-bdd1-21ad9a499f90/Reino-Fungi_6_13816.jpg",
        "alt": "Person with tattoos and jewelry lying in a dark space, wrapped in ropes, with hands covering their face."
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "932935155",
        "poster": "/__l5e/assets-v1/7b57442f-9de1-4198-95f2-28f2508f505f/animalia-video-thumb.png"
      }
    ]
  },
  {
    "slug": "border",
    "title": "Border",
    "year": "",
    "lead": "",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a38f8d91-eb73-4e64-b6fe-bd689b82d796/luiza+prado+6.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4eb86390-b78a-4219-9166-e02a8afded41/luiza+prado+10.jpg",
        "alt": "Black and white photo of a naked person lying on their stomach, with hands placed on their back, framed within a white border and black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6cc96b51-3e6c-4d0d-91b8-09eabb2fee8f/luiza+prado+1.jpg",
        "alt": "A ball of black yarn on a wooden surface with a loose strand extending outward."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0269cb65-31d4-4160-bc3c-2e33e9f85376/luiza+prado+5.jpg",
        "alt": "Close-up black and white photo of a person's hand resting on their hip with fingers slightly curled, wearing a thin strap garment."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d575168c-0534-4de2-931c-6448a1f52e35/luiza+prado+2.jpg",
        "alt": "Close-up of a black rod or wire crossing over a lighter surface, with a circular object or ring attached at the center."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d031b1e3-b75b-4bb6-9807-5048f61aba72/luiza+prado+3.jpg",
        "alt": "A white bath bomb tied with black string, placed on a surface with a black background and a white border."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/33e436d2-d9ef-4f8f-9ca3-bc7e9898a418/luiza+prado+4.jpg",
        "alt": "A divided plate with a piece of meat, knife on the left, fork on the right, on a table with a placemat."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/34ec1707-873b-42ff-808c-a6f042608cf6/luiza+prado+6.jpg",
        "alt": "Blurred black-and-white portrait of a woman's face with a horizontal crack across the center."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/450e1629-c846-42a0-a7a6-f14b4afe1cfb/luiza+prado+9.jpg",
        "alt": "A black shoelace tied in a loose knot on a gray surface, framed within a white border."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4851cc40-50a0-4e1b-8bf9-ff29410c5dfd/luiza+prado+8.jpg",
        "alt": "Black and white photograph of a bird in motion, possibly a hummingbird, against a plain background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5daf0fc8-ac56-4dcb-81ef-5615b503f5e1/luiza+prado+7.jpg",
        "alt": "Close-up of a finger tied with black thread in a knot."
      }
    ],
    "videos": []
  },
  {
    "slug": "comissioned",
    "title": "Commissioned Photography",
    "year": "",
    "lead": "",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/78e20ee8-f0da-450a-b550-e9692717fa4c/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/dca198b2-2df3-4401-aecd-9811a4d4de06/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "Luiza Prado + Hajime Kinoko 2"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f6d2da58-114d-469f-9b8c-c4348161dd0b/oxumarie_luiza_prado_performance_ssa_mapping.png",
        "alt": "A person dressed in colorful, abstract clothing with eye patterns and a mask is standing in a desert landscape at sunset, with water at their feet, a moon and a sun in the sky."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3cb9c040-13e8-4371-a2a1-86d4f5d5ffd4/love_cabaret_luiza_prado_hifa_cybe.jpg",
        "alt": "Luiza Prado + Akira Nawa Love Cabaret"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1cd4449d-1889-45cb-b716-7927f753c4c9/luiza_prado_love_cabaret.jpg",
        "alt": "People watching a live performance on a stage with colorful, vibrant lighting in a dark nightclub or entertainment venue."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4855ab14-f7f3-48bf-9265-f1aca3306d83/performance_bdsm_artesanal_latex_luiza_prado_abitante.jpg",
        "alt": "Close-up of a dog with a braided leash, resting on a wooden floor inside a room with pink lighting. Part of a person's leg and foot are visible in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/71fef33b-6d36-494a-b9d6-a7290fec82bf/video_mapping_illustration_luiza_prado_sp.png",
        "alt": "Nighttime city street with a tall building displaying an illuminated billboard for Arts SP 3a. The billboard shows a graphic of a woman with long hair. The street below is busy with traffic, including buses and cars, with some streetlights and buildi"
      }
    ],
    "videos": []
  },
  {
    "slug": "corpo-estranho",
    "title": "Corpo Estranho",
    "year": "2012",
    "lead": "Corpo Estranho” in english Weird Body, was a performance made in 2012 about : sexuality - specifically sexual abuse - queer theory and erasure of the body both in the social and cultural spheres, specifically mentioning walkers and sexual professionals for their personal experience with these two media.",
    "body": [
      "The name “Corpo Estranho” was inspired by the book “A weird body: essays on sexuality and queer theory” by Guacira Lopes Louro"
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d3a49e0c-91d6-4a83-9d66-8d60a0dda471/corpo-estranho-hifa-cybe+%281%29.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/24d22b35-7b51-40fc-8e26-45218a614fb5/luiza%2Bjesus%2Bdo%2Bprado%2C%2Bhifa%2Bcybe%2C%2Bqueer%2C%2Bcorpo%2Bestranho.webp",
        "alt": "Four baby angels with white wings and towels, one holding a red starfish, on a white background."
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "161196586"
      }
    ]
  },
  {
    "slug": "cube-hajime-kinoko",
    "title": "The Cube - Hajime Kinoko",
    "year": "",
    "lead": "On-stage helpers: Monstrinho, Luminatus, Mako. Soundtrack: Mmoths",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3fd74f61-f654-4809-8f3d-4d2741ad836a/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2b893fb7-17df-4ccb-b20e-39986784b7b1/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "Luiza Prado + Hajime Kinoko 6"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8a11cb40-aa90-424a-9117-1e10772749df/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "Luiza Prado + Hajime Kinoko 4"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/81374d88-e666-498d-bcda-0bb1373276bb/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "Audience watching a bright red-lit stage inside a large theater or auditorium."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/dea3de08-d6f2-4fcb-b19a-a60eec142b20/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience_Opera_de_Arame.jpg",
        "alt": "A theatrical stage with five performers constructing a large geometric cube structure. The stage is lit with red and yellow spotlights, and a large red screen is in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a470d856-dae0-4dc3-b2b5-f59b0efdd31e/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "Concert hall with an audience watching a stage with large screens displaying a sunset scene, and a performer with structure in front. The interior has a domed wooden ceiling and stage lighting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3d73d6f9-1042-4c66-9d2b-193f0a4d2e38/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "Luiza Prado + Hajime Kinoko 7"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f027cbfb-5623-47d2-85ee-c4f3ad7e7d73/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "A woman with tattoos in black lingerie and red rope is standing on a ladder on a stage with a red background. The ropes are intricately tied around her body, suggesting a performance or artistry."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/408f156f-db85-44e7-8990-afc49fe9c018/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience_Opera_de_Arame.jpg",
        "alt": "A concert hall with a stage featuring fire effects and a pyramid art installation, audience seated in front, illuminated in red lights."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/72596ffe-6713-4e7b-8a05-3202db615691/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "Five performers standing in line on a stage, illuminated with stage lights, with smoke or fog in the background, black-and-white photo."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8dd5e289-51a0-4c1e-b4f1-feb8722799b8/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "A stage performance with a woman standing with her hands down, dressed in a revealing outfit with tattoos, while a man stands behind her. The background features a large screen displaying a red and orange sky scene, and stage equipment is visible inc"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/052b1d93-b349-4b6f-8039-487ec4a829a1/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience_Opera_de_Arame.jpg",
        "alt": "A woman climbing on a spherical structure made of ropes, with two other women on the ground, one on a ladder, as part of a performance or art piece in black and white."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/82d70634-363f-4e9e-9b8f-dad12060a4f3/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "Performance art scene with performers entangled in red ropes on a stage with dramatic lighting and smoke effects."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/70ca987b-5c4b-4961-9ac8-02cede8caed1/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "A wooden ladder leaning against a dark background, with a pile of tangled ropes on the floor below, and a red glow from stage lights reflected on the surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8c59e897-f408-4472-b7eb-952d775e626d/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "A person with short hair, wearing a sleeveless leather vest with studs, walking on stage with dramatic lighting, black and white photograph."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/800bfb71-e9d3-4178-8da5-154ff18dc53f/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "A performer dressed in black with tattoos and high heels is climbing an intricate red web-like structure on stage, illuminated by red and yellow stage lights."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/7c2b0893-a0cf-459e-af06-7fb11f139697/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "A man in black clothing with studs ties a red rope around a woman in black lingerie and high heels, standing on a dark stage."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9078327a-f082-4919-8c92-cef69c16e91c/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "A performer hanging upside down inside a red geometric metal structure on a dark stage, illuminated by red lights."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/35682b11-07cc-4b06-9d38-e753da169f26/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "A performer on aerial silk hangs upside down amidst a red web of ropes with stage lighting in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a56fe1f3-7209-4996-82ba-90e07586f36e/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "Audience seated in an auditorium, illuminated by warm, orange stage lighting, with some standing or clapping."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8c6989cd-bb60-4662-8580-709b3633396e/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "A performer hangs upside down inside a geometric metal framework during a circus or acrobatic show, illuminated by red stage lights."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8a30da5d-3e49-4157-89a4-8f43bd5ea2fa/Hajime_Kinoko_Luiza_Prado_Hifa_Cybe_Shibari_Experience.jpg",
        "alt": "Performer hanging inside a geometric wireframe cube on stage with red lighting and large screens in the background."
      }
    ],
    "videos": []
  },
  {
    "slug": "dance",
    "title": "Dance",
    "year": "",
    "lead": "",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c17f162b-81e1-4f13-9ad0-2ff63f3dd903/Prado.Dance_.jpeg",
    "images": [],
    "videos": []
  },
  {
    "slug": "deriva-de-edipo",
    "title": "A Deriva de Édipo",
    "year": "2013",
    "lead": "This performance was based on Voluntary Servitude Discourse of Étienne de La Boétie’s, the name “The Oedipus Drift” is an illustration of Oedipus, a personage of Greek mythology. The performance illustrates a society that, at the same time as it borders on tyranny, transforms itself into it, because it feeds on what kills it, the strings symbolize the act of being unconscious of not wanting freedom, but the strings are falsely imprisoned, symbolizing a lack of argumentative structure “No, the masses have not been deceived, they have longed for fascism at certain times, under certain circumstances, and this is what needs an explanation, this perversity of collective desire.” Reich quoted by Félix Guattari in The Anti Oedipus The live was held at SYNNFEST – Festival of Alternative Arts in São Paulo/Brazil in 2013.",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e99c8ab5-0a42-4a68-88a6-c9fd1c49fc9b/performance-hifa+cybe-a-deriva-de-edpo-3.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1439c87b-27ea-4f92-a175-0fa389dc04d0/performance-luiza-prado-a-deriva-de-edpo-1.jpg",
        "alt": "A person sitting with a large black object or mask covering their face, surrounded by tangled black strings hanging around and across the scene, in black and white."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/29167ade-5ff3-4ec3-8fce-eff6fe0c2b73/performance-luiza-prado-a-deriva-de-edpo-2-1.jpg",
        "alt": "A person wearing a hooded plastic bag mask surrounded by tangled strings or wires."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5bb69567-6e91-4c93-95a9-3bc6e0da5b2d/performance-luiza-prado-a-deriva-de-edpo-4-1.jpg",
        "alt": "A person with long dark hair sitting on a corner of a room, with arms and face covered in mud or dark paint, in a black and white photo."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ea97e308-6e8c-4cb2-b7f1-19640079a146/performance-luiza-prado-a-deriva-de-edpo-5-1.jpg",
        "alt": "A person with long dark hair sitting on a wooden floor, covered in mud or dark paint, with their head bowed and arms crossed over their knees in a dark, shadowy room."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b4494db6-b4f0-4cd7-a8a4-0be5ddfc4595/performance-luiza-prado-a-deriva-de-edpo-6-1.jpg",
        "alt": "A person lying on the floor, holding a sword in one hand, surrounded by scattered belongings, in a room with wooden flooring."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/72e5a9b6-5edb-4688-9353-a38cf4044f3c/performance-luiza-prado-a-deriva-de-edpo-3-1.jpg",
        "alt": "A person sitting on the floor with their head covered, surrounded by tangled wires or strings in a dark room."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/241679f4-7f3d-409f-85db-6ee4c664a736/performance-luiza-prado-a-deriva-de-edpo-7-1.jpg",
        "alt": "A person sitting on the floor surrounded by tangled strings or wires, with a wall in the background and a piece of furniture on the right."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/18a68db4-1612-4e08-b48e-7ebd367b6a82/performance-luiza-prado-a-deriva-de-edpo-8-1.jpg",
        "alt": "A woman crawling on the floor surrounded by spider web decorations in a room."
      }
    ],
    "videos": []
  },
  {
    "slug": "devir",
    "title": "Devir",
    "year": "",
    "lead": "The serpent, with its renewal and movement between worlds, reflects the trajectory of identities that challenge gender and sexuality norms. Oxumarê, orixá of the rainbow and duality, symbolizes gender fluidity and the constant transformation of these bodies, which balance opposites and resist social impositions. The work celebrates the creative force of transformation, showing how these bodies inhabit movement and transcend symbolic limits.",
    "body": [
      "Authorship: Sara Ahab (SE) + Hifa Cybe (SP)",
      "Soundtrack: Afro Hooligans - Chico Saiu para Caça",
      "Conceived and produced by Baluart Produtora and Agência Ilimitado, in 2024 the SSA MAPPING Festival is sponsored by Nubank and is held through the Federal Law of Incentive to Culture, the Ministry of Culture and the Federal Government.",
      "Editing: Alvaro Ribeiro (@alvaro.ribeiro)"
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f6d2da58-114d-469f-9b8c-c4348161dd0b/oxumarie_luiza_prado_performance_ssa_mapping.png",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/bd22769b-da3e-49ae-8238-ffb9987c456f/oxumarie_luiza_prado_performance_ssa_mapping.jpg",
        "alt": "Devir"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/de0b9663-708c-4b71-9325-c0bf841990ad/devir+hifa+cybe+4.jpg",
        "alt": "Building with colorful light projection, including celestial patterns and abstract shapes, at night."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9202d330-61ee-42c2-b879-472a1feed631/devir+hifa+cybe+6.jpg",
        "alt": "Nighttime projection on a historic building featuring a graphic of a crab, colorful abstract designs, and the words 'Mercado Modelo'."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9f44a220-7acf-4553-8b79-d3bab71249a0/devir+hifa+cybe+1.jpg",
        "alt": "Building with projected colorful light display featuring a woman with sunglasses and text about an event, including artist names and a music trail."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9e000135-14d8-494c-b254-8ed5b5bcbb65/devir+hifa+cybe+3.jpg",
        "alt": "A building with colorful light projections displaying art at night."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4357fbf6-ee8c-47b2-976f-d674c1f66b09/devir+hifa+cybe+5.jpg",
        "alt": "Nighttime projection of an eye with tentacles on a building face with text 'LIMBERADO MODELO' nearby."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/233eb061-38ed-4caf-9dfd-43fc00223e20/devir+hifa+cybe+11.jpg",
        "alt": "Building with colorful projections of abstract artwork on its facade at night."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3f83402c-f477-4fc5-af0b-e6e96afaebc2/devir+hifa+cybe+9.jpg",
        "alt": "Night scene of a historical building with a projection of colorful underwater coral reef and marine life on its facade."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/20aef23b-3040-4fd1-85c8-b7e09abd6114/devir+hifa+cybe+10.jpg",
        "alt": "Nighttime outdoor projection of colorful floral artwork on the side of a building."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/639de111-51d2-4786-9bf2-8d3c8526e5e3/devir+hifa+cybe+13.jpg",
        "alt": "Building illuminated with colorful, abstract light projections resembling fireworks or explosions at night."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/88cd2e6f-3c27-4aca-bb4a-425dbec68724/devir+hifa+cybe+7.jpg",
        "alt": "Night scene of a historic building with a light projection display, featuring colorful letters and lines, and the sign 'Museo Museo' on the facade."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/27d983fd-9836-4433-8ec2-41bffe4ea3ff/devir+hifa+cybe+8.jpg",
        "alt": "Nighttime projection mapping on the side of a large building, displaying colorful, abstract shapes in vibrant yellow, pink, purple, and blue."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8f6196c5-33ad-4165-80ee-9be89a2914ab/devir+hifa+cybe+2.jpg",
        "alt": "Building illuminated with colorful projection of a giant eye and abstract designs at night."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f9dc6e47-7734-41d3-9103-bf83f4b2973c/oxumarie_luiza_prado_performance_ssa_mapping.jpg",
        "alt": "A surreal digital illustration of a humanoid figure with a colorful, tentacle-like head and a mask, standing against a dark blue background. The figure has long black hair, tan skin, and is wearing red and purple patterned pants. There is a small ins"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8471639d-e4b5-4647-b930-c9cc16d365e1/oxumarie_luiza_prado_performance_ssa_mapping.jpg",
        "alt": "Colorful decorative mask with multiple painted blue eyes and multicolored tentacle-like appendages."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3189d4c8-4d7f-4067-9ae7-7263bb2af3cf/oxumarie_luiza_prado_performance_ssa_mapping.jpg",
        "alt": "A collection of colorful, shiny packaging and accessories, including artificial hair, candy, and a toy with eyes, laid out on a bright green surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/cb9df1dd-a544-4490-b412-b872db7fb832/oxumarie_luiza_prado_performance_ssa_mapping.jpg",
        "alt": "Colorful eye-themed masks, a bright yellow circular stand with multicolored tentacles, and rainbow-colored flame-shaped decorations on a wooden table."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8ef9089a-dec8-42b4-9b4b-37fbb1bf2cd9/oxumarie_luiza_prado_performance_ssa_mapping.jpg",
        "alt": "Hand holding a small colorful pinwheel, standing on a wooden floor next to a pink rug, with part of a red couch visible on the left."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1f549146-9eab-45a6-b337-d8d05815f743/oxumarie_luiza_prado_performance_ssa_mapping.jpg",
        "alt": "Person taking a mirror selfie in a studio with a green screen background, wearing a colorful mask and a dress with eye patterns, making a peace sign with their hand."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/7d78f5b8-ee11-4fe8-a744-a1858ba81d8c/oxumarie_luiza_prado_performance_ssa_mapping.jpg",
        "alt": "Camera screen showing a green screen with a person dressed as a traditional dancer, standing with one arm raised and holding a fan, a chair and lighting equipment nearby."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/15160f95-e8fb-4f67-8c18-eef4f1a05309/oxumarie_luiza_prado_performance_ssa_mapping.jpg",
        "alt": "A black crayon drawing of a mythical creature with the head of a lion, multiple horns, and a long, curving serpent-like tail. The creature has a fierce expression and flowing mane."
      }
    ],
    "videos": [
      {
        "provider": "youtube",
        "id": "pV07KN5fXMA"
      }
    ]
  },
  {
    "slug": "e-dai",
    "title": "E, dai?",
    "year": "2019",
    "lead": "Brazil has been experiencing a political crisis for a long time, which intensified with the Covid-19 pandemic. In January 2019, Jair Messias Bolsonaro was elected, faced with a scenario of political arbitrariness, since then it has been a controversial government that flirts with fascism and necropolitics.",
    "body": [
      "We can consider that the lack of structure and assistance to the most needy, including indigenous people, people living in remote and peripheral areas are more emergent in times of pandemic. In addition to the lack of aid, precarious conditions in the area of ​​health that is a daily occurrence in Brazil, our country also faces a political crisis (in addition to the economic that has been going on since 2014).",
      "During this period, two ministers of health, Luiz Henrique Mandetta and Nelson Teich, the exoneration of both, was specifically due to the direct interference of the president in health strategies against the corona virus, which has no medical or scientific training. Inspired by Trump, Bolsonaro wants to include chloroquine in the official protocol of the SUS (Public Health System) even though medically having several side effects and not having scientific proof of any efficacy in the treatment of the corona virus.",
      "Bolsonaro also referred to the Corona Virus as \"little flu\" and that people with \"athlete backgrounds\" were less likely to die from the virus. There was also speculation that the president had contracted the disease, and he, in addition to not publishing his examination, went out on the streets without a mask, inciting the crowd and coughing close to people.",
      "During the pandemic, the minister of justice, Sergio Moro, also resigned, claiming that the president wanted to intervene politically in the investigations of the Federal Police, recalling that allies and the president's family have specifically 6 cases being investigated by the PF, one of them the murder of city councilwoman Marielle Franco.",
      "The name of the performance \"E dai?\" it is about an interview that Bolsonaro gave, on Tuesday, April 28, when he was asked by a journalist about the deaths in Brazil, which at the time totaled 5,017 deaths, exceeding the total deaths in China, and his answer was: 'And? Am sorry. What do you want me to do? ’, Says Bolsonaro about coronavirus deaths; 'I am Messiah, but I do not do miracles'"
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8218867b-3ad9-4b05-b5f7-a467f104f879/luiza_prado_video_art_political_art.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/86b8e539-a14c-4ab4-8c87-3be17d361005/e_da%C3%AD__%282020%29_-_video_performance___hifa_cybe+%28720p%29_14110.jpg",
        "alt": "E, dai?"
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "424329715"
      }
    ]
  },
  {
    "slug": "entities-2",
    "title": "Entities #2 — Irid Duo",
    "year": "",
    "lead": "",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/361b3620-2091-4d86-86ae-a852b43672db/FINAL+LUIZA+11520.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/93ce502a-c10c-499a-9c1b-f57dff5d8df7/FUNDO+PRETO+DUPLA0098.jpg",
        "alt": "Close-up of a silver chain hanging in darkness with blurred background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1b077fed-f718-4955-b3ac-1e54f2273d24/FINAL+LUIZA+15081.jpg",
        "alt": "A man and woman embrace under the water, with water droplets on their skin and dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0caf7e07-097c-4113-b7ec-ea83c1210721/FINAL+LUIZA+14676.jpg",
        "alt": "A shirtless person sitting on the ground under rain with their eyes closed, leaning on another person who has their face near their shoulder, against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/59c5227e-4a2e-4b18-8574-be0fbee8154f/FINAL+LUIZA+14672.jpg",
        "alt": "A man and woman embrace under rain in a dark setting, with a textured wall in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b2d06fae-8da4-488d-aaa1-e7150213f223/FINAL+LUIZA+14590.jpg",
        "alt": "Two dancers in dark clothing perform in the rain against a dark background, with light highlighting their faces and bodies."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d731b300-d819-471c-a3e5-be91be4a230f/FINAL+LUIZA+13615.jpg",
        "alt": "Close-up of a sweaty person's face with closed eyes, lying down, with wet hair and a hand resting on their forehead, dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/630d2bee-3a19-4307-9894-fe6e035d4cf6/FINAL+LUIZA+12802.jpg",
        "alt": "A man and a woman standing close together under rain, with dark background and dramatic lighting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3f7df747-8431-44a9-9b94-277c4617c496/FINAL+LUIZA+12481.jpg",
        "alt": "Person holding chain in a dark, rainy environment"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/04ea29c6-b1be-4de0-8ecf-1be3fa3ed516/FINAL+LUIZA+12470.jpg",
        "alt": "A person wearing a dark hoodie and a chain necklace, holding a gun in a pouring rainstorm at night."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8eafb718-0802-4fa4-90ea-292b881d7e22/FINAL+LUIZA+12428.jpg",
        "alt": "A person with chains around their neck and wrists stands in the rain, with their head bowed and hands clasped near their face."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/210c5dc1-53a9-432e-b1df-dcfc15c15b70/FINAL+LUIZA+12318.jpg",
        "alt": "A person with wet hair and body, chains around their neck and arms, in a dark, rain-filled environment."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1de3143a-60c2-49c3-8041-f4a9e014f8e5/FINAL+LUIZA+12139.jpg",
        "alt": "Close-up of chained and weathered wooden structures with rain falling in a dark scene."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6d56a050-9511-43ff-adc1-9f2c62a2a7f8/FINAL+LUIZA+12129.jpg",
        "alt": "A dark scene featuring rain hitting a submerged wooden beam with hanging metal chains, in a moody, wet environment."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/19e824ee-0b13-47a1-8e37-612a33bd9714/FINAL+LUIZA+11909.jpg",
        "alt": "Two people, a woman and a man, are in a dark, rainy setting with chains around their necks and shoulders, appearing distressed."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8fc32645-98eb-4894-bebe-dffb00e3bfb2/FINAL+LUIZA+11623.jpg",
        "alt": "Two shirtless men in the rain, one with hands on his head and the other leaning forward with a chain around his neck, against a dark wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/66d3b990-b818-4f3a-b574-f05437312319/FINAL+LUIZA+11529.jpg",
        "alt": "A person with wet hair holding a chain above their head while another person stands behind them in the rain, with dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/415407fe-9178-4e64-b831-f05219a6902b/FINAL+LUIZA+11458.jpg",
        "alt": "Two shirtless men in a dark setting, one with a chain around his neck, appearing to be in a dramatic or intense moment, with rain falling around them."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c086519c-c40e-4526-87ae-bc4bae7cd6cd/FINAL+LUIZA+11172.jpg",
        "alt": "A person with wet hair is holding a chain in a dark, rain-soaked environment."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c1c685b5-602d-44b9-8498-3d39ddcc2700/FINAL+LUIZA+11082.jpg",
        "alt": "Two people in the rain, one sitting and one kneeling, with dark lighting and wet surfaces."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ec3b1805-827c-42ac-916b-cb2e96fffb0c/FINAL+LUIZA+11039.jpg",
        "alt": "A man and woman with wet hair and skin in a dark, rain-soaked setting, possibly a shower or outdoor scene, embracing closely."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c007d332-6f27-4127-8946-e7f58d2e27ae/FINAL+LUIZA+10635.jpg",
        "alt": "A shirtless man with a tattoo on his chest stands in the rain at night, with his eyes closed and head tilted downward."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0d601131-2ddc-4185-a4d0-db85f78876fc/FINAL+LUIZA+10414.jpg",
        "alt": "A woman with short hair in the rain, facing sideways, with water falling around her in a dark setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d775decd-b225-4993-a7a5-d8e517ef2ae0/FINAL+LUIZA+10375.jpg",
        "alt": "A woman with wet hair and tattoos on her shoulder and arm, looking at a man with wet skin from the back, both in a dark setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ba4c3f50-9a81-4fee-8062-77e0e02ac59b/FINAL+LUIZA+10308.jpg",
        "alt": "A woman with wet hair and water droplets on her face and shoulder, standing against a dark, textured wall in a dimly lit environment."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a0366231-a8ee-45fd-bfe5-e4b7771aab2b/FINAL+LUIZA+10214.jpg",
        "alt": "A woman with dark hair and makeup peeking out from a dark, shadowy environment, partially illuminated by a faint light source."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1ced4ded-f52f-4079-a825-f11353fe20d5/FINAL+LUIZA+10005.jpg",
        "alt": "A woman with short, wet hair and tattoos on her chest and shoulders rests against a dark, textured brick wall, with water on her face and minimal lighting highlighting her features."
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "1176132299"
      }
    ]
  },
  {
    "slug": "estender",
    "title": "Estender",
    "year": "",
    "lead": "",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9adb8edb-c315-4d2f-ab32-66524870be07/estender_luiza_prado.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/62be1f10-fb48-40f3-af6f-14991443c0fb/to_curate_yourself_project_-_estender_-_performance___hifa_cybe+%28720p%29_202877.jpg",
        "alt": "Estender"
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "144276523"
      }
    ]
  },
  {
    "slug": "fetiche",
    "title": "Fetiche",
    "year": "",
    "lead": "Menu: Ceviche, Sancocho, Pamonha, Café, Bolo de Fubá (pastel de harina de maíz) y Feijoada",
    "body": [
      "The performance proposes a reflection on the politics of marginalized bodies within sexual contexts. The body, covered by a latex bodysuit and mask, becomes an anonymous and fetishized surface where identity disappears, giving way to a territory of projection and consumption.",
      "By ingesting dishes such as feijoada, pamonha, ceviche, or sancocho, the action goes beyond the act of eating. These foods operate as symbols that condense colonial histories, subsistence economies, and cultural resistances. Their flavors, associated with contexts often labeled as “underdeveloped,” are brought into the performative space as materials of tension. The act of eating reveals the paradox between the celebration of these cultures and their simultaneous exoticization and exploitation.",
      "In this way, the performance establishes a mirror between the consumption of marginalized bodies in the sexual imaginary and the material consumption of territories and peoples positioned within structures of global inequality. Latex, as both a material of protection and fetish, intensifies this contradiction: what is hidden is also exposed, what is desired is also disposable.",
      "The black mask, in particular, alludes to processes of appropriation and erasure of narratives. In dialogue with Frantz Fanon’s _Black Skin, White Masks_, the work suggests that a mask is never neutral: it functions as a mediation between desire and violence, imposition and survival. If, for Fanon, the white mask embodies the pressure to conform to a colonial norm, here the black mask exposes the tension of carrying an identity that has been consumed, exoticized, and transformed into fetish.",
      "The performance seeks to strain the boundaries between pleasure, inequality, and resistance, inviting reflection on how the erotic, the economic, and the cultural intertwine in the lived experience of dissident bodies."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2e9fa5db-644e-40b4-97bc-bcac9a39b3a8/FOOD_11664.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b2fa1d0a-6233-4828-baa6-168080236470/FOOD_12488.jpg",
        "alt": "Close-up of lips with a lit joint resting on the lower lip."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/60715cf0-2497-4729-a8a8-8caa08ab5072/FOOD_10662.jpg",
        "alt": "Person holding an ear of corn in both hands."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3ede2603-3b10-4585-8ff7-2f71d22f543d/FOOD_13945.jpg",
        "alt": "Top-down view of a person with black hair and glasses giving a chicken a shot or injection in its neck."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4c0b44c8-9a11-48fe-aec4-1cf3752873fd/FOOD_10939.jpg",
        "alt": "Person wearing a black latex face mask and matching clothing against a pink background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/01b4cabb-8e1a-4efb-a6d0-acbfd606f267/FOOD_10071.jpg",
        "alt": "Black pot containing corn on the cob, apple, and chopped meat, with a hand holding a fork over the pot."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/dde21af8-af94-4c98-88ee-0f651c5270d7/FOOD_10387.jpg",
        "alt": "Person wearing a black ski mask and black leather jacket, sitting at a table with food, against a pink wall background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/944209c3-2709-45c3-a1a9-fe7a6759eac1/FOOD_10584.jpg",
        "alt": "Close-up of a person wearing a black helmet and face cover, with visible lips and nose, against a pink background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3053fae1-cb4f-4fab-b619-6064e33cd549/FOOD_11403.jpg",
        "alt": "A person wearing a black ski mask and black leather jacket, holding a spoon with some substance, against a pink background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/40f77dee-f098-436a-8826-e0c25c89b888/FOOD_12221.jpg",
        "alt": "Person wearing a black face mask and a form-fitting black outfit, touching their lips against their hand, against a red background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/38515c31-a600-4bdc-83f8-34bd7422836e/FOOD_12649.jpg",
        "alt": "Close-up of lips with lip piercing, smudged lipstick, and a small green object on the tongue, with part of a person's face and hair visible in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8853f3d2-9c42-477c-a7bc-47f5f4c96740/FOOD_12894.jpg",
        "alt": "Close-up of a black and white kitten with one eye and part of face visible, lying on a dark surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/78a595e3-2bb3-4983-a1a2-9ade2bb427e2/FOOD_13425.jpg",
        "alt": "A close-up of a dish containing cubed chicken, sliced red onions, and sliced green peppers in a creamy sauce."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a9ddeefa-d5b6-475a-8284-4ca4710c7c48/FOOD_14125.jpg",
        "alt": "Person wearing a black ski mask with eye and mouth openings, black leather jacket, leaning on their hand with tattoos visible on the arm, against a red background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6de56e27-5743-4883-9987-a0477dbbdb85/FOOD_14168.jpg",
        "alt": "Person holding a white mug with black coffee, wearing a dark top, tattoos on left hand, and dark long hair."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/477aa31d-89cc-4f01-9467-ba8e7792b7bd/FOOD_14527.jpg",
        "alt": "Person with tattoos eating a piece of food against a red background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/28a3de26-0856-4af2-aa06-6068a1868411/FOOD_14686.jpg",
        "alt": "A person wearing a black jacket holding two slices of toasted bread, with a pink background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a2a49360-d0de-4b9c-8e66-b65d2cd7b19f/FOOD_14852.jpg",
        "alt": "Person wearing a black mask, holding a piece of food in one hand and a bowl in the other, against a pink background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6823ac00-725c-4735-8b30-ce63728a7090/FOOD_15023.jpg",
        "alt": "Person holding a piece of food near their mouth with their hand, wearing a face mask, in front of a pinkish-red background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/791b41a9-8277-4b1a-8eed-4e7237be8729/FOOD_15160.jpg",
        "alt": "Close-up of a person's face partially visible, with a hand showing a tattoo, holding a black and gray ceramic mug with a carved face design, against a pink background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f0140586-0cb1-4a56-89f4-1835915be797/FOOD_14272.jpg",
        "alt": "Person wearing a black mask, holding a white mug, with tattoos on their fingers, and a pink background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/26ea4c80-3f82-42d2-99bf-44b71aca1a06/FOOD_15274.jpg",
        "alt": "Close-up of a person's face and upper body wearing a black and gray patterned shirt against a pink background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9d73ff0d-077a-4cd2-b5cb-efbc112ab473/FOOD_15015.jpg",
        "alt": "Person wearing a black mask and black clothing holding a yellow ice cream cone, sitting at a table with food and a pink background."
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "1126527725"
      }
    ]
  },
  {
    "slug": "memoria",
    "title": "Memória",
    "year": "",
    "lead": "",
    "body": [],
    "cover": memoriaFeto.url,
    "images": [
      {
        "src": memoriaFeto.url,
        "alt": "Two people lying side by side inside a cylindrical space, one with tattoos and wearing glasses, the other with tattoos, both resting with tubes connected to their bodies."
      }
    ],
    "videos": []
  },
  {
    "slug": "fundo-do-mar",
    "title": "Fundo do Mar",
    "year": "",
    "lead": "",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5781902e-3bbc-495b-8601-960dcf2e4f94/web.png",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/218dd584-b442-4b72-bf80-c1761d738f74/moldura.png",
        "alt": "A framed photograph of a nude woman curled up in a fetal position, set against a dark background, hung on a plain white wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/14f64a7e-b599-4e4e-bc8f-7c69948cc8e2/web4.png",
        "alt": "A woman with pale skin and brown hair sitting on the ground with her arms wrapped around her knees, against a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1ae8a1c9-8cf0-4fdf-a157-967817ae7806/web3.png",
        "alt": "Close-up of a person's arm and hand crossing their legs against a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0ed012a7-2379-446c-828c-0550a2cc93ad/web2.png",
        "alt": "Close-up of a curled finger against a dark background."
      }
    ],
    "videos": []
  },
  {
    "slug": "fungi",
    "title": "Fungi",
    "year": "",
    "lead": "",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/08f5da71-6646-478e-8bee-dfcbede5dd00/fungi_shibari_performance_luiza_prado.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/922d4305-72bb-4ca8-bfe1-6be48190c7e7/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10479.jpg",
        "alt": "A tattooed person with short hair, head bowed, with water or sweat on their face and chest, in a dimly lit setting with a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/495fd803-6ebb-41ab-875f-ef7c6a66cee2/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10363.jpg",
        "alt": "A woman with long dark hair and tattoos on her arms and shoulders, bound with red ropes, with arms extended. She appears to be in a dark setting with a faint circular pattern or artwork in the background, and water splashing or dripping on her face."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/90e2e4df-e23a-45a6-898a-44f57d3e3d3f/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10367.jpg",
        "alt": "A person with black paint or ink on their face and chest, with eyes closed, in a dark setting with a circular pattern on the ceiling."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/841f5a65-d8ab-4d25-b30e-d4b8522669b1/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10011.jpg",
        "alt": "Close-up of a sushi roll with fish, avocado, and rice in a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d969f678-1eb6-4ae4-9e49-d6242ccfd82e/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10544.jpg",
        "alt": "A person with dark tattoos on arms and torso, wearing black and red clothing, is blindfolded and restrained with red ropes, standing against a dark background with a large moon or celestial body in the backdrop."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/158c435d-16b5-4829-a27c-2858858ba86b/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10591.jpg",
        "alt": "A close-up of a person with tattoos and red ropes bondage around their torso, with a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d2196c90-794b-4fa7-a64c-f00507610885/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10633.jpg",
        "alt": "A woman covered in black paint with tattoos on her arms and torso, tied with red ropes, stands with arms outstretched in front of a dark background featuring a moon and draped fabric."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c32d9790-42b8-481c-8183-5f741ee15a2c/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10765.jpg",
        "alt": "A person with dark hair and a beard is suspended with red ropes, arms outstretched, in a dark room with a red curtain and a round, glowing light in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fd3d2f69-85f2-4216-987e-784e19a7fc7c/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10825.jpg",
        "alt": "Close-up of a person's upper body, covered in mud and grime, wearing a red rope tied in a knot at the chest, with dark hair and wet skin."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/871a75f7-3bd2-47c7-a6a8-120356dd9997/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10852.jpg",
        "alt": "Close-up of a person's lower face, showing wet black curly hair, dark skin with some blemishes, and a red and black rope or string tied around the neck, with a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6313a7e1-453c-41aa-aaff-b8260525a770/Reino-Fungi_Hifa_Cybe_Luiza_Prado_10955.jpg",
        "alt": "Close-up of a woman with wet skin, dark curly hair, and face makeup, with a red cord around her neck, set against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b897799f-be9c-4e55-9cc8-0fb2a9e65478/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11091.jpg",
        "alt": "Close-up of red shoelaces tied in knots on a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fe0c4978-8469-442f-bf60-0b8ef1d3589d/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11255.jpg",
        "alt": "A woman is chained at her arms with red ropes, covered in black and gold paint, standing in a dark room with a red and black backdrop and a red moon in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2c718871-aa5d-4622-8ce4-7c5841937804/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11305.jpg",
        "alt": "Close-up of a person's face with black beads on the forehead and neck, and face paint, against a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/773b9b8b-6630-46f4-9f7f-abd256a40f9e/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11417.jpg",
        "alt": "Close-up of a person's arm with tattoos and dirt, with a focus on the tattooed skin and a person's face partially visible."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0efdb52f-c156-4add-a6aa-8a3a476f89ff/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11391.jpg",
        "alt": "A person with half of their face covered in black insects, staring upwards with visible eyes and skin details in a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/58b784c0-726d-4f56-9113-f1eff279009e/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11467.jpg",
        "alt": "Close-up of a person's arm with dark skin, tattoos, and wearing a sparkly black and red garment, against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/63e7b37b-98f1-4a03-a3f0-f591bbc5c809/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11568.jpg",
        "alt": "A close-up of a bow and arrow, with a wooden bow and red fletched arrows, set against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/51fab22e-1798-4b4f-abb3-a525bde2aca4/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11705.jpg",
        "alt": "A tattooed woman with black hair poses with her arms outstretched, tied with red ropes, wearing black and red clothing, in a dark setting with a circular art piece in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e5d97fe7-00b0-4297-a8cb-9976354dd47c/Reino-Fungi_Hifa_Cybe_Luiza_Prado_11900.jpg",
        "alt": "Close-up of a tattooed person's neck, shoulder, and arm with black ink tattoos, red rope necklace, and dark hair, against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3cbe3805-d624-4028-9f4c-038f88fe9245/Reino-Fungi_Hifa_Cybe_Luiza_Prado_12026.jpg",
        "alt": "Close-up of red shoelaces tied in knots against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a21b96b6-1c60-454a-95f1-5beecb0686e6/Reino-Fungi_Hifa_Cybe_Luiza_Prado_12101.jpg",
        "alt": "Close-up of a person's chest and hands, with tattoos, tightening a red shoelace on black clothing."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d89da888-fe82-452a-95f8-84efaaee210e/Reino-Fungi_Hifa_Cybe_Luiza_Prado_12173.jpg",
        "alt": "A noose made of red rope tied to a wooden stick, with a black spider on the stick, against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3eac9b1a-7f40-44f4-81f1-d0dfa29429b2/Reino-Fungi_Hifa_Cybe_Luiza_Prado_12336.jpg",
        "alt": "Close-up of a tattooed arm with pinkish circular tattoos resting on a dark surface. The person is wearing black and red striped clothing and accessories with red strings."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c5793d0a-fa06-456d-932f-4378981a9b2f/Reino-Fungi_Hifa_Cybe_Luiza_Prado_12395.jpg",
        "alt": "Close-up of a foot wearing a black fishnet stocking with torn edges, red shoelaces, and red underwear visible at the bottom of the image."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4ca089a4-c762-4f70-bc58-37c26f48ee75/Reino-Fungi_Hifa_Cybe_Luiza_Prado_12411.jpg",
        "alt": "Close-up of a red basketball hoop net against a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/40cbffcd-98f9-4dbe-9068-1928960d66d2/Reino-Fungi_Hifa_Cybe_Luiza_Prado_13090.jpg",
        "alt": "Close-up of a burned, scarred chest with blackened skin, partially covered by a red harness or string, illuminated in low light."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4db7feac-4720-457b-aeec-e067be1867f3/Reino-Fungi_Hifa_Cybe_Luiza_Prado_13307.jpg",
        "alt": "A person covered in mud and tattoos, wearing a red rope harness and black jewelry, with a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1d8302ee-5baf-4b90-b86b-a7433e52e740/Reino-Fungi_Hifa_Cybe_Luiza_Prado_13583.jpg",
        "alt": "A person with tattoos on their chest and arm is covered in mud, with a black substance on their face and beard. They are wearing a red strap around their neck."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5d003bcc-032d-4479-8793-09a425e66a15/Reino-Fungi_Hifa_Cybe_Luiza_Prado_13962.jpg",
        "alt": "A hand with long, decorated nails, gripping red fabric in a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a6b26931-204a-44db-b82a-a36ecc7bbde5/Reino-Fungi_Hifa_Cybe_Luiza_Prado_14657.jpg",
        "alt": "Person performing a traditional or artistic dance with extended arms, dark background, and dramatic lighting, with a moon or planet in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/934e4bdc-6b28-4768-9425-f058f660934b/Reino-Fungi_Hifa_Cybe_Luiza_Prado_14996.jpg",
        "alt": "A performer, kneeling on stage with arms outstretched, wearing a black mask and body paint, with a backdrop resembling a planet and red fabric draped around her."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a99996b3-5a3b-4a0d-828d-02b6b4070e0e/Reino-Fungi_Hifa_Cybe_Luiza_Prado_15362.jpg",
        "alt": "A woman with dark hair and glasses, wearing a black lace shirt with floral pattern, leaning forward in a low-light setting."
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "932934707",
        "poster": "/__l5e/assets-v1/c4148b34-f372-4b4b-a4ae-97970698e5f0/fungi-video-thumb.jpg"
      }
    ]
  },
  {
    "slug": "girl-gas-mask",
    "title": "Girl with the Gas Mask",
    "year": "2012",
    "lead": "When I was around five years old, I began to have recurring visions of a family wearing gas masks. This image would appear specifically whenever I looked toward my family’s house down the hallway. The vision of the gas mask family always seemed to coincide with moments when bad things were happening in my life. Because of this, I came to associate that image with deeply negative feelings. Experiencing these visions was painful, and I often had nightmares about this gas mask family — they robbed me of peace of mind.",
    "body": [
      "When I was 23, I decided to transform this haunting image into a staged photograph. After finding the models for the shoot, there was no doubt in my mind that I would give them a happy ending. I had lived for too long with the suffocating presence of this heavy-masked family and all the sorrow attached to them. The turning point came when I created and photographed _The Gas Mask Girl (2012)_ — the image shown above. In photographing the girl wearing the gas mask, I borrowed her presence to help me process and purge the emotional weight carried by those visions.",
      "The experience was liberating. It felt as though I had finally removed the filter of my own imaginary gas mask and could breathe freely. I allowed myself to be “contaminated” by this staged girl — and through her, I stepped into a new phase of life, even though the chaos around me remained. That photograph definitively freed me from the ghostly visions of the gas mask family.",
      "I believe that transforming my vision into an object — in this case, a photograph — enabled me to reprocess my past experience and the pain attached to it. Eloa, the girl who posed for the image, became a mirror of myself: she was about the same age I had been when the visions first began. I wanted Eloa to know how important she was in my life, because she offered her presence and seriousness so that together, we could complete this act of catharsis."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/27b70ef7-0511-49dc-ad18-4cc1276da700/menina_da_mascara_de_gas_luiza_prado.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/83cb88fd-4cab-4c97-a418-d76651b1a548/frame-mockup-interior-3d-rendering.png",
        "alt": "A child wearing a gas mask, holding a bouquet of flowers, standing in an industrial or workshop setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a71a2b5b-ab08-45d8-8218-4b568de4a4e8/12140108_1233630746662937_4260025733726553663_o.jpg",
        "alt": "A woman with long dark hair, tattoos on her arm, and wearing a sleeveless top, helps a young girl put on a gas mask. The girl is holding a bouquet of pink and white flowers and is wearing a gray dress. They are indoors, with a rustic, industrial setting in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b941d28c-5ddc-43fb-a025-2b50a9c651a7/luiza-prado-menina-da-mascara-de-gas-2+%281%29.jpg",
        "alt": "A woman holding a bouquet of flowers receives a kiss on the cheek from another woman in a workshop or storage area."
      }
    ],
    "videos": []
  },
  {
    "slug": "gula",
    "title": "Gula",
    "year": "2016",
    "lead": "‍“Gula” talk about the fetishism of commodity, based in Karl Marx’s critique of the social and psychological phenomenon in which goods appear to have an independent will of its producers. The BDSM (Bondage, Discipline, Sadism and Masochism) aesthetic alludes to two products (girl and watermelon) and their measures, guiding properties that affect their usefulness and values that is based only on the currency and the third object which denominates the social relationship between the whole, hunger. Self-consuming, self-abort and swallow, the ideologies that the system imposes on us and so develop one of the capital sins, Gula, as we consume something that we need and are playing a part in a social theater. The photo was inspired by Saudek and the performer is Miss Tibia. Gula participated in several exhibitions such as “Trabalhadores do Cú” at Espaço Cultural Maus Hábitos in Portugal in 2016, Scope Art Fair in Miami in 2014, in addition to being part of the permanent collection of the Museum of Contemporary Art in Bogotá, he has also participated in several exhibitions at the Museum like Medusa Mujer, Political Bodies, ABRAHADABRA. It has also been published in Digital Photographer magazine.",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ad15c5e5-f8ef-421e-ad83-7cf449bd27c0/luiza%2Bprado%2Bexhibition.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/daa48c1b-eb3d-4fe1-9a34-31208be53936/gula-emilia-luiza-prado+%283%29.png",
        "alt": "A woman with short dark hair, tattoos, and minimal clothing sits on the floor with her legs spread apart. She has her mouth open and appears to have a mechanical or metallic device on her head. In front of her, there is a large, smashed watermelon with the inner flesh exposed. The background contains industrial machinery and equipment in a dimly lit, gritty setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/003c23db-571f-4ac5-b305-a0179ecb76e2/Luiza-Prado-Gula-2.jpg",
        "alt": "Upside-down image of a young child with glasses, holding two pieces of bread above their face."
      }
    ],
    "videos": []
  },
  {
    "slug": "i-miss-you",
    "title": "I Miss You",
    "year": "",
    "lead": "The devastation of the feminine begins in its vital energy, in search of \"power\" and it is these relations of power and of absence, that women who have already left, struggling, do, is what this performance speaks about. A circle of fire recalls pagan rituals, but also the burning of women during the Inquisition. Nature, vital energy, ablaze, a female body amidst the circle of fire, wearing social clothing and a sash and crown of Miss, \"the place of acceptance of the feminine, not the place where I wanted to be.\" The saying; \"I MISS YOU\" and the position in which gods pose in their paintings, figurines, symbols, and in the hand, a vagina-like sore.",
    "body": [
      "Like the 9 phases of the moon, but this time, on fire as the sun, burns 9 sheets of paper written front-of-verse with names of women victims of feminicide in various languages, as a nature that connects and inspires change and evolution; I miss you, we miss you."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/19c4a1a0-fa49-4409-9896-1c237d816395/i-miss-you-luiza-prado+%281%29.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8b4c4515-e13b-4225-847a-77aea9859854/Performance+-+I+Miss+You+_+Luiza+Prado+%281%294518.jpg",
        "alt": "I Miss You"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/408f026e-74af-4710-91c9-995335698884/Performance+-+I+Miss+You+_+Luiza+Prado+%281%295117.jpg",
        "alt": "Close-up of a person’s hand and part of their face, with a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9764accd-58af-4381-a17c-2ed6983780fd/Performance+-+I+Miss+You+_+Luiza+Prado+%281%293276.jpg",
        "alt": "Person standing by a fire circle on a rocky surface in a wooded area."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/adde5e76-7ff4-474e-bfbf-a851fad32d99/i-miss-you-3-1200x600+%281%29.jpg",
        "alt": "Paper documents and dried leaves burning on the ground with flames in the center."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/954d4984-18a2-44d4-af19-021b9ef6ce73/Performance+-+I+Miss+You+_+Luiza+Prado+%281%294148.jpg",
        "alt": "A person standing on a rocky surface near small fires with trees in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/91301aac-5461-4444-896a-8cb550bf8758/Performance+-+I+Miss+You+_+Luiza+Prado+%281%293476.jpg",
        "alt": "Explosion near trees with fire and smoke"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6452b510-2e56-4965-82ae-55485487744d/hifa+cybe+i+miss+you.jpg",
        "alt": "A handwritten letter on paper is burning on the edges, with flames visible on the right side of the image. The letter appears to be outdoors, placed on burnt debris or ashes."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/daabc61b-f1f6-42d9-9317-96e78b7f6ebd/i-miss-you-3-1200x600.jpg",
        "alt": "burning paper on a concrete surface with ashes and scorched paper around it."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/335a3010-6c8c-486d-b8af-552bea5735fe/Performance+-+I+Miss+You+_+Luiza+Prado+%281%294612.jpg",
        "alt": "A handwritten letter burning on a fire, with visible flames."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f464162c-7c8c-4afa-8a1d-c1c3fd02ee9e/Performance+-+I+Miss+You+_+Luiza+Prado+%281%292292.jpg",
        "alt": "A person's hand is raised near their face, with a dark background of tall green plants. The person is wearing a black outfit and a white sash with blue lettering."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2fbf783c-8e57-401d-8cb0-a39eeddd810e/Performance+-+I+Miss+You+_+Luiza+Prado+%281%292309.jpg",
        "alt": "Bright orange and yellow flames with black smoke, possibly from a fire or burning debris."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c87bfd57-6a70-47bb-b927-89b71e8c9647/Performance+-+I+Miss+You+_+Luiza+Prado+%281%292636.jpg",
        "alt": "Person standing on dark, rocky ground with flames on the ground in front, in a wooded area."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ca038904-a091-437e-932c-85b1c9ed2301/Performance+-+I+Miss+You+_+Luiza+Prado+%281%295292.jpg",
        "alt": "Close-up of a person holding a striped cloth or bag outdoors."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f3f61447-245b-44c2-bc38-5a4ad29cd30e/Performance+-+I+Miss+You+_+Luiza+Prado+%281%295373.jpg",
        "alt": "Close-up of a person wearing a jacket with a water-resistant pack or item with large printed letters."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3e74af13-e0ff-4ca2-a114-a283914f6989/Performance+-+I+Miss+You+_+Luiza+Prado+%281%293724.jpg",
        "alt": "Open flames with visible fire near logs or wood in a dark outdoor setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1327a005-f119-4822-9445-8ff9650d40dd/Performance+-+I+Miss+You+_+Luiza+Prado+%281%295477.jpg",
        "alt": "Close-up of a decorative fabric badge with the Roman numeral XII and XVIII, surrounded by ruffles and beads."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/90ce09da-1d5d-4a42-b71b-82652bc59dd7/Performance+-+I+Miss+You+_+Luiza+Prado+%281%295518.jpg",
        "alt": "Burned paper with flames on a rock surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c63d7070-8da4-4321-b2df-8f486e2c8ea5/Performance+-+I+Miss+You+_+Luiza+Prado+%281%292884.jpg",
        "alt": "A fire burning on a dark surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f696ad77-9b9a-490e-8bc4-988ad795eb1f/Performance+-+I+Miss+You+_+Luiza+Prado+%281%295653.jpg",
        "alt": "Close-up of a small fire burning on the ground near a large piece of ice or snow."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/81a09d68-6f43-4fc4-9405-91aeff9b5def/Performance+-+I+Miss+You+_+Luiza+Prado+%281%296220.jpg",
        "alt": "A burning object on the sand with visible flames and smoke."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9985ff58-96e8-473d-9512-ef13a84a9c0b/Performance+-+I+Miss+You+_+Luiza+Prado+%281%296326.jpg",
        "alt": "Flowing lava with visible flames on the surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f2f0216d-9df1-4772-ab83-dd2d3a6bc302/Performance+-+I+Miss+You+_+Luiza+Prado+%281%296597.jpg",
        "alt": "Burning logs on an outdoor fire pit with flames and smoke"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/85302e2a-457e-4356-8072-56f3ccc4f583/Performance+-+I+Miss+You+_+Luiza+Prado+%281%294893.jpg",
        "alt": "Person standing on rocky terrain near a dense forested area."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5269497d-bc7e-4f2c-aef4-9e7563c20362/Performance+-+I+Miss+You+_+Luiza+Prado+%281%293998.jpg",
        "alt": "Fire burning along a line on the ground."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ac094d74-f87b-4dee-9264-3bcf6fa747b6/Performance+-+I+Miss+You+_+Luiza+Prado+%281%296005.jpg",
        "alt": "Person standing near a circular pattern of burning flames on a rocky surface with bushes in the background"
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "235166337"
      }
    ]
  },
  {
    "slug": "indigesto",
    "title": "Indi-Gestão",
    "year": "",
    "lead": "In this performance, the artist ingests her own voter registration card. The act transforms a bureaucratic document into organic matter, shifting it from the domain of institutional identity to that of the body.",
    "body": [
      "The title _Indi-gestão_ operates as a double meaning in Portuguese, evoking both “indigestion” and a fractured notion of management or governance. Through this gesture, the work reflects on the uneasy relationship between the individual body and the structures that claim to represent it.",
      "By eating the document that certifies civic participation, the performance collapses the distance between political identity and physical existence. What once functioned as proof of citizenship becomes something to be metabolized, rejected, or absorbed.",
      "The act suggests a political system that is difficult to digest, where participation, representation, and authority circulate in unstable forms between institution and body."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/56d2a3fc-9662-4d08-bf15-b990226f22ee/indigestao-luiza-prado-1-1200x600.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/03abe7dc-382c-4cae-98ea-cdd3aef83c87/indi-gest%C3%A3o_performance___hifa_cybe+%281080p%29_12988.jpg",
        "alt": "Indi-Gestão"
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "181019759"
      }
    ]
  },
  {
    "slug": "mergulho",
    "title": "Mergulho",
    "year": "",
    "lead": "In this video installation in the format of a long vertical strip, a woman and a man, dressed in the water element, slowly sink into the ocean waters until they disappear at the bottom.",
    "body": [
      "The work invites the viewer to reflect on the correlation between diving in water and diving into the unconscious, exploring the hidden layers of the human psyche and confronting one's own inner abysses.",
      "Water, a fundamental element for life, evokes the idea of returning to our primordial roots. The oceanic depths suggest a solitary journey of introspection, a desire to escape the chaotic and warlike contemporary world. The act of sinking into the water can be interpreted as a search for a world free from tension. The ocean, like a silent refuge, becomes a place where it seems possible to suspend time and calm the mind.",
      "Asphyxiation or freedom? Peace or passivity? Deep or narrow? Fae or phobic? Ocean or unconscious? Water or sorrows? Lightness or hardness? The work is an invitation to confront the “monsters of the deep” themselves and to reflect on the correlation between diving in the waters - the origin of life - and the hidden layers of the human psyche.",
      "This work was developed together with the visual artist and performer Maurizio Mancioli. Maurizio Mancioli is an Italo-Swiss visual artist based in São Paulo, Brazil. His works include photography, painting, drawing, video and performance. As a reflection of his own nature, his works examine states of isolation, memory, as well as reality and fiction.",
      "This work was developed at Acquabox is both a design masterpiece and a therapeutic device by Maurizio Mancioli."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/11258bd5-7d1b-46b9-8d64-2dd4e708e899/mergulho_ccbb_luiza_prado_maurizio_mancioli_acqua_box.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2300308a-7411-4829-b423-1a94a7eb705b/mergulho_ccbb_luiza_prado_maurizio_mancioli_acqua_box.jpg",
        "alt": "A woman in a black top is underwater, floating with her eyes closed and bubbles rising above her head."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/35e3e818-87c4-454c-9dfd-57b6323a9390/mergulho_ccbb_luiza_prado_maurizio_mancioli_acqua_box.jpg",
        "alt": "An art installation in a museum featuring a tall, black rectangular display with a projected image of a person in mid-air, possibly performing a dance or acrobatics, surrounded by informational signage."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2d39ec91-a760-4b5e-be79-90348888d435/mergulho_ccbb_luiza_prado_maurizio_mancioli_acqua_box.jpeg",
        "alt": "An art installation with a large vertical screen displaying an underwater scene with a swimmer, illuminated in blue light inside a dark room."
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "931828331"
      }
    ]
  },
  {
    "slug": "mortuary-portraits",
    "title": "Effigies - Mortuary Portraits",
    "year": "",
    "lead": "_Pudor_ is a video-performance that investigates the mechanisms through which sexuality can be silenced, regulated, and denied within rigid religious contexts. The work centers on the experience of having one’s sexual subjectivity suppressed by a community structured around moral restraint and spiritual dogma.",
    "body": [
      "At its core, the piece addresses vaginismus not only as a physiological condition, but as a psychosomatic manifestation shaped by repression, shame, and the absence of dialogue about the body. Within this environment, sexual pain becomes unspeakable, as religious belief systems override the recognition of sexual health and autonomy.",
      "In _Pudor_, violence is not portrayed as an isolated act, but as a diffuse and collective force. It emerges through omission, silence, and the normalization of denial. The work reflects on how communities that refuse to acknowledge the value of sexuality can inadvertently produce forms of structural violence, inscribing control and guilt onto the body itself."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/66495250-f254-49d1-b0db-2bcdb34c8b05/familia+luiza+prado.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fda508f2-9b53-41f8-8d57-e0b8e474ce6a/luiza-prado-photo.jpg",
        "alt": "An artistic photo showing a man with hands on his face and chest, reflected symmetrically to create a mirror-like image."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/7580bbbc-35fc-4312-b491-f541a5f05336/retratos-luiza-prado-1.jpg",
        "alt": "A woman with clown makeup, dark eye makeup and tears painted on her face, wearing a ruffled, light-colored costume, looking somberly at the camera against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/59355f9b-bfea-47d7-8142-4a27d6e9a5b6/retratos-luiza-prado-6.jpg",
        "alt": "A woman dressed as a nun with her top parted, holding her breasts, against a dark background with a halo-like glow around her head."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/17eacbc6-0eb8-4a61-a098-2e30f62cb065/retratos-luiza-prado-7.jpg",
        "alt": "A woman with long brown hair and bangs, wearing dark makeup, has a serious expression. She is dressed in black and is set against a dark background with abstract, faintly glowing lines and two small rocks or crystals in front of her."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f49f77b0-e3fc-403f-9b5a-548e9be83435/retratos-luiza-prado-2.jpg",
        "alt": "A person covered with a red cloth, with part of their torso and legs visible, against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/454f7d9e-38dd-41e0-8411-bcae30111313/retratos-luiza-prado-3.jpg",
        "alt": "A woman with dark hair and pale skin, wearing a dark hooded cloak, stands against a dark background with a faint circular light behind her head."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f1d83a00-64f5-449c-b204-d1708951c371/retratos-luiza-prado-4.jpg",
        "alt": "A person taking a mirror selfie dressed in lingerie with a rabbit mask, revealing a partly nude body, in a room with vintage-style wallpaper and various clothes on the floor."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/48c3de8e-9df2-4f46-ab07-2fe0ade79377/choro-luiza-prado.jpg",
        "alt": "A woman lying upside down with her hands covering her eyes and wearing a cloth gag over her mouth, with curly blonde hair around her head."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/82181831-b34a-4e89-8878-518dd360e7a5/retratos-luiza-prado-5+%281%29.jpg",
        "alt": "A woman with curly hair, partially submerged in darkness, is holding her chest with her hands. Her eyes are obscured by horizontal lines and her face is tilted upwards."
      }
    ],
    "videos": []
  },
  {
    "slug": "naltura-dos-olhos",
    "title": "N'altura dos Olhos",
    "year": "",
    "lead": "",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4e7845d4-89db-4e33-a708-a487b716a17a/12615773_1552701798381225_5292040960145096789_o.jpg",
    "images": [],
    "videos": []
  },
  {
    "slug": "o-estado",
    "title": "O Estado (Performance) & Castração (Object)",
    "year": "",
    "lead": "The tattoo was made on the central axis, purposely to cause tension in the spine and the peripheral nervous system.",
    "body": [
      "Classified as an extension of the central nervous system (CNS), the spinal cord consists of the encephalon and spinal cord. It begins in the lower part",
      "of the brainstem and terminates in the lower dorsal part, thus forming the medullary cone.",
      "A collection of nerves, known as the cauda equina, leaves the lower part of the spinal cord (medullary cone) and serves to provide us sensibility",
      "The tattoo as done in this region, causes involuntary movements and pain in other parts of the body, where the tattoo is not being done, in addition",
      "to dizziness and headaches. The intention is in every action, the tattoo be done within the stroke, until one day, this whole map is painted red.",
      "The countries of Latin America walk together, strain together and the red symbolizes blood but also revolution, that after the tattoo, the blood",
      "is staked in a white fabric, like a flag."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/89224f37-8eff-4ba0-8014-613ecd32d7a2/castra%C3%A7%C3%A3o_political_art_luiza_prado.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fff9a609-4589-4d03-bc43-021be9303ea6/Imagem13.jpg",
        "alt": "Side-by-side images of small metallic mechanical parts, possibly components of a machine or tool, with a dark grey finish."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d4105173-7f98-496e-8f4d-80b9cedf86f4/Imagem11.jpg",
        "alt": "O Estado (Performance) & Castração (Object)"
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "272140565"
      }
    ]
  },
  {
    "slug": "o-passaro-agoniza",
    "title": "Psicopompo - O Pássaro Agoniza",
    "year": "",
    "lead": "Psychopompus is the word that originates in the Greek psychopompós, junction of psyche (soul) and pompós (guide), designates an entity whose function is to guide or lead the perception of a human being between two or more significant events. Inner guide, the psychopomp can be of human nature, (Ariadne), animal (rabbit, from Alice in Wonderland) or spiritual (Hermes, Daimon). Archetype present in most mythological registers, dreams, films and popular tales, it arises spontaneously and assumes the task of revealing a symbol or guiding meaning, necessary for the continuity of the individual trajectory of those who find it. According to the Critical Dictionary of Jungian Analysis: “The figure who guides the soul on occasions of initiation and transition: a function traditionally attributed to Hermes in the Greek myth, for he, besides messenger of the gods, was the god who accompanied the souls of the dead , being able to transit between polarities (not only death and life, but also night and day, heaven and earth)",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/63d085be-95a2-4924-81fb-0e798ec6e65e/psicopombo-hifa+cybe.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/cd7096c9-364b-4131-b088-c6a051952a3c/o-passaro-agoniza-hifa+cybe+%281%29.jpg",
        "alt": "Black and white photos of people working or performing on a stage with musical equipment."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0d6a1ebf-5318-42c4-a225-84a719b13c10/10384585_1041594392533241_1825798864308778713_n.jpg",
        "alt": "A person lying on the floor with long hair, resting their head on their arm. Several guitars are leaning against the brick wall, and there is audio equipment, including speakers and a mixer, on the right side of the image. The setting appears to be a"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fe7d521e-06cf-4cbd-b0f4-68efcfd57943/hifa+cybe+%281%29.jpg",
        "alt": "A silhouette of a person with pig ears and a pig snout seen in front of colorful stage lights."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ace68148-4be2-4534-ba28-eb8553091c61/print-video-hifa+cybe+%281%29.jpg",
        "alt": "A woman with long dark hair wearing a red dress is leaning forward and touching the ground with her hands, with her head bowed down."
      }
    ],
    "videos": []
  },
  {
    "slug": "pai-afasta-de-mim-esse-calice",
    "title": "Pai, afasta de mim esse cálice",
    "year": "",
    "lead": "For this performance, I counted at least 10 men and the act would be me in the crucifixion position, but without the cross, because it brings us back to the masculine figure and I wanted the female figure to be the center of the action. In this action, I am the mirror and I am willing to suffer this humiliation and I make it possible and a group of men in line must urinate on my feet, one at a time.",
    "body": [
      "My first analysis was that for the sake of this feasibility of wanting to suffer this \"supposed\" humiliation and face a concept of subalternity while placing this sign mirroring the other, thus exalting a pulse and a \"negative\" attitude that many deny having and, having as a backdrop, the outline of a male figure, however, a woman's body, naked, in order to deface and deconstruct signs assigned to me, culturally by them.",
      "I've been trying to carry out this performance about a year and during the first attempt when I was undressing, I was blocked by the police, so, during the second time I decided to approach people and perform the act in an abandoned school in Cambuci - SP. I approached several people and initially my priorities were: artists, actors from liberal or LGBT theaters, people involved with fetish and sex professionals. During the entire process, about 80 people were approached, but many of these people did not answer me, a few stopped speaking to me and others blocked me from social networks."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fa321c46-7760-4ce4-9bd4-e7bc353b101b/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%290989.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2330f5f4-14cc-4c6c-9f52-db5ee43cb234/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%290429.jpg",
        "alt": "Close-up of a clear glass of water on a dark surface with a light background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/40d94186-60ca-49a6-9799-9fe771012402/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%291305.jpg",
        "alt": "A shirtless person wearing a black ski mask, standing against a plain beige wall with arms outstretched, and tattoos visible on their left arm."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/734f28f7-c60a-4c8b-b534-f629fb43a5d7/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%292061.jpg",
        "alt": "Close-up of a person holding a glass with a light-colored beverage, possibly a cocktail or drink, against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a1ea95f3-dcdd-483e-af93-f03ebed2968d/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%298248.jpg",
        "alt": "Close-up of a finger pointing towards a plain white wall with a black vertical strip on the left side."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b3c1b584-1701-4fcd-b0f4-5401fdfb37d5/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%292735.jpg",
        "alt": "A shirtless person wearing a black ski mask with eye and mouth holes, standing against a plain light-colored wall with arms outstretched."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/541eee2f-9163-4897-ba87-feaaa63685e6/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%294860.jpg",
        "alt": "Reflection of a person standing in a room with blonde hair, visible tattoos on legs, black shoes on the floor, and a plain wall in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/007f75c5-e9fc-4e50-8dbb-866ffd0391df/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%296134.jpg",
        "alt": "A close-up view of a corkscrew inserted into a wine bottle opening, with a partially filled wine glass in front."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/422af5ee-de21-45cf-9ddd-25ddf665ef76/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%296240.jpg",
        "alt": "A person holding a dark-colored mug with foam on top, in a dark environment."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/da631d6a-5a94-4fb5-9b57-0a92529d241b/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%298158.jpg",
        "alt": "A person taking a mirror selfie, covering their face with their phone, standing against a plain wall, with visible tattoos on their body."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/87a17f8e-7d32-4abe-bca3-93d569731d61/_pai%2C_afasta_de_mim_esse_c%C3%A1lice__-_performance___hifa_cybe+%28720p%298181.jpg",
        "alt": "A person with tattoos taking a mirror selfie while holding a hairdryer."
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "143548773"
      }
    ]
  },
  {
    "slug": "profano",
    "title": "Profano",
    "year": "",
    "lead": "Photo-performance created in collaboration with the artist Abitante and photography by Ludmila Russo.",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/74675325-f735-4b31-89f9-8177f6d6f2ab/Scan38687.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2236335d-51e7-4529-baa4-815a8f0bf13e/Scan38685+%281%29.jpg",
        "alt": "A person dressed in black latex cosplay costume pose on all fours on a wooden floor with a purple-pink background. There are chains hanging from the ceiling and a piece of stone on the floor."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6c45d841-c896-4013-9cef-db7415ec4e75/Scan38682.jpg",
        "alt": "Person dressed in black latex outfit and mask, kneeling on the floor with pink lighting and chain hanging on the wall"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/903639bc-6391-4d1e-87ba-867f4decadd0/Scan38690.jpg",
        "alt": "Two women dressed in shiny black latex outfits and wearing gas masks in a room with purple lighting. One is standing with her hands and feet on the floor, while the other is kneeling against the wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/87ec8283-86de-49dd-a249-e090ec787fff/Scan38680.jpg",
        "alt": "A doll's head on a dark wooden floor in front of a door with a glass window. The image has a purple tint and a string of lights or decorations hanging near the door."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4c36fef5-cd6a-4315-9c91-6db054702929/Scan45914.jpg",
        "alt": "Two women with tattoos and chains posing indoors, one kneeling and the other upside down, with tattoos and braided hair."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4915a98b-e38a-4b73-9ad2-42135d8c9ff8/Scan45916.jpg",
        "alt": "Two divers underwater, one holding a ball and wearing chains."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/457bf69e-42df-4c3f-836f-1e9c40c96442/Scan45917.jpg",
        "alt": "A mirror reflection of a person performing an aerial dance pose, wearing dark clothing, with a chain hanging above."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/67351bc2-50e6-44a5-a988-2a2616f92155/Scan45921.jpg",
        "alt": "Two tattooed individuals performing a handstand in a room. One is balancing upside down with chains around their neck, and the other is supporting them on the floor. Both are tattooed and wearing minimal clothing."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/176911ea-df7f-4bbd-a54e-1bb69a08189c/Scan45889.jpg",
        "alt": "A collection of masks and paper cutouts arranged on a wooden floor, including a lion, a superhero, and a clown mask, with braided strands attached."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e24598c6-aa18-475b-9d3e-f21a990ec965/Scan45890.jpg",
        "alt": "A woman with tattoos lying on the floor holding a chain, with a man with tattoos lying beside her, both posing for a photograph. The photo is in black and white."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/446af408-750f-4864-b064-fe396b713882/Scan45891.jpg",
        "alt": "Two women with tattoos wearing lingerie engage in a BDSM scene with chains, with one woman kneeling and holding a ball gag."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c868dbd5-352a-4a0c-a5a1-172a88df3e87/Scan45892.jpg",
        "alt": "A person dressed in black lingerie with tattoos, wearing a mask, holding chains, and standing over another person on the floor, who is also dressed in black and has tattoos."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/7fef55ce-190d-4605-a45b-e33d9bdd3c0a/Scan45893.jpg",
        "alt": "A person in black clothing and tattoos kneeling on the floor with one arm raised to their head, next to a sculpture of a seated woman with chains hanging from her shoulders, in a dimly lit room."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ea6f61bb-d874-4f3f-a0e5-5163b83632cf/Scan45894.jpg",
        "alt": "Two women with tattoos wearing masks and lingerie, holding chains in a room with wooden flooring."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/fe7e0625-6e96-4274-a081-a5a61b92904f/Scan45895.jpg",
        "alt": "A woman with tattoos sitting on the floor reaching out to a chainsaw that is hanging from the ceiling, in a dark room."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/276f8260-e410-4c17-8e0e-b70e7ea814a6/Scan45897.jpg",
        "alt": "A person wearing a mask and sportswear is doing a stretching exercise in a room with a door and a chain hanging from the ceiling."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3d8e07e7-6712-4b75-8c92-6e1850c2cbd6/Scan45899.jpg",
        "alt": "Two tattooed women are engaged in a playful or artistic interaction indoors. One woman, with short hair and wearing lingerie, leans back against a wall while holding onto a chain. The other woman, with long hair styled in braids and wearing minimal c"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/dd22b3b3-6a99-4481-814f-4eb7df70cbd0/Scan45900.jpg",
        "alt": "A person with extensive tattoos performs a backbend on the floor, holding onto a hanging chain with one hand in an indoor setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f403682b-c2aa-4ea8-9cc4-6bfd7b2d5fdc/Scan45905.jpg",
        "alt": "Two tattooed women wearing masks and chains, one in a headscarf and the other in a mask, engaging in a BDSM scene on a wooden floor, with one woman in a wheelbarrow position and the other holding chains attached to her, both wearing minimal clothing."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3277e428-e549-4d8f-b1a7-a336690147b6/Scan45908.jpg",
        "alt": "Black and white photo of a person with tattoos on their arms, holding a hammer and breaking a brick on the floor."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4180d700-c942-4db9-9c4e-c5c036413851/Scan45911.jpg",
        "alt": "Two tattooed women with chains and stockings are in an unusual pose on a wooden floor, with one woman behind the other."
      }
    ],
    "videos": []
  },
  {
    "slug": "pudor",
    "title": "Pudor",
    "year": "",
    "lead": "_Pudor_ is a video-performance that investigates the mechanisms through which sexuality can be silenced, regulated, and denied within rigid religious contexts. The work centers on the experience of having one’s sexual subjectivity suppressed by a community structured around moral restraint and spiritual dogma.",
    "body": [
      "At its core, the piece addresses vaginismus not only as a physiological condition, but as a psychosomatic manifestation shaped by repression, shame, and the absence of dialogue about the body. Within this environment, sexual pain becomes unspeakable, as religious belief systems override the recognition of sexual health and autonomy.",
      "In _Pudor_, violence is not portrayed as an isolated act, but as a diffuse and collective force. It emerges through omission, silence, and the normalization of denial. The work reflects on how communities that refuse to acknowledge the value of sexuality can inadvertently produce forms of structural violence, inscribing control and guilt onto the body itself."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f81bde02-db7d-4977-bec1-98fc265adf14/pudor-luiza-prado.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f2730f43-8248-4fe9-a763-f96aab75880b/pudor-hifa-cybe.jpg",
        "alt": "Pudor"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d9479c92-46f9-42af-89e9-23c4adbab999/pudor+luiza+prado_7029.jpg",
        "alt": "A person's tattooed stomach with a pile of white rosary beads resting on it, featuring miniature crosses, against a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f36e4894-d5bd-4b32-ad03-82eceee9cd5d/pudor-hifa-cybe.jpg",
        "alt": "A tattooed person with a snake design tattoo on their arm, wearing a black shirt, has a pile of small white objects, possibly pills, on their stomach, with a cross-shaped object falling from above."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/25006c61-44d7-44d4-a173-de937d3367d1/pudor-hifa-cybe-1.jpg",
        "alt": "A nude woman with tattoos lying on her back on a dark surface against a black background."
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "233659229"
      }
    ]
  },
  {
    "slug": "reincarnate",
    "title": "Reincarnate",
    "year": "",
    "lead": "",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/eb5f689a-8cc3-42c4-9074-c1ebe60cd89a/andrea-barbour---luiza-prado.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/282c9f9b-7457-4fad-bf65-130de05d94b4/IMG_0611_baixa.jpg",
        "alt": "A woman dressed in sheer, dark lingerie sitting on a chair in a dimly lit room with black and gold ornate wallpaper, a small window, and framed artwork on the wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/55dc6002-83f4-462d-81b7-d1b2e7e20f53/IMG_0633_baixa.jpg",
        "alt": "A plastic doll with a paper bag over its head, hanging upside down from a chair in a room with red and yellow walls."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2292fe69-0aac-4bc7-b6f2-468ba4f1af4b/IMG_0645_baixa.jpg",
        "alt": "A elderly woman with gray hair, wearing a sheer long-sleeve top and patterned pants, is curled up in a fetal position on a small red table in a dimly lit living room, near a brick fireplace and wood logs."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6f1c8ffc-bf79-4530-9250-8cfb9e17e64d/IMG_0646_baixa+%281%29.jpg",
        "alt": "A person with plastic wrap over their head and face, kneeling on a small red table in a dimly lit living room, in front of a fireplace and surrounded by dark sofas."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/74404d2d-16c9-4374-beeb-c43033cedbe7/IMG_0646_baixa.jpg",
        "alt": "Woman sitting on a small round table with a glass-like face mask and transparent head covering, inside a cozy living room with a fireplace, logs, and dark furniture."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/18b1b2fa-cced-4ba2-a59d-b0b91ce0aff7/IMG_0681_baixa.jpg",
        "alt": "Person lying on the floor in front of a wooden cabinet with a mirror, in a room with a window covered by yellow curtains."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/523a3c9b-c211-46d2-abab-7e73d115efb6/IMG_0686_baixa.jpg",
        "alt": "Partially visible woman in a long black dress standing near a dark wooden dresser with a mirror in a dimly lit room, sunlight streaming in through a window with curtains."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/43cc31f3-fa26-47ec-a457-cf7e0025841c/luiza-prado-andrea-barbour-perus-9.jpg",
        "alt": "Reincarnate"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/61e8b780-0b12-46f4-a2d4-e6ad8b8b6279/luiza-prado-andrea-barbour-perus-1.jpg",
        "alt": "Woman in a white dress sitting in front of a window, reflected in a round mirror placed on the ground surrounded by dirt and small plants."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f7147800-7549-469c-8748-265d99c0b860/luiza-prado-andrea-barbour-perus-25.jpg",
        "alt": "A woman in a white dress sitting on the ground inside a dilapidated building with broken windows, holding a broom, with greenery visible outside."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6e2f32e1-4b66-4d95-95cb-441e836f2f9a/luiza-prado-andrea-barbour-perus-34.jpg",
        "alt": "A young girl dressed in a white gown, looking up from a dirt ground in a narrow, stone-walled alleyway, with her head turned back and a curious expression."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d5740bd6-bc36-4c14-a625-433ffd607833/luiza-prado-urbex.png",
        "alt": "A white dress hanging on a string, with a mirror reflecting a woman sitting on a chair and looking at her phone, in a rustic outdoor setting with plants and dirt"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/99b07e4a-57e2-48b5-91a5-e64f688bf96a/REINCARNATE-5-photo-1.jpg",
        "alt": "A young woman in a white dress sitting on a wooden chair in an abandoned room with a large window, an acoustic guitar leaning against the wall, and a vintage telephone on a table in the foreground."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ad518979-b137-44ae-be15-9eacc8b9924d/REINCARNATE-5-photo-3.jpg",
        "alt": "A woman walking along a dirt path in an abandoned industrial area with overgrown grass, old buildings, and a factory or power plant in the background during sunset."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d4ffd563-632c-469a-a315-060c8f79e07d/reincarnate-luiza-prado-1.jpg",
        "alt": "A woman with dark hair in a loose updo, wearing a white dress with lace details on the shoulders, looking to her left outdoors with cloudy skies and old buildings in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/7600acbe-5945-494b-991e-2142d70a6667/IMG_4655_baixa+%281%29.jpg",
        "alt": "Reincarnate"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/09befc6c-8511-43d7-a4e5-19cc3a22d96b/IMG_4548_baixa+%281%29.jpg",
        "alt": "Interior of a derelict train car with a person walking away in the distance, showing peeling paint and debris on the floor."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/afbe8832-8fdc-4143-90e5-1edae149da60/IMG_4554_baixa+%281%29.jpg",
        "alt": "A woman with reddish hair in profile, looking upward in a dark, industrial setting with exposed pipes and a metal wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0c4eb997-b6c0-4bcc-8fae-f6107f2d2688/IMG_4567_baixa+%281%29.jpg",
        "alt": "A woman with red hair leaning against a window frame in a dark, dilapidated room."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/68c30b6d-cfa6-490e-891d-1d8818c18c23/IMG_4569_baixa+%281%29.jpg",
        "alt": "A woman with red hair wearing a black and shiny striped outfit lying on debris and rubble in a dark, destroyed setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c1452d16-54c5-457a-b081-4c32edec938b/IMG_4578_baixa+%281%29.jpg",
        "alt": "A woman with red hair lying on the floor with her hands covering her face amidst debris."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8f164e39-3d0e-41bb-be62-b855c788f4a2/IMG_4600_baixa+%281%29.jpg",
        "alt": "A person walking through the interior of an abandoned, rusted train car with peeling paint and broken floor panels."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/feb3d75a-db8f-4cfc-b1bc-d3684d0ee1aa/IMG_4626_baixa+%281%29.jpg",
        "alt": "A woman with reddish-brown hair looking up through a small window in an abandoned and weathered structure."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/efce2dff-64ee-4434-86b5-eefe25432d11/IMG_4635_baixa+%281%29.jpg",
        "alt": "A woman standing in a dark, industrial brick warehouse with arched doorway and metal pipes, surrounded by barrels and construction materials."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/028155bf-5f14-454b-ab60-73f3114b79a5/reincarnate_project_%236___hifa_cybe+%28Original%290214.jpg",
        "alt": "Reincarnate"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/8e0d42b7-f6e3-4e43-a4d2-74f48351e969/reincarnate_project_%236___hifa_cybe+%28Original%291047.jpg",
        "alt": "A person kneeling or bowing on the floor in a dimly lit, abandoned house with open doors and windows, and peeling paint on the walls."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/cabaf5af-b159-476f-86dd-59954381f06c/reincarnate_project_%236___hifa_cybe+%28Original%290862.jpg",
        "alt": "A person with dark hair raising their hands toward the camera in a dimly lit room."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/234e074f-59df-4730-8f18-1fc0345caea7/reincarnate_project_%236___hifa_cybe+%28Original%290817.jpg",
        "alt": "A woman with long, messy hair covering part of her face, leaning forward in a dark indoor setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/08338076-ccef-4e7a-a517-3604aa460e6a/reincarnate_project_%236___hifa_cybe+%28Original%290711.jpg",
        "alt": "Person with dark hair holding their hand up close to the camera, obscuring their face in a dark room."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/79b4ceed-c865-4f67-b334-7b6c3e425664/reincarnate_project_%236___hifa_cybe+%28Original%290615.jpg",
        "alt": "Two women with long dark hair and black dresses standing inside an empty, dimly lit room with peeling paint and old windows, leaning towards each other with arms outstretched."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e0fed81f-9828-4851-9621-e1375d84633e/reincarnate_project_%236___hifa_cybe+%28Original%290542.jpg",
        "alt": "The image shows a person with long hair, dressed in dark clothing, leaning forward and touching their lower back with one hand, against a beige wall and wooden flooring."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/794e3079-2899-4b45-893b-a3c9f27e891c/reincarnate_project_%236___hifa_cybe+%28Original%290494.jpg",
        "alt": "Person with dark curly hair reaching towards the camera, with a dark painted fingernail, in a dimly lit room."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b6dea06a-98ac-4289-a053-b539aae35912/reincarnate_project_%236___hifa_cybe+%28Original%290478.jpg",
        "alt": "Person with curly hair extending their hand toward the camera, with a blurry background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b32a2317-a8af-47e3-addb-02d081137fb7/reincarnate_project_%236___hifa_cybe+%28Original%290367.jpg",
        "alt": "Two women in black dresses dancing in an old, dimly lit room with beige walls and an open doorway."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/dbbd4757-ef0d-4023-b02b-9ce2ed89453b/reincarnate_project_%236___hifa_cybe+%28Original%290348.jpg",
        "alt": "A close-up shot of a person's face, holding their hand up, with long dark hair partially covering their face in a dimly lit environment."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/59e7e7b7-090b-49f1-b437-6bf35dd9c675/reincarnate_project_%236___hifa_cybe+%28Original%290293.jpg",
        "alt": "Two women in long black dresses appear to be arguing or fighting in a dimly lit, old-style room with open doorways and a window."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f200ae94-f7a9-46a4-b24a-292668f0187d/thays-vita--luiza-prado-2.jpg",
        "alt": "Reincarnate"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c85c6666-2fef-4054-ae72-81c6f3f26d6a/thays-vita--luiza-prado-1.jpg",
        "alt": "A nude woman standing in a dilapidated, graffiti-covered room with a red cloth wrapped around her legs."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/42447ccb-e787-4fe8-b40f-35228f93f0cd/thays-vita--luiza-prado-6.jpg",
        "alt": "A naked person standing in a dark, empty, and gritty alleyway."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/eb79aaaa-baf1-4d60-8f12-fb83ed6eb50f/thays-vita--luiza-prado-3.jpg",
        "alt": "A woman standing nude in a dilapidated building with graffiti on the walls, holding a piece of red fabric."
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "424335301"
      },
      {
        "provider": "vimeo",
        "id": "424333915"
      },
      {
        "provider": "vimeo",
        "id": "424336510"
      },
      {
        "provider": "vimeo",
        "id": "424333072"
      },
      {
        "provider": "vimeo",
        "id": "424336667"
      },
      {
        "provider": "vimeo",
        "id": "424344404"
      }
    ]
  },
  {
    "slug": "resistencia",
    "title": "Resistencia",
    "year": "",
    "lead": "The tattoo was made on the central axis, purposely to cause tension in the spine and the peripheral nervous system.",
    "body": [
      "Classified as an extension of the central nervous system (CNS), the spinal cord consists of the encephalon and spinal cord. It begins in the lower part",
      "of the brainstem and terminates in the lower dorsal part, thus forming the medullary cone.",
      "A collection of nerves, known as the cauda equina, leaves the lower part of the spinal cord (medullary cone) and serves to provide us sensibility",
      "The tattoo as done in this region, causes involuntary movements and pain in other parts of the body, where the tattoo is not being done, in addition",
      "to dizziness and headaches. The intention is in every action, the tattoo be done within the stroke, until one day, this whole map is painted red.",
      "The countries of Latin America walk together, strain together and the red symbolizes blood but also revolution, that after the tattoo, the blood",
      "is staked in a white fabric, like a flag."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/abc00383-b327-4de7-bcb4-577d152d7a87/latina-luiza-prado.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f68051c8-9b14-4f48-903b-2537f9638db5/resistencia-luiza-prado-6.jpg",
        "alt": "A person showing their back with a tattoo of a tree and red lightning bolts."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a705b261-5b77-4418-ba17-9f7e6f754a89/resistencia-luiza-prado-1.jpg",
        "alt": "Tattoo artist creating a red ink design of a lightning bolt on a person's back with extensive tattoos."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/65af8c97-b1ed-4fdd-85af-106c3c36e237/resistencia-luiza-prado-4.jpg",
        "alt": "A reflection of a person with dark hair and facial piercings, including a septum ring, seen in a small round mirror or hole in a wooden surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f8431aab-e491-4e0f-8ec5-25d179625f62/resistencia-luiza-prado-7.jpg",
        "alt": "Close-up of a person’s face with a scar that resembles a lightning bolt."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0bbafbc3-3365-47f7-a1a6-29c47aadf200/resistencia-luiza-prado-2.jpg",
        "alt": "Tattoo artist tattooing a woman lying face down on a tattoo table in a studio with red lighting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d8e3f0fe-b6fc-43de-ad54-c90d99183875/hifa+cybe+resistencia.jpg",
        "alt": "Abstract watercolor painting with soft reddish-brown and gray tones."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4e99af85-68c5-4cd0-8e96-67140ae15be1/resistencia-luiza-prado-1+%281%29.jpg",
        "alt": "Tattoo artist creating a red ink tattoo on a woman's back in a tattoo studio."
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "233473348"
      }
    ]
  },
  {
    "slug": "rose-compass",
    "title": "Rose Compass",
    "year": "",
    "lead": "",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/24df6009-2d1f-4309-a09d-852b1755b99e/luiza_prado_hifa_cybe_rose_compass%2C_performance_art_shibari.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d32be6b0-063e-4837-8efa-0166e15b8f6a/luiza_prado_hifa_cybe_rose_compass%2C_performance_art_shibari.jpg",
        "alt": "luiza_prado_hifa_cybe_rose_compass,_performance_art_shibari.jpg"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/542714b7-4f04-4e2a-8025-3a9d89f048d6/luiza_prado_hifa_cybe_rose_compass%2C_performance_art_shibari.jpg",
        "alt": "luiza_prado_hifa_cybe_rose_compass,_performance_art_shibari.jpg"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b733aa72-17c9-44f5-8e46-d802b3190e2a/luiza_prado_hifa_cybe_rose_compass%2C_performance_art_shibari.jpg",
        "alt": "luiza_prado_hifa_cybe_rose_compass,_performance_art_shibari.jpg"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3636a1a2-e7da-451d-87a6-db94b550e878/luiza_prado_hifa_cybe_rose_compass%2C_performance_art_shibari.jpg",
        "alt": "luiza_prado_hifa_cybe_rose_compass,_performance_art_shibari.jpg"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3522b8e0-6a6e-43fb-bdbc-da80ad7c0beb/luiza_prado_hifa_cybe_rose_compass%2C_performance_art_shibari.jpg",
        "alt": "luiza_prado_hifa_cybe_rose_compass,_performance_art_shibari.jpg"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c9845795-8712-4187-ba86-00d346a22436/luiza_prado_hifa_cybe_rose_compass%2C_performance_art_shibari.jpg",
        "alt": "luiza_prado_hifa_cybe_rose_compass,_performance_art_shibari.jpg"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/41144580-4d22-4926-bfe3-0c13b7f4ab90/luiza_prado_hifa_cybe_rose_compass_performance_art_shibari.jpg",
        "alt": "luiza_prado_hifa_cybe_rose_compass_performance_art_shibari.jpg"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9f14519b-bb3c-45c6-9e3c-ab27dd05766a/luiza_prado_hifa_cybe_rose_compass_performance_art_shibari.jpg",
        "alt": "luiza_prado_hifa_cybe_rose_compass_performance_art_shibari.jpg"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0b3f7cdc-b748-4adc-baee-75d8b8f324be/luiza_prado_hifa_cybe_rose_compass_performance_art_shibari.jpg",
        "alt": "luiza_prado_hifa_cybe_rose_compass_performance_art_shibari.jpg"
      }
    ],
    "videos": []
  },
  {
    "slug": "sem-rostos",
    "title": "Sem Rostos",
    "year": "",
    "lead": "_Pudor_ is a video-performance that investigates the mechanisms through which sexuality can be silenced, regulated, and denied within rigid religious contexts. The work centers on the experience of having one’s sexual subjectivity suppressed by a community structured around moral restraint and spiritual dogma.",
    "body": [
      "At its core, the piece addresses vaginismus not only as a physiological condition, but as a psychosomatic manifestation shaped by repression, shame, and the absence of dialogue about the body. Within this environment, sexual pain becomes unspeakable, as religious belief systems override the recognition of sexual health and autonomy.",
      "In _Pudor_, violence is not portrayed as an isolated act, but as a diffuse and collective force. It emerges through omission, silence, and the normalization of denial. The work reflects on how communities that refuse to acknowledge the value of sexuality can inadvertently produce forms of structural violence, inscribing control and guilt onto the body itself."
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2ea849a7-a5af-4fe6-89c1-2e4a3d139eb1/sem-rostos-luiza-prado+%281%29.jpg",
    "images": [],
    "videos": []
  },
  {
    "slug": "teias-desconexas",
    "title": "Téias Desconexas",
    "year": "",
    "lead": "",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/dc380380-343b-4a95-97f3-c24d51613e3d/teias-desconexas_159.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ea087245-465b-4711-9c72-84f6fc3c0298/teias-desconexas_260.jpg",
        "alt": "A performer suspended upside down with ropes in a dark, red-lit setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2bdb5782-b410-44a7-b64f-ca09861dbef4/teias-desconexas_168.jpg",
        "alt": "People in protective suits on stage, one kneeling and tying something on the ground, others dancing and taking pictures."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f997be9a-b697-4bab-980b-1d8779a07c35/teias-desconexas_158.jpg",
        "alt": "Group of people in yellow protective suits with a smiley face patch, standing in a dark setting with a smoky or dusty background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/28b34728-4f1e-4219-b32b-cfbdbd9ec2e6/teias-desconexas_160.jpg",
        "alt": "A woman with short hair, earrings, and sunglasses smiles and touches her nose while holding a bouquet of roses in her arms. She is wearing a white jacket and appears to be in a casual or candid moment. There are other people around, blurred in the ba"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ae8cb686-4b55-45c3-82ca-7dbbd30ebf69/teias-desconexas_165.jpg",
        "alt": "People in white protective suits standing and taking photos in a dark room with some large leaves on the wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e9636c8c-3051-4df7-af4f-00169d7b8c97/teias-desconexas_171.jpg",
        "alt": "People wearing yellow protective suits participating in a ritual or event indoors, with one person smoking and others raising their hands, surrounded by dark background and orange lighting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/35b7f19b-7882-499e-bedb-549827555563/teias-desconexas_167.jpg",
        "alt": "Two individuals wearing white protective suits, one holding flowers, standing on a dark stage with scattered flowers and an umbrella in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/51a7e6de-d314-4726-899d-6250f9d29d03/teias-desconexas_169.jpg",
        "alt": "Group of four people dressed in yellow protective suits, some with face masks, in a dark room with low lighting. One person is taking a photo with a smartphone, another is holding a roll of tape, and the others are interacting with each other."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/dcec8f01-f0d0-4a5d-b78b-ebe55590a3ce/teias-desconexas_170.jpg",
        "alt": "Group of people in yellow and white hazmat suits, one person holding an umbrella, inside a dark room with red lighting, some flowers on the floor."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c463da4f-81ff-45e2-8608-df9ac6e317b7/teias-desconexas_172.jpg",
        "alt": "Person in protective suit smiling and interacting with others, holding a phone, with warm, dim lighting"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/20019ba8-9014-4236-b1e5-9171f82c2c05/teias-desconexas_173.jpg",
        "alt": "People wearing yellow safety overalls standing on stage, with one woman taking a selfie. The scene is dark with warm lighting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/362c6045-6116-4907-beef-1758d39cd626/teias-desconexas_174.jpg",
        "alt": "Two men in white protective suits exchange a flower, while a woman in a similar suit observes in a dark environment with plants and people in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c99ad854-a744-4b45-96e5-974a8d22eabe/teias-desconexas_175.jpg",
        "alt": "Two people in yellow protective suits writing or drawing on the ground with chalk or similar material, illuminated by a dim warm light."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/bf207599-f86f-4b69-8169-c21abb370e77/teias-desconexas_176.jpg",
        "alt": "People dressed in orange protective suits holding a flowing orange fabric in a dark setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ecf530b1-7c18-4018-b029-5e62433bf930/teias-desconexas_177.jpg",
        "alt": "People dressed in white protective suits with hoods, with one person mid-movement, lifting an arm, holding a flowing fabric or material against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c366aded-d873-471a-8b97-adf1cb4cf459/teias-desconexas_224.jpg",
        "alt": "People wearing protective suits and holding up smartphones with flashlights turned on in a dark environment."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/61e652ed-7f08-42a3-9694-69a690e66522/teias-desconexas_225.jpg",
        "alt": "A woman in a white jacket taking a selfie with her phone, the phone's flash illuminating the scene, in a dark setting with other people around."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6d58d4ea-71c1-446d-95d2-efe7044a1188/teias-desconexas_243.jpg",
        "alt": "Person wearing a distorted mask resembling a face, standing in a dark setting with green foliage in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f789ca92-e2b1-46ea-8183-fab7c548b0ba/teias-desconexas_244.jpg",
        "alt": "A person wearing a mask of a human face with makeup and earrings, standing in a dimly lit space with dark background and green lighting on foliage."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a72750eb-09f6-4e8a-8a58-97181ff406fd/teias-desconexas_245.jpg",
        "alt": "A woman performing in a dark setting is wearing a mask and black clothing, holding red strings connected to a large geometric structure with red lines."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/4efae834-b84f-4456-8fb0-a570b6b2e94b/teias-desconexas_246.jpg",
        "alt": "Two individuals in dark clothing are seen in a low-light setting illuminated by red light. One person wears a mask or head covering, and the other wears a mask with cables attached. They are engaged in an activity involving a rope."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/42f5499c-5d46-4445-8671-134bf80def17/teias-desconexas_247.jpg",
        "alt": "A woman wearing a futuristic mask and black clothing is on stage with a man who appears to be adjusting her sleeve. The background features a bright blue panel and dark stage lighting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/33093c88-8a25-441b-b3a3-ab0cb5649451/teias-desconexas_248.jpg",
        "alt": "A person with a helmet and harness is preparing for a high-altitude activity against a dark background with blue light."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f617c0c1-6b94-42d7-b2a2-9c612f9d6078/teias-desconexas_249.jpg",
        "alt": "Two people holding hands, wearing masks and costumes, surrounded by others in costumes, illuminated with red and blue lighting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/43ea8ab7-7df2-4ead-81ad-b7b98cccb8d4/teias-desconexas_250.jpg",
        "alt": "People in costumes performing on a dark stage with blacklights and colored lighting, some in white suits and others in elaborate headpieces."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d7cd6560-fb26-426e-8e33-1085303695ca/teias-desconexas_251.jpg",
        "alt": "Group of women wearing white glow-in-the-dark jackets under blacklights at a dark event."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9e1707d6-64ce-422b-bc5b-62c76190cbad/teias-desconexas_252.jpg",
        "alt": "People in white protective suits and dark clothing are involved in a performance or activity in a dark room with blue and red lighting. One person is kneeling, another stands above them, and others are in the background near a blue screen or panel."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e7fb505b-1f39-4020-83bf-b9528994aba8/teias-desconexas_253.jpg",
        "alt": "Group of people in white protective suits standing in a dark room with a blue screen, illuminated by purple and red lights, with some individuals kneeling and wearing a harness or climbing gear."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9bc865df-b062-4fcc-8d42-77f66c911dab/teias-desconexas_254.jpg",
        "alt": "Two performers under purple and red stage lighting, with one standing and the other kneeling, both wearing helmets with wires and costumes made of ropes and straps, during a theatrical or circus performance."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/56d88005-662a-4f51-b886-6c4b0d65c0c3/teias-desconexas_257.jpg",
        "alt": "Person in black outfit, with a bald or shaved head, sitting on a harness or swing suspended from a high point, being held by another person in a dark environment illuminated with red and purple lighting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d90cc267-0642-40d6-9043-2102cd061615/teias-desconexas_258.jpg",
        "alt": "Performers in dark room with colored lighting, some wearing white costumes, surrounding a person on a trapeze."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/88ea2037-5528-4d0e-9b37-ad1fdbf471a5/teias-desconexas_259.jpg",
        "alt": "A performer on a dark stage, illuminated by red lighting, holding and manipulating a puppet or figure with ropes, with another person blurred in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/879bfb54-a6d6-4cdb-b1aa-d6b951455655/teias-desconexas_261.jpg",
        "alt": "A performer is hanging upside down, wrapped in ropes, illuminated by red stage lighting, with a person standing in the background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d607104a-0857-4beb-86fc-2fe6d029817f/teias-desconexas_262.jpg",
        "alt": "Person wearing a mask and black clothing, standing in dim red light, handling ropes connected to a hanging object or figure."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/cc9e88c9-5826-4a5d-a691-8a9e19ebcaa3/teias-desconexas_263.jpg",
        "alt": "Performers on stage in a dark setting with red lighting, one hanging upside down and another standing, engaging in a circus act."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/20f7df45-c2ab-49f3-8fb9-2a6a3e8514fe/teias-desconexas_264.jpg",
        "alt": "Group of people sitting and crouching in dark room, illuminated by phone screens and a flashlight, with some wearing white protective suits and makeup that highlights their faces."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9ab44617-e137-4d27-9ee6-606fd551c923/teias-desconexas_265.jpg",
        "alt": "Group of children and an adult on a multi-level puppet stage, illuminated with red and white lights, performing a puppet show in a dark setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/e62df536-d438-4c65-8c62-3857bfdc4f9b/teias-desconexas_266.jpg",
        "alt": "Children wearing white shirts with smiley face badges and face paint, illuminated from below, sitting inside a red-lit structure at night."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0db41ecd-9de1-49c0-80c4-7ce9345bab2c/teias-desconexas_267.jpg",
        "alt": "Group of children illuminated with flashlights and colored light, looking at the camera in a dark setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/09614839-dbed-426c-a059-f7294afffaa0/teias-desconexas_268.jpg",
        "alt": "A group of people wearing white hooded clothing gathered around a camera or mirror, illuminated by the glow of their smartphones in a dark setting."
      }
    ],
    "videos": []
  },
  {
    "slug": "tenro",
    "title": "Tenro",
    "year": "",
    "lead": "Tenro - Performance - Luiza Prado - YouTube",
    "body": [
      "Tenro - Performance - Luiza Prado HIFA CYBE"
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c2cfa8f9-61aa-4b51-9602-5d4197ca67c7/tenro_luiza_prado.jpg",
    "images": [],
    "videos": [
      {
        "provider": "youtube",
        "id": "tUMvGIZ-wvY"
      }
    ]
  },
  {
    "slug": "the-body-state",
    "title": "The Body State",
    "year": "",
    "lead": "This project satirizes and takes to absurdism the State's interference in our autonomy over our bodies and sexuality. We use body donation for necrophilia as a posthumous performance, in this narrative the necrophile is the State.",
    "body": [
      "We also touch on subjects such as necrocitizenship, religion, necropolitics and body donation, which, for example, if you go to Law No. 9,434 in art. 4th, he is saying that organ donation depends on family scrutiny to happen, which is independent of individual will and autonomy, and this is our social theater, just like the perverse figure of the necrophile.",
      "We also made a donation document, this donation will probably not be made for obvious reasons, but the performance itself is a discussion that permeates issues of the body, death, violence, sexuality and politics.",
      "In Brazil, the freedom of bodies is constantly restricted by deep-rooted morality. Furthermore, the silence about mortality is reflected in legislation since we do not have any type of guaranteed right over expressly expressed wishes regarding our corpse. The necrocitizen is entirely linked to the wishes of his relatives, and it can be said that, seen as matter, he would then become the property of the family. To the same extent that the permission to donate organs and the donation of the body to science are legislative advances, the need for family screening for these practices to be carried out is a setback.",
      "The work seeks to metaphorize the State in the figure of the necrophile. Both because the State represents a perverse figure, restricting the freedom of bodies (dead or alive) and allowing itself to be influenced by religious fetishism, and because of the responsibility that the State should assume so that the desire of individuals regarding the corpse is fulfilled.",
      "The Body State (O Estado do Corpo) - Luiza Prado \\| Spotify"
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/798207de-d4b1-4fc0-83e2-e8c52a9c82cb/quem--o-necrofilo--1-3.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d76f3c21-c550-4e73-a95a-5e65762ed996/Necrofilia-hifa-cybe.jpg",
        "alt": "Framed Brazilian certificate of body donation for necropsy, with official emblems, text, and form fields filled in with personal information, against a white wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/7ab97d7f-8525-4624-8591-3028b29094a9/old-black-stucco-wall-with-white-scratches-and-scuffs-texture-textured-grunge-background-for-designers-photo.jpg",
        "alt": "The Body State"
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3f6869c4-7371-4507-83c4-680c425d359a/black-paper-texture-pictures-jryv6fyv7kn8yv5g.jpg",
        "alt": "The Body State"
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "934314540"
      },
      {
        "provider": "youtube",
        "id": "yLW-FQCFI0g"
      }
    ]
  },
  {
    "slug": "the-painter",
    "title": "The Painter",
    "year": "1988",
    "lead": "This is the issue of gender in art (art market and history), specifically the predominance of cisgender men. Based, for example, on the work “The advantages of being a female artist (1988/2017)” by Guerrila Girls, which exhibited at MASP in 2017 and addresses the contrast between the small number of female, non-binary, trans, and queer artists, compared to the large number of nude female bodies in the exhibition of the collection of the Metropolitan Museum of New York (5% and 85% in 1989, 4% and 76% in 2012) and at MASP (6% and 60% in 2017). In the performance, the constant and repetitive act evokes a sexual act in its phallocentric form, symbolizing the persistent cultural dominance of cisgender men in the art world — both historically and within the market. The screen represents the feminine, the queer, and the non-binary; its whiteness suggests an attempted erasure of these identities. The act of tearing through the screen becomes a gesture of ongoing violation, a metaphor for how these bodies and narratives are repeatedly invaded, silenced, or overwritten.",
    "body": [],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6a775db7-8f5e-4704-bc2f-8414f80ff546/the-painter-thumb-1+%281%29.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6b7b99c8-7ce7-43aa-986c-3923a272bd16/the_painter_%282017%29_performance_art_-_hifa_cybe0003.jpg",
        "alt": "Close-up of a person painting on a canvas, wearing black gloves, with tattoos visible on their thigh, against a dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b067aa69-fde4-442d-b11e-619612b73e2e/the_painter_%282017%29_performance_art_-_hifa_cybe2853.jpg",
        "alt": "Close-up of a person's upper thigh and hand, with the person wearing black clothing and sitting on a surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/97dcd47c-e6b5-45c1-bdaa-9eb38b77c7ca/the_painter_%282017%29_performance_art_-_hifa_cybe0032.jpg",
        "alt": "A woman with wavy hair in black clothing and gloves playing a white grand piano against a black background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/03faf635-a8ee-4619-b37c-6fdec2de9e94/the_painter_%282017%29_performance_art_-_hifa_cybe1570.jpg",
        "alt": "A person in black gloves holding a paint roller, with a wooden easel in the foreground, and a person with a tattoo on their thigh visible in the background, in a dark setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1b74db75-39bd-4481-b559-9937418515e5/the_painter_%282017%29_performance_art_-_hifa_cybe2444.jpg",
        "alt": "Close-up of a person wearing black shorts, long-sleeve shirt, and gloves, leaning over a white surface."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/72fcab85-8981-4fad-9d47-813daf9fee72/the_painter_%282017%29_performance_art_-_hifa_cybe3113.jpg",
        "alt": "A woman standing next to a wooden chair against a black background, wearing black gloves and revealing her thigh tattoo."
      }
    ],
    "videos": [
      {
        "provider": "vimeo",
        "id": "233700623"
      }
    ]
  },
  {
    "slug": "triplice",
    "title": "Tríplice",
    "year": "",
    "lead": "_The name “Triplice” emerges from a convergence of experiences in search of knowledge and from_",
    "body": [
      "_a reflection on mythic concepts within a contemporary society._",
      "The name Triplice originates from the “Triple Goddess,” a pagan goddess who represents the trinity and a matriarchal society. She is the feminine polarity of a whole through the archetypes: Crone, Mother, and Maiden, also characterized by the three visible phases of the moon. Bringing this idea to a micro and intrasubjective level: mental, emotional, and spiritual, and to another level, macro and intersubjective: social, political, and historical.",
      "The Triple Goddess does not govern the world, because she is the very foundation of its origin. She is creation, maintenance, and destruction.",
      "Life and sexuality emerge with spring, like the new moon not yet illuminated by the sun, still unaffected by cultural expectations linked to patriarchal concepts.",
      "The natural essence of the feminino lies in what it values, not in being valued for what it is, because it possesses total freedom of choice to define itself. Its choice becomes the definition that remains immaculate, as it opts for secrecy, the secret of being.",
      "Often represented by a virgin, not because of sexual abstinence but because of the freedom to be filled with oneself rather than with the other.",
      "The full moon illuminated by the sun, the hot and fertile summer, the warrior, lover, creator, also symbolized by nature, by the creation and the offering of life.",
      "Contradictory in today’s times, the mother is the one who cares, whether internally or externally to the spirit, not limited only to a human image. Even when using human signs such as the umbilical cord, which can be understood as a bond, she is the one who does not condition us to remain tied in order to belong. Since life is made of relationships, giving is necessary for any act to occur. Whatever the intention may be, it requires leaving a part of oneself.",
      "“The act of the advising grandmother who weaves a cloak is like the weaving of life, whose cloak will not be hers but the next person’s.”",
      "The waning moon loses its brightness, but it has already reflected everything the sun could offer.",
      "Balance, knowledge, and wisdom complete the triad that becomes personified, because it has already been Maiden and Mother. It is winter, which even though it is a cold passage, can be warm if one knows how to light the fire. We live the end of our process of self knowledge, psychic maturation, the process of individuation, which makes this phase difficult. It is the end of a cycle and can be represented by transformation or renewal, rather than death understood as an end.",
      "Cults to the Triple Goddess, specifically to the Mother Goddess, were common since the beginning of the human species, in the Paleolithic and Neolithic periods. In theory, this was the phase that initiated the worship of goddesses and gods, whose cults expanded across several civilizations.",
      "With the rise of theocentrism, this worship became a threat, giving rise to persecutions such as the tribunals of the Inquisition.",
      "Polytheism was a threat within a patriarchal society structured through sexual and hierarchical organization. It was sustained by male domination in both private and public spheres, built upon a masculine model of domination and virility. Even more threatening to this model was the worship of goddesses, because it implied plurality, a transversal and enriching theme. However, within a centralized social construction, psychic and human development and experience would become problematic, as there would be no space for rigid hierarchy and we would instead be living in a cooperative and self managed system.",
      "The Triplice is an archetype of the feminine psyche, figuratively an ideology that stands in opposition to the cult of disinformation and to beliefs and signs historically imposed upon the feminino as a product. Our Triplice lives a moment of transition when analyzing the historical macro context in which the power to act was taken from us in a society that believes power is possession. In reality, the greater the equality, the greater the empowerment, returning us to the primitive symbolism of gods and goddesses who, in paganism, were the foundation of creation rather than simply leaders.",
      "We are Maidens, Mothers, and Crones. We, the feminino, who exist within this silent war.",
      "We are living a contemporary mythology within a system that has conditioned us to inherent and involuntary forms of worship. But who is the feminine Goddess of this mythology?"
    ],
    "cover": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b78d7eb9-c59a-4cac-9063-883bcd0cb356/mar-vermelho-luiza-prado-1+%281%29.jpg",
    "images": [
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/20aaa711-3d5b-4c0f-87ae-fc85497c1fef/maos-luiza-prado+%281%29.png",
        "alt": "A person's hands with red-painted nails are crossed and resting on a decorative iron gate in front of a weathered red wooden door."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c91f2ecc-1288-441b-a0c3-a0664ae3de39/a+flor+1+luiza+prado.jpg",
        "alt": "A topless woman with a flower crown is sitting backwards on an open bathroom door, with her head hanging down and her hands on the ground, in a dark room with large open windows and brick flooring."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ee2d3805-425a-42c9-ad89-afd6c5328afe/dialetica-do-arlequim_luiza-prado-1.jpg",
        "alt": "A woman with makeup resembling a tears running down her face, wearing a dark red top and jewelry, in a dimly lit setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/469abd00-49b6-491c-a05a-5b16257605ea/promessa.jpg",
        "alt": "The image shows a person's legs with several fresh, bloody cuts on the knees, standing on a worn, dirty floor near a wall with some exposed paint and damage."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/7596578e-5963-4fe4-b065-1d3a8122e760/Sangue-luiza-prado+%281%29.png",
        "alt": "Person holding a red lace fabric or towel over a bathtub edge."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a1375f8b-d556-4b97-a415-0fc59436f52d/20.png",
        "alt": "A person sitting on the floor of a dimly lit, abandoned building, leaning against a stroller in front of a graffitied wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5cdc1c50-3c1d-4111-b3d8-a7f9a6898411/A+Flor+luiza+prado.jpg",
        "alt": "A young girl standing outside at night under a decorative streetlamp attached to a wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/265c4761-2635-4815-9773-96b7ae7702ef/amarras_luiza-prado.png",
        "alt": "An abstract, blurred image with swirling patterns and a hint of landscape or texture in the center, dark background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/08d57763-97e2-4a83-91fa-715f5bbf9113/barduco-luiza-prado-1.jpg",
        "alt": "A black and white photo of a person sitting under a tree, surrounded by other trees in a foggy or misty outdoor setting."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/bc9c5366-a4ca-443b-971f-975a4d0683ea/boneca+luiza+prado.jpg",
        "alt": "A woman with red hair wearing black clothing and high heels crouches near large industrial green machinery inside a dimly lit factory or warehouse with high ceilings and tall windows."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9d9392d4-745f-4ca5-b7c7-de768663f1ee/Camila+-+Luiza+Prado.jpg",
        "alt": "A woman with dark hair and makeup is partially obscured behind a dark netted fabric with red and yellow flower petals on it."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/83c67162-3869-4ad6-9796-a313882e515b/Censura---Luiza-Prado.jpg",
        "alt": "A naked woman crouching on the ground in a dark, rustic setting with wooden stairs behind her."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/1c30f207-426c-4043-a763-d65a530d26ae/parque_de_diverses_luiza_prado.jpg",
        "alt": "A woman sitting on a carousel horse inside a dimly lit amusement park or arcade, with the carousel's horses and structure visible around her."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/552a1012-d040-4ef1-aea4-c560279b021f/contemplativa+luiza+prado+%281%29.jpg",
        "alt": "A woman with dark, wavy hair wearing a dark green velvet jacket with a white shirt underneath and a turquoise necklace, standing with her head bowed and eyes closed in front of a wooden background."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5030a46e-51a9-4694-a739-78aa6eb36f43/diana+carolina+luiza+prado+1.jpg",
        "alt": "A woman with dark makeup and dark hair, wearing black lace lingerie, lying down in a dimly lit environment with shadows."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/51aef83f-7043-4076-8aeb-0feda293d35c/douce.png",
        "alt": "Close-up of a newborn's hand holding an adult's finger, with blood and an umbilical cord visible."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/290ea79d-591f-4d6e-9a9e-c93641f98026/drama-luiza-prado-1-1.jpg",
        "alt": "A young woman with blonde hair in a black dress, standing barefoot between two stone columns in a garden with trees and bushes, looking upward."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/7b3d3cf8-0d1a-4ce3-850f-b7f96d354438/drama-luiza-prado-2-1.jpg",
        "alt": "A woman with blonde hair wearing a black lace dress stands with her head tilted back, in front of a large ornate wooden mirror, in a dimly lit room with a chandelier and a painting on the wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/40bcc669-c161-4abd-8aab-529e51b7aa59/Esquizofrenia---Luiza-Prado-1.jpeg",
        "alt": "A woman with long hair, wearing a white hospital gown, sitting on the floor in a dark, abandoned building, leaning her head against a folded wheelchair beside her."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/44293e8e-c93a-4b19-b668-7ea3f30984a5/FILE21039.JPG",
        "alt": "A woman with long black hair posing outdoors among foliage, with sunlight filtering through the trees."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2cd1260e-74d3-4dd6-b995-60fab9db35e2/grazi-luiza-prado-1.jpg",
        "alt": "A person wearing a red cape and mask sitting on the ground in front of a tree in a park or wooded area."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ceed65ca-1373-4de4-a27b-83c293cef4df/human-3-luiza-prado-1+%281%29.png",
        "alt": "A nude person bent over with one arm extended upward outdoors near trees and water."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/6f8a0787-322d-4247-a7a4-547ed0619a1e/Veias-olhos-e-corao-luiza-prado+%281%29.jpg",
        "alt": "Person taking a photo or recording with a camera in a natural outdoor setting, surrounded by trees and branches."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/16b32ce7-11ef-4e2a-9d63-c259e3bef518/imolao-luiza-prado-1-1.jpg",
        "alt": "A woman tied to a tree in a forest, shown in two separate images. In the first, she is leaning back against the tree with her face tilted upward. In the second, she stands with her back to the camera among trees and tall grass."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/50bed2fd-b6aa-4ca0-825d-8f0e9da7b072/luiza+prado+-+fuga.jpg",
        "alt": "A girl in a dress and heels standing by a large window, looking outside at a building with yellow and gray balconies."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/de9f92d7-dd52-4b38-83aa-9c0e61c7448b/ma-luiza-prado-2.jpg",
        "alt": "A woman with short red hair looking up while adjusting an ornate gold-framed mirror on a teal-colored wall."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b92a41b1-4223-4ea7-b915-28bed4a794b4/maossangue-luiza-prado+%281%29.png",
        "alt": "A close-up of a damaged hand with cuts and blood, resting on a patterned cloth."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/dc05a999-7757-4bf9-8745-2d609dd84557/mar-vermelho-luiza-prado-1+%281%29.jpg",
        "alt": "A woman in a long red dress walking through a doorway into a dimly lit room."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d589e956-b9a0-4acd-a26e-5add455367b9/mayara---luiza-prado+%281%29.jpg",
        "alt": "A woman with red hair sits at a cluttered wooden table, resting her head on her arm while holding a brass chandelier with a figure of a woman in her other hand. The background shows an eclectic mix of furniture and decorative items."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/583d7400-12ff-4719-a3dd-1fe87de4d5a5/na-luiza-prado+%281%29.jpg",
        "alt": "A woman lying on the ground, holding a mirror, surrounded by leaves and broken glass."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/716588b8-105e-4a60-92d0-8747fe56dbe4/luiza+prado+-+adormece.jpg",
        "alt": "A woman in a lace dress lying on the floor, looking into a large round mirror reflecting her face and hand, with spilled debris around her."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a040c73e-0ca8-495a-b7ab-3ee0d7bc96e0/inconcistente+.png",
        "alt": "A black and white photo of a woman with wet hair, with her face in profile, framed by two hands reaching towards her from above and below."
      },
      {
        "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ee257dbe-c4ad-4bec-b87a-6503603345bb/triplice-luiza-prado-1.jpg",
        "alt": "A woman with long hair in a white dress sits on a chair in the middle of an empty street, bending down to pick up fallen leaves. A glass of milk and a tray are balanced on her back."
      }
    ],
    "videos": []
  },
  {
    "slug": "the-weight-of-feeling",
    "title": "The Weight of Feeling",
    "year": "2026",
    "lead": "Suspended steel, a ring, and the quiet mechanics of holding something that has no body. The work measures affection as load: what it costs to carry, to hang, to be held.",
    "body": [
      "The chains operate as an instrument of weight and suspension — an apparatus where emotion is treated as a material with mass, tension and a point of rupture.",
      "Between the sculptural object and the body that inhabits it, the piece proposes a study of dependency: what supports, what restrains, and what remains once the load is released."
    ],
    "cover": weightOfFeelingPlate.url,
    "images": [
      {
        "src": wofRopeHands.url,
        "alt": "Tattooed, ringed hands holding a bundled coil of black rope in front of a gridded frosted window, sheer white ruffled sleeves at the edge of the frame."
      },
      {
        "src": wofWaistRopes.url,
        "alt": "A person looking down while adjusting black and tan ropes fastened around the waist, wearing a white lace bustier with leather straps, a red sash and sheer ruffled sleeves."
      },
      {
        "src": wofSeatedChain.url,
        "alt": "A seated figure in a sheer white ruffled robe leaning back and gripping a thick metal chain suspended from the ceiling, coiled ropes resting on the cloth-covered floor in a studio with a deep red wall and an easel."
      },
      {
        "src": wofChainOverhead.url,
        "alt": "A figure reaching overhead with both hands to grip a heavy vertical link chain against a deep red wall, sheer white ruffled sleeves and tattoos along both arms lit by warm directional light."
      },
      {
        "src": wofReclinedChains.url,
        "alt": "A figure leaning back with the head tilted upward among vertical strands of steel chains and tan and black ropes, against a black backdrop, in cream undergarments and a red strap structure with flowing sheer white fabric."
      },
      {
        "src": wofEyesClosedChain.url,
        "alt": "A person with closed eyes, one arm behind the head and the other hand on the chest, standing behind hanging steel chains intertwined with tan and black ropes, in a lace-trimmed cream top and sheer bell sleeves."
      },
      {
        "src": wofNeckChains.url,
        "alt": "Close-up of an angled neck and tattooed chest in a light ruffled bodice strap, gold choker and ornate earring, heavy metal chains hanging at one side bound with twisted brown rope and black cords around the neck."
      },
      {
        "src": wofRopesFace.url,
        "alt": "Close-up of a head tilted back with half-closed eyes and parted lips in a sheer white ruffled garment and dangling pearl earring, a vertical steel chain beside the face and black and tan ropes knotted at the neck crossing the foreground."
      },
      {
        "src": weightOfFeelingPlate.url,
        "alt": "Kneeling figure in lace and leather arching backwards while gripping suspended steel chains."
      },
      {
        "src": weightOfFeeling.url,
        "alt": "Suspended steel chains converging into a single ring."
      }
    ],
    "videos": [{ "provider": "youtube", "id": "bPL12Cjxq-g" }]
  },
  {
    "slug": "apophenia-and-pareidolia",
    "title": "Apophenia and Pareidolia",
    "year": "2026",
    "lead": "Apophenia is the human tendency to see patterns where there are none; pareidolia, its most visible face — faces in clouds, figures in noise, meaning emerging from randomness.",
    "body": [
      "The work investigates perception as an act of creation: the eye does not receive the world, it invents it. In noise, stains, textures and organic forms, the mind insists on finding figures — an ancestral mechanism of survival that turns uncertainty into image.",
      "Between the botanical and the artificial, the pieces explore this threshold where the real dissolves and the imaginary takes form, inviting the viewer to confront their own way of seeing."
    ],
    "cover": apopheniaPareidolia.url,
    "images": [
      {
        "src": apopheniaPareidolia.url,
        "alt": "Surreal garden of sculptural flowers, pearls and braided vines framed by an organic ornamental border, against a fiery orange sky."
      }
    ],
    "videos": []
  },
  {
    "slug": "lacuna",
    "title": "Lacuna",
    "year": "2026",
    "lead": "A performance in honour of my grandmother Maria — my curator, my benzedeira, my healer: the hands that cured, drawn on the body.",
    "body": [
      "Curator comes from the Latin curator, 'the one who has care and affection'. The Portuguese curandeira — healer — derives from curar (to care for, to treat, to heal) plus the suffix -eiro. I was assembling a performance in honour of my Indigenous grandmother, starting from the curing of pains.",
      "For more than ten years I have told Jun Matsui that I wanted to make visible on my body the massage my maternal grandmother Maria gave me when I had breathing crises, following the hallucinations I have had since childhood: seeing animals and people entering the house whom only I could see made it impossible for me to breathe. In my family she was perhaps one of the only people who truly saw me, apart from Aunt Bel. My grandmother worried about where I was. In that context, and in so many others, she would never have called me mad: it was all a spiritual entanglement, a depth of flow that not everyone wants to understand.",
      "One day she took a handful of herbs and macerated them with a powder; there was a basin of hot water and smoke in my cousin's room. The drawing of this tattoo is the movement her hands made.",
      "My grandmother was my curator, my benzedeira, my healer. I have an entire performance in my head in her honour; I only need to wait for the tattoo to be finished, because it is the central point. And thank you, Jun Matsui, for understanding everything from the beginning, even the erotic, profound and grotesque nuances involved in the simple 'where these hands have passed'. When I see black I feel something deep that can be plunged into — the dark part of this story that does not need to be told in words. Everything dances in me, even the psoriasis that appears when the body truly needs to dance. And there was no one else but you, because you followed so many of my self-processes up close, reinventing them through these pains."
    ],
    "cover": lacunaHammockFace.url,
    "images": [
      {
        "src": lacunaTattooChest.url,
        "alt": "A tattoo machine at work on a person's chest and shoulder, gloved hands stretching the skin, lit against deep shadow."
      },
      {
        "src": lacunaTattooHeadlamp.url,
        "alt": "A tattoo artist with a headlamp leans over the work, the client's face and upper chest lit by a focused beam in a dark room."
      },
      {
        "src": lacunaStudioBw.url,
        "alt": "A tattoo studio in black and white: an artist in profile with gloved hands and a tattoo machine, a client's upturned face in the foreground, framed sheets on the wall."
      },
      {
        "src": lacunaDaggerPendant.url,
        "alt": "Close-up of a freckled chest and collarbone with a chain necklace and a small dagger pendant, in grainy black and white."
      },
      {
        "src": lacunaMirrorForearm.url,
        "alt": "A mirror photograph of a person holding a camera, a flowing botanical tattoo covering the forearm, a dagger pendant hanging over a dark top."
      },
      {
        "src": lacunaHammockFace.url,
        "alt": "A face seen through the frayed ropes of a hammock, strong light casting a grid of shadows across the skin."
      }
    ],
    "videos": []
  }
];

export const getProject = (slug: string) => projects.find((p) => p.slug === slug);
